var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 4999.999 5000",
    enableBackground: "new 0 0 4999.999 5000",
    height: 50,
    width: 49,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#4D0B7F",
    cx: 4168.603,
    cy: 4313.016,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#377B79",
    cx: 4168.603,
    cy: 4229.917,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F779F",
    cx: 4168.603,
    cy: 4148.795,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ED4FEB",
    cx: 4168.603,
    cy: 4071.549,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BFBF99",
    cx: 4168.603,
    cy: 3998.053,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C3A9FD",
    cx: 4168.603,
    cy: 3928.107,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5B438D",
    cx: 4168.603,
    cy: 3861.55,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B1D5BB",
    cx: 4168.603,
    cy: 3798.2,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2157BD",
    cx: 4168.603,
    cy: 3737.908,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5FC9C3",
    cx: 4168.603,
    cy: 3680.539,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BBC5CF",
    cx: 4168.603,
    cy: 3625.985,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E1C10B",
    cx: 4168.603,
    cy: 3574.068,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EFE9A1",
    cx: 4168.603,
    cy: 3524.645,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#379753",
    cx: 4168.603,
    cy: 3477.604,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CB2F49",
    cx: 4168.603,
    cy: 3432.838,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F8BFB",
    cx: 4168.603,
    cy: 3390.236,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EB6767",
    cx: 4168.603,
    cy: 3349.696,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CFEBC3",
    cx: 4168.603,
    cy: 3311.123,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0F97B3",
    cx: 4168.603,
    cy: 3274.41,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#29D721",
    cx: 4168.603,
    cy: 3239.455,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2D4721",
    cx: 4168.603,
    cy: 3206.214,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F73DBD",
    cx: 4168.603,
    cy: 3174.584,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#854353",
    cx: 4168.603,
    cy: 3144.479,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8D7DA5",
    cx: 4168.603,
    cy: 3115.837,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDFD87",
    cx: 4168.603,
    cy: 3088.577,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6D2599",
    cx: 4168.603,
    cy: 3062.633,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ADE137",
    cx: 4168.603,
    cy: 3037.96,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ED9777",
    cx: 4168.603,
    cy: 3014.471,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AB97DD",
    cx: 4168.603,
    cy: 2992.11,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#95D93D",
    cx: 4168.603,
    cy: 2970.831,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C3F197",
    cx: 4168.603,
    cy: 2950.589,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#07D167",
    cx: 4168.603,
    cy: 2931.337,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DBCB6B",
    cx: 4168.603,
    cy: 2913.025,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E3EBD7",
    cx: 4168.603,
    cy: 2895.606,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BFD9D7",
    cx: 4168.603,
    cy: 2879.032,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E36533",
    cx: 4168.603,
    cy: 2863.258,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CD75CF",
    cx: 4168.603,
    cy: 2848.241,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#05AF73",
    cx: 4168.603,
    cy: 2833.942,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ED7DD3",
    cx: 4168.603,
    cy: 2820.325,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A98307",
    cx: 4168.603,
    cy: 2807.36,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B93F8B",
    cx: 4168.603,
    cy: 2795.021,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#737DC1",
    cx: 4168.603,
    cy: 2783.291,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2BDBE1",
    cx: 4168.603,
    cy: 2772.157,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AF7D61",
    cx: 4168.603,
    cy: 2761.533,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#757F53",
    cx: 4168.603,
    cy: 2751.409,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6F898D",
    cx: 4168.603,
    cy: 2741.788,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DBFDAD",
    cx: 4168.603,
    cy: 2732.654,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A1D5A1",
    cx: 4168.603,
    cy: 2723.928,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#335D81",
    cx: 4168.603,
    cy: 2715.632,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0BC5D1",
    cx: 4168.603,
    cy: 2707.76,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#953D8F",
    cx: 4168.603,
    cy: 2700.148,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EB79D9",
    cx: 4168.603,
    cy: 2692.58,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C37787",
    cx: 4168.603,
    cy: 2685.013,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CB63F1",
    cx: 4168.603,
    cy: 2677.455,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AB55EF",
    cx: 4168.603,
    cy: 2669.885,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#233BC9",
    cx: 4168.603,
    cy: 2662.323,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E5F17D",
    cx: 4168.603,
    cy: 2654.754,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#558F53",
    cx: 4168.603,
    cy: 2647.192,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EFE99F",
    cx: 4168.603,
    cy: 2639.621,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E38F7F",
    cx: 4168.603,
    cy: 2632.061,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#598F41",
    cx: 4168.603,
    cy: 2624.496,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3301B3",
    cx: 4168.603,
    cy: 2616.926,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E53557",
    cx: 4168.603,
    cy: 2609.354,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#01551B",
    cx: 4168.603,
    cy: 2601.783,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B767A5",
    cx: 4168.603,
    cy: 2594.218,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#61CD33",
    cx: 4168.603,
    cy: 2586.648,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3F00E3",
    cx: 4168.603,
    cy: 2579.09,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3131C3",
    cx: 4168.603,
    cy: 2571.518,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B3C515",
    cx: 4168.603,
    cy: 2563.945,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9FF90D",
    cx: 4168.603,
    cy: 2557.008,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D32325",
    cx: 4021.211,
    cy: 4438.344,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EB0BB5",
    cx: 4027.731,
    cy: 4355.5,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AB955F",
    cx: 4034.095,
    cy: 4274.629,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4F01A3",
    cx: 4040.156,
    cy: 4197.621,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CF9725",
    cx: 4045.923,
    cy: 4124.352,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ABAF9F",
    cx: 4051.41,
    cy: 4054.622,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BF77D9",
    cx: 4056.633,
    cy: 3988.269,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F9FD23",
    cx: 4061.603,
    cy: 3925.115,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8D8BFB",
    cx: 4066.333,
    cy: 3865.009,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#87E149",
    cx: 4070.834,
    cy: 3807.817,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BD6385",
    cx: 4075.115,
    cy: 3753.431,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A1F9AB",
    cx: 4079.188,
    cy: 3701.673,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79737B",
    cx: 4083.066,
    cy: 3652.403,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#65335B",
    cx: 4086.757,
    cy: 3605.507,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F96B1F",
    cx: 4090.269,
    cy: 3560.879,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B74B99",
    cx: 4093.611,
    cy: 3518.409,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EBB331",
    cx: 4096.792,
    cy: 3477.993,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#95FF2B",
    cx: 4099.818,
    cy: 3439.539,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E55723",
    cx: 4102.699,
    cy: 3402.94,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#657DF3",
    cx: 4105.441,
    cy: 3368.092,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CB736B",
    cx: 4108.05,
    cy: 3334.953,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BDEF6F",
    cx: 4110.531,
    cy: 3303.421,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E9D365",
    cx: 4112.893,
    cy: 3273.409,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A10D41",
    cx: 4115.141,
    cy: 3244.855,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BF9DF9",
    cx: 4117.279,
    cy: 3217.68,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8D0165",
    cx: 4119.315,
    cy: 3191.815,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4FBF63",
    cx: 4121.25,
    cy: 3167.219,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#871BFF",
    cx: 4123.094,
    cy: 3143.802,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B7FFB9",
    cx: 4124.848,
    cy: 3121.51,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#89ED31",
    cx: 4126.518,
    cy: 3100.296,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9B45E5",
    cx: 4128.105,
    cy: 3080.117,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C93F67",
    cx: 4129.616,
    cy: 3060.924,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#072D51",
    cx: 4131.053,
    cy: 3042.668,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C54FCD",
    cx: 4132.419,
    cy: 3025.303,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EF2FD1",
    cx: 4133.72,
    cy: 3008.78,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3737D5",
    cx: 4134.958,
    cy: 2993.055,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F92913",
    cx: 4136.136,
    cy: 2978.084,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#555FE5",
    cx: 4137.258,
    cy: 2963.829,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C7391D",
    cx: 4138.326,
    cy: 2950.254,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#235131",
    cx: 4139.343,
    cy: 2937.329,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B8D49",
    cx: 4140.312,
    cy: 2925.029,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ADD179",
    cx: 4141.232,
    cy: 2913.334,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#654F99",
    cx: 4142.105,
    cy: 2902.235,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CD01A1",
    cx: 4142.939,
    cy: 2891.644,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E18707",
    cx: 4143.733,
    cy: 2881.551,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E9311B",
    cx: 4144.488,
    cy: 2871.959,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E1F5FD",
    cx: 4145.205,
    cy: 2862.854,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#910D4D",
    cx: 4145.889,
    cy: 2854.155,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F1239F",
    cx: 4146.54,
    cy: 2845.884,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BDA9DF",
    cx: 4147.158,
    cy: 2838.037,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#39D58F",
    cx: 4147.755,
    cy: 2830.448,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1583EB",
    cx: 4148.349,
    cy: 2822.903,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#11313F",
    cx: 4148.942,
    cy: 2815.359,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CFEFF1",
    cx: 4149.536,
    cy: 2807.824,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3D71BD",
    cx: 4150.129,
    cy: 2800.278,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#118700",
    cx: 4150.723,
    cy: 2792.739,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#75DD6B",
    cx: 4151.316,
    cy: 2785.194,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#835F7F",
    cx: 4151.91,
    cy: 2777.655,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B33561",
    cx: 4152.504,
    cy: 2770.108,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D187A7",
    cx: 4153.097,
    cy: 2762.57,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FD196B",
    cx: 4153.69,
    cy: 2755.029,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#17B717",
    cx: 4154.285,
    cy: 2747.482,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#41A335",
    cx: 4154.878,
    cy: 2739.934,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0D891B",
    cx: 4155.473,
    cy: 2732.386,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DB6F3B",
    cx: 4156.066,
    cy: 2724.844,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#994119",
    cx: 4156.66,
    cy: 2717.298,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BF9701",
    cx: 4157.253,
    cy: 2709.762,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B965C3",
    cx: 4157.847,
    cy: 2702.215,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDDF3D",
    cx: 4158.441,
    cy: 2694.664,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#851337",
    cx: 4158.986,
    cy: 2687.749,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#639703",
    cx: 3864.441,
    cy: 4551.72,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1109FD",
    cx: 3877.441,
    cy: 4469.644,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3BC109",
    cx: 3890.131,
    cy: 4389.521,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AB7B09",
    cx: 3902.215,
    cy: 4313.226,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#914D09",
    cx: 3913.712,
    cy: 4240.636,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#65517D",
    cx: 3924.654,
    cy: 4171.551,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4FFD15",
    cx: 3935.066,
    cy: 4105.813,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#25C52B",
    cx: 3944.976,
    cy: 4043.243,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#29CDB9",
    cx: 3954.408,
    cy: 3983.693,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3529A7",
    cx: 3963.382,
    cy: 3927.031,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EF2FBD",
    cx: 3971.916,
    cy: 3873.148,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8B3D53",
    cx: 3980.038,
    cy: 3821.87,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#31837D",
    cx: 3987.769,
    cy: 3773.056,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F1E1B3",
    cx: 3995.128,
    cy: 3726.594,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#01BD3B",
    cx: 4002.131,
    cy: 3682.379,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#298763",
    cx: 4008.795,
    cy: 3640.302,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D96BAD",
    cx: 4015.137,
    cy: 3600.26,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#41BB75",
    cx: 4021.172,
    cy: 3562.162,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#55BDBF",
    cx: 4026.915,
    cy: 3525.902,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BD095F",
    cx: 4032.383,
    cy: 3491.377,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6B7BD9",
    cx: 4037.583,
    cy: 3458.545,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2DA591",
    cx: 4042.531,
    cy: 3427.304,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#89B759",
    cx: 4047.24,
    cy: 3397.57,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C5B70B",
    cx: 4051.721,
    cy: 3369.281,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FF4B0D",
    cx: 4055.985,
    cy: 3342.357,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FBDD3F",
    cx: 4060.044,
    cy: 3316.731,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2DB9CF",
    cx: 4063.904,
    cy: 3292.363,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#992DC9",
    cx: 4067.578,
    cy: 3269.163,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8F2903",
    cx: 4071.076,
    cy: 3247.077,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7A1C1",
    cx: 4074.405,
    cy: 3226.06,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#83394D",
    cx: 4077.572,
    cy: 3206.067,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#15535F",
    cx: 4080.583,
    cy: 3187.052,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#93AB77",
    cx: 4083.448,
    cy: 3168.966,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8F53EB",
    cx: 4086.173,
    cy: 3151.761,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E37FD3",
    cx: 4088.766,
    cy: 3135.391,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A7A3D1",
    cx: 4091.233,
    cy: 3119.811,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7F4153",
    cx: 4093.582,
    cy: 3104.979,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BD634F",
    cx: 4095.819,
    cy: 3090.856,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#65EBC1",
    cx: 4097.949,
    cy: 3077.407,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#778B6B",
    cx: 4099.978,
    cy: 3064.602,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#33D9FB",
    cx: 4101.908,
    cy: 3052.415,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#89693D",
    cx: 4103.743,
    cy: 3040.829,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EDB1FF",
    cx: 4105.484,
    cy: 3029.832,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#71CD9B",
    cx: 4107.146,
    cy: 3019.339,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CFA771",
    cx: 4108.73,
    cy: 3009.34,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#09D735",
    cx: 4110.235,
    cy: 2999.836,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A1A11D",
    cx: 4111.664,
    cy: 2990.815,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5BB307",
    cx: 4113.029,
    cy: 2982.197,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D9E11D",
    cx: 4114.327,
    cy: 2974.002,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A14D77",
    cx: 4115.558,
    cy: 2966.228,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0B63E9",
    cx: 4116.749,
    cy: 2958.709,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#13AFD3",
    cx: 4117.933,
    cy: 2951.235,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7F1FEF",
    cx: 4119.117,
    cy: 2943.761,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A33B25",
    cx: 4120.299,
    cy: 2936.296,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6B7D0D",
    cx: 4121.483,
    cy: 2928.82,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#05B359",
    cx: 4122.666,
    cy: 2921.35,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2DC737",
    cx: 4123.85,
    cy: 2913.875,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#774511",
    cx: 4125.033,
    cy: 2906.405,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C947F3",
    cx: 4126.217,
    cy: 2898.928,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#050573",
    cx: 4127.4,
    cy: 2891.46,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5B0DE3",
    cx: 4128.583,
    cy: 2883.989,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5D3B45",
    cx: 4129.768,
    cy: 2876.512,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6F1DCB",
    cx: 4130.952,
    cy: 2869.033,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CF5705",
    cx: 4132.137,
    cy: 2861.555,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C581A3",
    cx: 4133.32,
    cy: 2854.084,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#31C583",
    cx: 4134.504,
    cy: 2846.607,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#91B597",
    cx: 4135.687,
    cy: 2839.142,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#732FC5",
    cx: 4136.871,
    cy: 2831.664,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#41692D",
    cx: 4138.056,
    cy: 2824.183,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C5B17F",
    cx: 4139.141,
    cy: 2817.332,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CFAFD7",
    cx: 3699.259,
    cy: 4652.45,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F79D8D",
    cx: 3718.658,
    cy: 4571.646,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#57D953",
    cx: 3737.595,
    cy: 4492.766,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#312559",
    cx: 3755.628,
    cy: 4417.654,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#336FC3",
    cx: 3772.785,
    cy: 4346.19,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#19FD1B",
    cx: 3789.114,
    cy: 4278.176,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#47B555",
    cx: 3804.651,
    cy: 4213.458,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CDC565",
    cx: 3819.44,
    cy: 4151.858,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7DB77D",
    cx: 3833.515,
    cy: 4093.232,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#17BB33",
    cx: 3846.907,
    cy: 4037.449,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6993F3",
    cx: 3859.643,
    cy: 3984.402,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#73A75F",
    cx: 3871.763,
    cy: 3933.919,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C3EF2D",
    cx: 3883.3,
    cy: 3885.862,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A3F389",
    cx: 3894.281,
    cy: 3840.12,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#97D98B",
    cx: 3904.732,
    cy: 3796.591,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9593CB",
    cx: 3914.677,
    cy: 3755.167,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3941B7",
    cx: 3924.141,
    cy: 3715.746,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5DB781",
    cx: 3933.146,
    cy: 3678.239,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DF9FE5",
    cx: 3941.716,
    cy: 3642.541,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9147C3",
    cx: 3949.876,
    cy: 3608.552,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A1756F",
    cx: 3957.636,
    cy: 3576.229,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B335AD",
    cx: 3965.02,
    cy: 3545.473,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#09F3C9",
    cx: 3972.048,
    cy: 3516.199,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C38547",
    cx: 3978.734,
    cy: 3488.349,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#533D53",
    cx: 3985.098,
    cy: 3461.843,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AF998F",
    cx: 3991.155,
    cy: 3436.615,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D91B9F",
    cx: 3996.914,
    cy: 3412.624,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F5DB61",
    cx: 4002.398,
    cy: 3389.784,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6995C7",
    cx: 4007.618,
    cy: 3368.04,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1F8B55",
    cx: 4012.585,
    cy: 3347.35,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A5537D",
    cx: 4017.311,
    cy: 3327.667,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#294F89",
    cx: 4021.805,
    cy: 3308.947,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CDCD5D",
    cx: 4026.08,
    cy: 3291.141,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FD6F87",
    cx: 4030.146,
    cy: 3274.203,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1157B1",
    cx: 4034.016,
    cy: 3258.087,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B7B81",
    cx: 4037.698,
    cy: 3242.749,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#896D8B",
    cx: 4041.203,
    cy: 3228.147,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ADE5C1",
    cx: 4044.542,
    cy: 3214.243,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BF53B9",
    cx: 4047.72,
    cy: 3201.002,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#473375",
    cx: 4050.747,
    cy: 3188.395,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#472B73",
    cx: 4053.627,
    cy: 3176.397,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#594983",
    cx: 4056.366,
    cy: 3164.991,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2FD5E3",
    cx: 4058.965,
    cy: 3154.165,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F54127",
    cx: 4061.445,
    cy: 3143.835,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E74761",
    cx: 4063.808,
    cy: 3133.99,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8F9925",
    cx: 4066.054,
    cy: 3124.635,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5D656D",
    cx: 4068.187,
    cy: 3115.753,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#51D713",
    cx: 4070.224,
    cy: 3107.269,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C7F9BF",
    cx: 4072.161,
    cy: 3099.201,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C53735",
    cx: 4073.998,
    cy: 3091.548,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CDBBB1",
    cx: 4075.775,
    cy: 3084.146,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#916B43",
    cx: 4077.542,
    cy: 3076.786,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A10973",
    cx: 4079.308,
    cy: 3069.428,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#159DEB",
    cx: 4081.073,
    cy: 3062.079,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BDE135",
    cx: 4082.84,
    cy: 3054.719,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#033D00",
    cx: 4084.605,
    cy: 3047.365,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#832101",
    cx: 4086.372,
    cy: 3040.006,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9351D7",
    cx: 4088.137,
    cy: 3032.652,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#857B27",
    cx: 4089.905,
    cy: 3025.291,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F389E1",
    cx: 4091.67,
    cy: 3017.939,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4FA70F",
    cx: 4093.436,
    cy: 3010.583,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#15A589",
    cx: 4095.203,
    cy: 3003.222,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#737D37",
    cx: 4096.971,
    cy: 2995.86,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1D2765",
    cx: 4098.738,
    cy: 2988.498,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C56183",
    cx: 4100.504,
    cy: 2981.143,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7F83C1",
    cx: 4102.271,
    cy: 2973.782,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#51590B",
    cx: 4104.036,
    cy: 2966.432,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#93F95B",
    cx: 4105.803,
    cy: 2959.07,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6B4D07",
    cx: 4107.571,
    cy: 2951.706,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AD0069",
    cx: 4109.19,
    cy: 2944.961,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#636BA3",
    cx: 3526.682,
    cy: 4739.907,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DF17FB",
    cx: 3552.362,
    cy: 4660.875,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9745E7",
    cx: 3577.43,
    cy: 4583.723,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BB913D",
    cx: 3601.3,
    cy: 4510.258,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D3177B",
    cx: 3624.011,
    cy: 4440.36,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3F6F81",
    cx: 3645.626,
    cy: 4373.837,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B5A97F",
    cx: 3666.193,
    cy: 4310.537,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D7CB63",
    cx: 3685.769,
    cy: 4250.288,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8B7F11",
    cx: 3704.401,
    cy: 4192.946,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#817DED",
    cx: 3722.128,
    cy: 4138.386,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3D27C5",
    cx: 3738.987,
    cy: 4086.502,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0BAD55",
    cx: 3755.03,
    cy: 4037.125,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#45BDE7",
    cx: 3770.302,
    cy: 3990.122,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C73B65",
    cx: 3784.839,
    cy: 3945.383,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A5BB2D",
    cx: 3798.672,
    cy: 3902.808,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C90BC3",
    cx: 3811.837,
    cy: 3862.291,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#053903",
    cx: 3824.365,
    cy: 3823.735,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#19857D",
    cx: 3836.284,
    cy: 3787.05,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4533E3",
    cx: 3847.629,
    cy: 3752.134,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B8F75",
    cx: 3858.431,
    cy: 3718.89,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B1C327",
    cx: 3868.703,
    cy: 3687.275,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#971DAF",
    cx: 3878.477,
    cy: 3657.194,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EB8D53",
    cx: 3887.78,
    cy: 3628.562,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3DC741",
    cx: 3896.631,
    cy: 3601.322,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#352137",
    cx: 3905.055,
    cy: 3575.396,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#435BA9",
    cx: 3913.072,
    cy: 3550.721,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#896763",
    cx: 3920.696,
    cy: 3527.257,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#45C5CF",
    cx: 3927.955,
    cy: 3504.917,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D7CB9F",
    cx: 3934.865,
    cy: 3483.65,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#63FDD3",
    cx: 3941.44,
    cy: 3463.413,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FDB3C5",
    cx: 3947.696,
    cy: 3444.162,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CB2707",
    cx: 3953.645,
    cy: 3425.852,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5977AF",
    cx: 3959.303,
    cy: 3408.436,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6F5F93",
    cx: 3964.686,
    cy: 3391.87,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1D8B7D",
    cx: 3969.808,
    cy: 3376.107,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#515DDB",
    cx: 3974.682,
    cy: 3361.105,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FD29FB",
    cx: 3979.323,
    cy: 3346.823,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#15F119",
    cx: 3983.741,
    cy: 3333.224,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4BDF15",
    cx: 3987.949,
    cy: 3320.273,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A5E351",
    cx: 3991.956,
    cy: 3307.943,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#89E177",
    cx: 3995.769,
    cy: 3296.208,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E3F3C3",
    cx: 3999.394,
    cy: 3285.052,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2D3FBB",
    cx: 4002.834,
    cy: 3274.463,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F76F7F",
    cx: 4006.117,
    cy: 3264.359,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#13EB65",
    cx: 4009.245,
    cy: 3254.73,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#17C125",
    cx: 4012.219,
    cy: 3245.58,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1F97B7",
    cx: 4015.041,
    cy: 3236.893,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#77B7BF",
    cx: 4017.738,
    cy: 3228.594,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D75787",
    cx: 4020.302,
    cy: 3220.704,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#57C7AB",
    cx: 4022.734,
    cy: 3213.218,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F9ED1B",
    cx: 4025.086,
    cy: 3205.978,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#096700",
    cx: 4027.425,
    cy: 3198.78,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FB1D61",
    cx: 4029.763,
    cy: 3191.584,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3F5B6B",
    cx: 4032.099,
    cy: 3184.396,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#39D3AB",
    cx: 4034.438,
    cy: 3177.197,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#83A5C7",
    cx: 4036.775,
    cy: 3170.004,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B9BB99",
    cx: 4039.114,
    cy: 3162.806,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E1770F",
    cx: 4041.45,
    cy: 3155.614,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CD2D2B",
    cx: 4043.79,
    cy: 3148.414,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D1DF0B",
    cx: 4046.126,
    cy: 3141.223,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D72BD7",
    cx: 4048.464,
    cy: 3134.029,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A5137D",
    cx: 4050.803,
    cy: 3126.829,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#753D1F",
    cx: 4053.143,
    cy: 3119.628,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#87057D",
    cx: 4055.483,
    cy: 3112.427,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#355BA7",
    cx: 4057.82,
    cy: 3105.233,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#890F2D",
    cx: 4060.159,
    cy: 3098.034,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8107CB",
    cx: 4062.495,
    cy: 3090.845,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#715F3D",
    cx: 4064.835,
    cy: 3083.644,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A5A783",
    cx: 4067.175,
    cy: 3076.441,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1DCB55",
    cx: 4069.319,
    cy: 3069.844,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ADAFF7",
    cx: 3347.776,
    cy: 4813.554,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DFFB6B",
    cx: 3379.577,
    cy: 4736.78,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#433747",
    cx: 3410.621,
    cy: 4661.833,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AF153B",
    cx: 3440.182,
    cy: 4590.467,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CF3D0F",
    cx: 3468.307,
    cy: 4522.567,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#935947",
    cx: 3495.074,
    cy: 4457.945,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6D4FAF",
    cx: 3520.545,
    cy: 4396.454,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#31FB63",
    cx: 3544.788,
    cy: 4337.926,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8995D7",
    cx: 3567.861,
    cy: 4282.224,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B0FCB",
    cx: 3589.815,
    cy: 4229.222,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#839153",
    cx: 3610.692,
    cy: 4178.821,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D77F21",
    cx: 3630.56,
    cy: 4130.855,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#17B3BB",
    cx: 3649.473,
    cy: 4085.195,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#87E50F",
    cx: 3667.475,
    cy: 4041.734,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D1E79D",
    cx: 3684.606,
    cy: 4000.376,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AF4B7D",
    cx: 3700.909,
    cy: 3961.017,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#192B33",
    cx: 3716.423,
    cy: 3923.563,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FB6529",
    cx: 3731.184,
    cy: 3887.926,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#511151",
    cx: 3745.234,
    cy: 3854.008,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4F01D1",
    cx: 3758.61,
    cy: 3821.713,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5361C3",
    cx: 3771.331,
    cy: 3791.002,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#11A9D9",
    cx: 3783.435,
    cy: 3761.78,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#53C345",
    cx: 3794.956,
    cy: 3733.967,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5DA5FB",
    cx: 3805.917,
    cy: 3707.505,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#676F6F",
    cx: 3816.349,
    cy: 3682.321,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B91537",
    cx: 3826.277,
    cy: 3658.35,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A3B593",
    cx: 3835.719,
    cy: 3635.556,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A593AD",
    cx: 3844.708,
    cy: 3613.855,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#977B0D",
    cx: 3853.265,
    cy: 3593.196,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#65E5A9",
    cx: 3861.408,
    cy: 3573.537,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8B63F9",
    cx: 3869.155,
    cy: 3554.836,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#01799F",
    cx: 3876.522,
    cy: 3537.049,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8B63BF",
    cx: 3883.53,
    cy: 3520.131,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8F05F9",
    cx: 3890.196,
    cy: 3504.038,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B73913",
    cx: 3896.538,
    cy: 3488.725,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4597AB",
    cx: 3902.575,
    cy: 3474.152,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#05E95B",
    cx: 3908.321,
    cy: 3460.279,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7B7FB9",
    cx: 3913.793,
    cy: 3447.068,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6F750F",
    cx: 3919.004,
    cy: 3434.488,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4FFB89",
    cx: 3923.966,
    cy: 3422.509,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#514F99",
    cx: 3928.688,
    cy: 3411.11,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DD3B33",
    cx: 3933.177,
    cy: 3400.272,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5987A7",
    cx: 3937.438,
    cy: 3389.986,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2DDB87",
    cx: 3941.503,
    cy: 3380.171,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#31411F",
    cx: 3945.377,
    cy: 3370.818,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6B11C3",
    cx: 3949.06,
    cy: 3361.928,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8923F7",
    cx: 3952.555,
    cy: 3353.49,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#714DA5",
    cx: 3955.894,
    cy: 3345.428,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F38101",
    cx: 3959.069,
    cy: 3337.763,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B0F85",
    cx: 3962.081,
    cy: 3330.491,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0529F7",
    cx: 3964.994,
    cy: 3323.458,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#537F1B",
    cx: 3967.89,
    cy: 3316.466,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CDC3ED",
    cx: 3970.786,
    cy: 3309.475,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#39B35B",
    cx: 3973.678,
    cy: 3302.493,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A95B6F",
    cx: 3976.575,
    cy: 3295.5,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9DCF23",
    cx: 3979.469,
    cy: 3288.513,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#134B77",
    cx: 3982.365,
    cy: 3281.52,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#373365",
    cx: 3985.26,
    cy: 3274.533,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#47B7F7",
    cx: 3988.157,
    cy: 3267.539,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7F357",
    cx: 3991.05,
    cy: 3260.554,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7B255B",
    cx: 3993.945,
    cy: 3253.565,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5FB101",
    cx: 3996.842,
    cy: 3246.571,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C3ED49",
    cx: 3999.74,
    cy: 3239.576,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1DA95F",
    cx: 4002.637,
    cy: 3232.581,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#57BB57",
    cx: 4005.532,
    cy: 3225.592,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BD891D",
    cx: 4008.428,
    cy: 3218.599,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#413FD3",
    cx: 4011.321,
    cy: 3211.615,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#21750F",
    cx: 4014.219,
    cy: 3204.62,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#253D67",
    cx: 4017.117,
    cy: 3197.623,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B383E9",
    cx: 4019.771,
    cy: 3191.215,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9B6D9D",
    cx: 3163.644,
    cy: 4872.938,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BBC701",
    cx: 3201.37,
    cy: 4798.896,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#57DD21",
    cx: 3238.199,
    cy: 4726.616,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1723AB",
    cx: 3273.268,
    cy: 4657.79,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E56D8D",
    cx: 3306.634,
    cy: 4592.305,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BF2B0B",
    cx: 3338.389,
    cy: 4529.982,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#85C99F",
    cx: 3368.605,
    cy: 4470.679,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DB2B1F",
    cx: 3397.365,
    cy: 4414.234,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#45C57B",
    cx: 3424.738,
    cy: 4360.514,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8321A3",
    cx: 3450.782,
    cy: 4309.398,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#97D5D5",
    cx: 3475.549,
    cy: 4260.79,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A1BD53",
    cx: 3499.119,
    cy: 4214.531,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EB05D5",
    cx: 3521.557,
    cy: 4170.495,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F1853F",
    cx: 3542.913,
    cy: 4128.581,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#273701",
    cx: 3563.236,
    cy: 4088.694,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D97FD5",
    cx: 3582.577,
    cy: 4050.736,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D37FA3",
    cx: 3600.982,
    cy: 4014.614,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C12BB7",
    cx: 3618.494,
    cy: 3980.245,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#718745",
    cx: 3635.161,
    cy: 3947.534,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#25A5F1",
    cx: 3651.03,
    cy: 3916.389,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79633D",
    cx: 3666.122,
    cy: 3886.771,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#45E591",
    cx: 3680.481,
    cy: 3858.588,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9BD3D1",
    cx: 3694.149,
    cy: 3831.764,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C3712B",
    cx: 3707.152,
    cy: 3806.244,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#15BB59",
    cx: 3719.527,
    cy: 3781.956,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0D41FD",
    cx: 3731.306,
    cy: 3758.839,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5B55D9",
    cx: 3742.507,
    cy: 3736.856,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2FF193",
    cx: 3753.171,
    cy: 3715.927,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2B2173",
    cx: 3763.323,
    cy: 3696.003,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F3C389",
    cx: 3772.983,
    cy: 3677.043,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7BC3C3",
    cx: 3782.173,
    cy: 3659.008,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F9C5B3",
    cx: 3790.913,
    cy: 3641.853,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#695571",
    cx: 3799.226,
    cy: 3625.538,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#83192B",
    cx: 3807.135,
    cy: 3610.017,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CFEBD9",
    cx: 3814.659,
    cy: 3595.249,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#612D31",
    cx: 3821.82,
    cy: 3581.195,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EB451D",
    cx: 3828.638,
    cy: 3567.815,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3BF12B",
    cx: 3835.129,
    cy: 3555.074,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#932311",
    cx: 3841.311,
    cy: 3542.941,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FDED4F",
    cx: 3847.197,
    cy: 3531.389,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9B4F5F",
    cx: 3852.799,
    cy: 3520.396,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4941EF",
    cx: 3858.125,
    cy: 3509.944,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#77E3C9",
    cx: 3863.179,
    cy: 3500.023,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#91454D",
    cx: 3868.002,
    cy: 3490.557,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#31932D",
    cx: 3872.598,
    cy: 3481.537,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4B7DFD",
    cx: 3876.967,
    cy: 3472.964,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#77F177",
    cx: 3881.113,
    cy: 3464.826,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F743D3",
    cx: 3885.074,
    cy: 3457.051,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#87A79D",
    cx: 3888.841,
    cy: 3449.659,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#151129",
    cx: 3892.415,
    cy: 3442.646,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4F1D41",
    cx: 3895.871,
    cy: 3435.863,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7B17FB",
    cx: 3899.306,
    cy: 3429.119,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#919DD5",
    cx: 3902.742,
    cy: 3422.377,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6359C1",
    cx: 3906.173,
    cy: 3415.643,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#378785",
    cx: 3909.61,
    cy: 3408.898,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#31033D",
    cx: 3913.043,
    cy: 3402.16,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4399EF",
    cx: 3916.479,
    cy: 3395.417,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#534D21",
    cx: 3919.912,
    cy: 3388.678,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FBA3A3",
    cx: 3923.349,
    cy: 3381.933,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EB1B09",
    cx: 3926.781,
    cy: 3375.197,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ADDBD5",
    cx: 3930.216,
    cy: 3368.456,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D123B1",
    cx: 3933.653,
    cy: 3361.711,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D77F1",
    cx: 3937.09,
    cy: 3354.965,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D32B7F",
    cx: 3940.527,
    cy: 3348.219,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0DC75B",
    cx: 3943.962,
    cy: 3341.479,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#172177",
    cx: 3947.398,
    cy: 3334.734,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#85B127",
    cx: 3950.83,
    cy: 3327.999,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8FE15D",
    cx: 3954.267,
    cy: 3321.253,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#61F593",
    cx: 3957.706,
    cy: 3314.505,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F547B7",
    cx: 3960.854,
    cy: 3308.324,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5171B1",
    cx: 2975.419,
    cy: 4917.692,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#011D9B",
    cx: 3018.839,
    cy: 4846.838,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#339F63",
    cx: 3061.225,
    cy: 4777.67,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AFDB85",
    cx: 3101.585,
    cy: 4711.808,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3DB309",
    cx: 3139.987,
    cy: 4649.143,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A50100",
    cx: 3176.533,
    cy: 4589.503,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B78517",
    cx: 3211.31,
    cy: 4532.754,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BFF137",
    cx: 3244.41,
    cy: 4478.74,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4F13A3",
    cx: 3275.912,
    cy: 4427.332,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#437B05",
    cx: 3305.887,
    cy: 4378.417,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#173B47",
    cx: 3334.392,
    cy: 4331.902,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FBA9C7",
    cx: 3361.519,
    cy: 4287.635,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#23BBF5",
    cx: 3387.342,
    cy: 4245.496,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F16733",
    cx: 3411.921,
    cy: 4205.386,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#19011D",
    cx: 3435.311,
    cy: 4167.217,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D1D755",
    cx: 3457.57,
    cy: 4130.894,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AD398F",
    cx: 3478.752,
    cy: 4096.327,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F3999B",
    cx: 3498.907,
    cy: 4063.438,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DBE357",
    cx: 3518.089,
    cy: 4032.135,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CF236F",
    cx: 3536.353,
    cy: 4002.331,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1BCBF9",
    cx: 3553.722,
    cy: 3973.988,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1F3B21",
    cx: 3570.248,
    cy: 3947.02,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8B151B",
    cx: 3585.978,
    cy: 3921.35,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AFB9DF",
    cx: 3600.943,
    cy: 3896.929,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9771C1",
    cx: 3615.187,
    cy: 3873.687,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2521B1",
    cx: 3628.743,
    cy: 3851.565,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A3F14B",
    cx: 3641.634,
    cy: 3830.529,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B73B49",
    cx: 3653.907,
    cy: 3810.501,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#018337",
    cx: 3665.591,
    cy: 3791.435,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3FCB89",
    cx: 3676.709,
    cy: 3773.292,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#157995",
    cx: 3687.285,
    cy: 3756.032,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B94B2D",
    cx: 3697.345,
    cy: 3739.617,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#158193",
    cx: 3706.912,
    cy: 3724.004,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FDC5F5",
    cx: 3716.014,
    cy: 3709.152,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CB61A9",
    cx: 3724.674,
    cy: 3695.02,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#89BD67",
    cx: 3732.916,
    cy: 3681.57,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6DB737",
    cx: 3740.762,
    cy: 3668.767,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C19B03",
    cx: 3748.233,
    cy: 3656.574,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#03B147",
    cx: 3755.348,
    cy: 3644.964,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#41B501",
    cx: 3762.122,
    cy: 3633.909,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F32165",
    cx: 3768.569,
    cy: 3623.389,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4F35D3",
    cx: 3774.698,
    cy: 3613.387,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CFCF73",
    cx: 3780.516,
    cy: 3603.894,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3775D5",
    cx: 3786.067,
    cy: 3594.836,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8B0BBD",
    cx: 3791.356,
    cy: 3586.204,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#15A319",
    cx: 3796.384,
    cy: 3578,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2D9781",
    cx: 3801.156,
    cy: 3570.212,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7901AF",
    cx: 3805.715,
    cy: 3562.772,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#57E109",
    cx: 3810.05,
    cy: 3555.698,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#81294D",
    cx: 3814.163,
    cy: 3548.987,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#191B17",
    cx: 3818.14,
    cy: 3542.496,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AD0B13",
    cx: 3822.095,
    cy: 3536.043,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#95EFC7",
    cx: 3826.049,
    cy: 3529.591,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EF0D1F",
    cx: 3829.998,
    cy: 3523.147,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CDB775",
    cx: 3833.953,
    cy: 3516.693,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#478B6B",
    cx: 3837.904,
    cy: 3510.245,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9D1DBD",
    cx: 3841.858,
    cy: 3503.792,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BDDB49",
    cx: 3845.81,
    cy: 3497.344,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#033183",
    cx: 3849.765,
    cy: 3490.889,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7B83F3",
    cx: 3853.716,
    cy: 3484.442,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BD53F1",
    cx: 3857.668,
    cy: 3477.992,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0B6FEF",
    cx: 3861.624,
    cy: 3471.537,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#35C751",
    cx: 3865.58,
    cy: 3465.082,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FB6DD7",
    cx: 3869.536,
    cy: 3458.626,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B017B",
    cx: 3873.489,
    cy: 3452.176,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CF7F9D",
    cx: 3877.444,
    cy: 3445.722,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#27B35D",
    cx: 3881.393,
    cy: 3439.277,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#55EDE1",
    cx: 3885.349,
    cy: 3432.822,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B53A5",
    cx: 3889.306,
    cy: 3426.364,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0F13ED",
    cx: 3892.931,
    cy: 3420.45,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A52FD3",
    cx: 2784.264,
    cy: 4947.54,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5DF9F3",
    cx: 2833.109,
    cy: 4880.311,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#518317",
    cx: 2880.791,
    cy: 4814.682,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#295F57",
    cx: 2926.195,
    cy: 4752.189,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D33BC5",
    cx: 2969.394,
    cy: 4692.73,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#571917",
    cx: 3010.508,
    cy: 4636.142,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#95C981",
    cx: 3049.629,
    cy: 4582.296,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BDAD4D",
    cx: 3086.865,
    cy: 4531.045,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5567E1",
    cx: 3122.304,
    cy: 4482.268,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#21ABC5",
    cx: 3156.024,
    cy: 4435.855,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#738907",
    cx: 3188.091,
    cy: 4391.721,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4B4519",
    cx: 3218.607,
    cy: 4349.718,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1D3737",
    cx: 3247.657,
    cy: 4309.735,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F51D35",
    cx: 3275.307,
    cy: 4271.677,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#19C11F",
    cx: 3301.62,
    cy: 4235.461,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#833367",
    cx: 3326.66,
    cy: 4200.996,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9DE753",
    cx: 3350.49,
    cy: 4168.198,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#71CFD3",
    cx: 3373.162,
    cy: 4136.991,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#73758B",
    cx: 3394.741,
    cy: 4107.29,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#35550D",
    cx: 3415.287,
    cy: 4079.011,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D38D5F",
    cx: 3434.826,
    cy: 4052.118,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A53D25",
    cx: 3453.418,
    cy: 4026.529,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#05418B",
    cx: 3471.113,
    cy: 4002.173,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4757C5",
    cx: 3487.948,
    cy: 3979.002,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1D27D1",
    cx: 3503.971,
    cy: 3956.948,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0B953F",
    cx: 3519.221,
    cy: 3935.958,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E9E7B1",
    cx: 3533.723,
    cy: 3915.998,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4DC50D",
    cx: 3547.53,
    cy: 3896.995,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#01199D",
    cx: 3560.673,
    cy: 3878.904,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#11F1F9",
    cx: 3573.181,
    cy: 3861.689,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7DE741",
    cx: 3585.078,
    cy: 3845.313,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4BF1A7",
    cx: 3596.395,
    cy: 3829.738,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#271183",
    cx: 3607.158,
    cy: 3814.923,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C39B57",
    cx: 3617.397,
    cy: 3800.831,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#350F45",
    cx: 3627.139,
    cy: 3787.422,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8173E7",
    cx: 3636.41,
    cy: 3774.661,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9B97B3",
    cx: 3645.237,
    cy: 3762.512,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D1F63",
    cx: 3653.642,
    cy: 3750.944,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1911D3",
    cx: 3661.646,
    cy: 3739.928,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3DCD69",
    cx: 3669.267,
    cy: 3729.438,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CB8733",
    cx: 3676.519,
    cy: 3719.457,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#055BA3",
    cx: 3683.414,
    cy: 3709.966,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A3F15B",
    cx: 3689.958,
    cy: 3700.959,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2F6D5D",
    cx: 3696.203,
    cy: 3692.364,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6DCF9D",
    cx: 3702.154,
    cy: 3684.174,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2F213D",
    cx: 3707.809,
    cy: 3676.389,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4DC9A5",
    cx: 3713.177,
    cy: 3669,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#05519D",
    cx: 3718.306,
    cy: 3661.941,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#23C533",
    cx: 3723.183,
    cy: 3655.229,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFC105",
    cx: 3727.81,
    cy: 3648.861,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BD7143",
    cx: 3732.284,
    cy: 3642.702,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#27D52F",
    cx: 3736.733,
    cy: 3636.58,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#410D07",
    cx: 3741.18,
    cy: 3630.458,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#43F1FD",
    cx: 3745.623,
    cy: 3624.343,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#314B81",
    cx: 3750.072,
    cy: 3618.219,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B3F52D",
    cx: 3754.517,
    cy: 3612.101,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F5D15",
    cx: 3758.966,
    cy: 3605.978,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2F3109",
    cx: 3763.411,
    cy: 3599.86,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FDCB07",
    cx: 3767.861,
    cy: 3593.735,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4DEF8B",
    cx: 3772.305,
    cy: 3587.618,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#15BD59",
    cx: 3776.751,
    cy: 3581.498,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D35379",
    cx: 3781.201,
    cy: 3575.374,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#910313",
    cx: 3785.651,
    cy: 3569.249,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DB43DB",
    cx: 3790.102,
    cy: 3563.123,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#431933",
    cx: 3794.548,
    cy: 3557.003,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F983B7",
    cx: 3798.998,
    cy: 3550.879,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E14791",
    cx: 3803.44,
    cy: 3544.764,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6917FB",
    cx: 3807.891,
    cy: 3538.639,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CFBDF5",
    cx: 3812.342,
    cy: 3532.511,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1365DD",
    cx: 3816.419,
    cy: 3526.9,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#27715F",
    cx: 2591.356,
    cy: 4962.298,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#035B03",
    cx: 2645.325,
    cy: 4899.109,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#872BAB",
    cx: 2698.009,
    cy: 4837.424,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#219D7F",
    cx: 2748.176,
    cy: 4778.686,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#074D07",
    cx: 2795.908,
    cy: 4722.799,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#03D3B1",
    cx: 2841.334,
    cy: 4669.612,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E3FFC9",
    cx: 2884.56,
    cy: 4619.001,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#85BF6F",
    cx: 2925.702,
    cy: 4570.83,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DBB54D",
    cx: 2964.859,
    cy: 4524.983,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9B0785",
    cx: 3002.116,
    cy: 4481.359,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E1D5F9",
    cx: 3037.546,
    cy: 4439.876,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6FC38F",
    cx: 3071.264,
    cy: 4400.398,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9DF795",
    cx: 3103.362,
    cy: 4362.817,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A9E147",
    cx: 3133.913,
    cy: 4327.046,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#97B995",
    cx: 3162.986,
    cy: 4293.006,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#852BFD",
    cx: 3190.653,
    cy: 4260.611,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6585B1",
    cx: 3216.982,
    cy: 4229.784,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0DEFDD",
    cx: 3242.033,
    cy: 4200.453,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#131F6D",
    cx: 3265.876,
    cy: 4172.537,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B54DE1",
    cx: 3288.578,
    cy: 4145.957,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#53279F",
    cx: 3310.167,
    cy: 4120.68,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#55D503",
    cx: 3330.708,
    cy: 4096.628,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3FCBF3",
    cx: 3350.26,
    cy: 4073.736,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C59909",
    cx: 3368.861,
    cy: 4051.957,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#770595",
    cx: 3386.565,
    cy: 4031.228,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ABFDEF",
    cx: 3403.415,
    cy: 4011.5,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8D0F25",
    cx: 3419.438,
    cy: 3992.739,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1DC9B7",
    cx: 3434.693,
    cy: 3974.877,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0D7B19",
    cx: 3449.216,
    cy: 3957.874,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3D374F",
    cx: 3463.035,
    cy: 3941.693,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B4319",
    cx: 3476.181,
    cy: 3926.301,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EFCD43",
    cx: 3488.685,
    cy: 3911.661,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FDB1CB",
    cx: 3500.577,
    cy: 3897.737,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#457DB1",
    cx: 3511.89,
    cy: 3884.492,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B7F33",
    cx: 3522.654,
    cy: 3871.888,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#59F50B",
    cx: 3532.898,
    cy: 3859.894,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#217B1D",
    cx: 3542.651,
    cy: 3848.475,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F05B1",
    cx: 3551.938,
    cy: 3837.602,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#99631B",
    cx: 3560.781,
    cy: 3827.248,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1D4B65",
    cx: 3569.201,
    cy: 3817.389,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#930F2F",
    cx: 3577.215,
    cy: 3808.006,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#918BE9",
    cx: 3584.833,
    cy: 3799.086,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E3EB0F",
    cx: 3592.064,
    cy: 3790.62,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#47BF23",
    cx: 3598.963,
    cy: 3782.542,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D3CBAB",
    cx: 3605.538,
    cy: 3774.844,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#29590F",
    cx: 3611.787,
    cy: 3767.527,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D9BC7",
    cx: 3617.719,
    cy: 3760.582,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6D9373",
    cx: 3623.386,
    cy: 3753.947,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#97D7F3",
    cx: 3628.774,
    cy: 3747.638,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EDF371",
    cx: 3633.886,
    cy: 3741.653,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1DB99F",
    cx: 3638.83,
    cy: 3735.864,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CDB919",
    cx: 3643.745,
    cy: 3730.109,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#992F6D",
    cx: 3648.659,
    cy: 3724.355,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C37111",
    cx: 3653.568,
    cy: 3718.608,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#578B81",
    cx: 3658.484,
    cy: 3712.852,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0DB30D",
    cx: 3663.395,
    cy: 3707.102,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8709E1",
    cx: 3668.311,
    cy: 3701.347,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4DC375",
    cx: 3673.222,
    cy: 3695.596,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F613F",
    cx: 3678.139,
    cy: 3689.839,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#03D541",
    cx: 3683.049,
    cy: 3684.09,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0DB1A3",
    cx: 3687.962,
    cy: 3678.338,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B3D7BB",
    cx: 3692.878,
    cy: 3672.581,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DD0337",
    cx: 3697.796,
    cy: 3666.824,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EB3365",
    cx: 3702.713,
    cy: 3661.067,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#17896D",
    cx: 3707.626,
    cy: 3655.314,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8D3F0F",
    cx: 3712.542,
    cy: 3649.558,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C387B3",
    cx: 3717.451,
    cy: 3643.811,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D7ED99",
    cx: 3722.368,
    cy: 3638.053,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B179D9",
    cx: 3727.287,
    cy: 3632.294,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DD850F",
    cx: 3731.792,
    cy: 3627.02,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E7FD95",
    cx: 2397.885,
    cy: 4961.876,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E1093F",
    cx: 2456.645,
    cy: 4903.116,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5925FD",
    cx: 2514.007,
    cy: 4845.754,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#59DB9B",
    cx: 2568.628,
    cy: 4791.133,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CD89CB",
    cx: 2620.597,
    cy: 4739.164,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B33DA9",
    cx: 2670.056,
    cy: 4689.705,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7159B",
    cx: 2717.119,
    cy: 4642.642,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7F3DC1",
    cx: 2761.914,
    cy: 4597.846,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5D452D",
    cx: 2804.547,
    cy: 4555.213,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#694313",
    cx: 2845.113,
    cy: 4514.647,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D9787",
    cx: 2883.688,
    cy: 4476.072,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7DC77F",
    cx: 2920.4,
    cy: 4439.361,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#45EF69",
    cx: 2955.347,
    cy: 4404.414,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3DA171",
    cx: 2988.61,
    cy: 4371.15,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8F1107",
    cx: 3020.264,
    cy: 4339.496,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#25B117",
    cx: 3050.388,
    cy: 4309.373,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CB89E3",
    cx: 3079.055,
    cy: 4280.706,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D30DAF",
    cx: 3106.33,
    cy: 4253.431,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E5DD73",
    cx: 3132.29,
    cy: 4227.471,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E50019",
    cx: 3157.007,
    cy: 4202.754,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9BD16B",
    cx: 3180.512,
    cy: 4179.249,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#87D711",
    cx: 3202.877,
    cy: 4156.883,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C5D70B",
    cx: 3224.165,
    cy: 4135.596,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#61BD49",
    cx: 3244.418,
    cy: 4115.343,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8F0397",
    cx: 3263.693,
    cy: 4096.067,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1F4123",
    cx: 3282.039,
    cy: 4077.721,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E919DD",
    cx: 3299.485,
    cy: 4060.276,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5BAB4D",
    cx: 3316.094,
    cy: 4043.666,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E1EFBF",
    cx: 3331.906,
    cy: 4027.854,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3D0F07",
    cx: 3346.952,
    cy: 4012.808,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C7C32D",
    cx: 3361.266,
    cy: 3998.495,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6DDD0B",
    cx: 3374.879,
    cy: 3984.881,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D7E3D3",
    cx: 3387.828,
    cy: 3971.933,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D8193",
    cx: 3400.145,
    cy: 3959.616,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CFDDED",
    cx: 3411.865,
    cy: 3947.896,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6D6177",
    cx: 3423.018,
    cy: 3936.742,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#350D5F",
    cx: 3433.636,
    cy: 3926.124,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C9C55F",
    cx: 3443.748,
    cy: 3916.013,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E3274F",
    cx: 3453.376,
    cy: 3906.384,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7B5951",
    cx: 3462.544,
    cy: 3897.217,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7F1D51",
    cx: 3471.269,
    cy: 3888.492,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B33307",
    cx: 3479.563,
    cy: 3880.197,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AF37DB",
    cx: 3487.436,
    cy: 3872.324,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B699F",
    cx: 3494.948,
    cy: 3864.812,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#418B4D",
    cx: 3502.107,
    cy: 3857.653,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D11717",
    cx: 3508.911,
    cy: 3850.85,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#276BE9",
    cx: 3515.369,
    cy: 3844.392,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5D4577",
    cx: 3521.539,
    cy: 3838.221,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#53CFD7",
    cx: 3527.406,
    cy: 3832.355,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BF195B",
    cx: 3532.972,
    cy: 3826.789,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#853985",
    cx: 3538.354,
    cy: 3821.406,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5FCF45",
    cx: 3543.706,
    cy: 3816.055,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C1A58F",
    cx: 3549.057,
    cy: 3810.704,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#81B753",
    cx: 3554.401,
    cy: 3805.36,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#15FDF5",
    cx: 3559.753,
    cy: 3800.007,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0DED3F",
    cx: 3565.101,
    cy: 3794.66,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F54B3D",
    cx: 3570.452,
    cy: 3789.308,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5B91BF",
    cx: 3575.8,
    cy: 3783.96,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5B696B",
    cx: 3581.153,
    cy: 3778.607,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#253BCB",
    cx: 3586.499,
    cy: 3773.261,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#87C13D",
    cx: 3591.849,
    cy: 3767.912,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BB21D1",
    cx: 3597.202,
    cy: 3762.559,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79434D",
    cx: 3602.555,
    cy: 3757.205,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#696995",
    cx: 3607.909,
    cy: 3751.852,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AF0F6D",
    cx: 3613.258,
    cy: 3746.502,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#013307",
    cx: 3618.611,
    cy: 3741.15,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#49EBB7",
    cx: 3623.956,
    cy: 3735.805,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E597F1",
    cx: 3629.309,
    cy: 3730.451,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6D8589",
    cx: 3634.665,
    cy: 3725.096,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E52163",
    cx: 3639.569,
    cy: 3720.191,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0DDDDD",
    cx: 2205.043,
    cy: 4946.275,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EF8D37",
    cx: 2268.232,
    cy: 4892.307,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BF3399",
    cx: 2329.917,
    cy: 4839.622,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E7C7A5",
    cx: 2388.656,
    cy: 4789.455,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#794B21",
    cx: 2444.542,
    cy: 4741.724,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#49F169",
    cx: 2497.729,
    cy: 4696.297,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B6B61",
    cx: 2548.34,
    cy: 4653.071,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#37A34B",
    cx: 2596.512,
    cy: 4611.929,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#87AD83",
    cx: 2642.358,
    cy: 4572.772,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#651D65",
    cx: 2685.982,
    cy: 4535.515,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E39B2D",
    cx: 2727.465,
    cy: 4500.084,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#85BD3D",
    cx: 2766.944,
    cy: 4466.367,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D94BE3",
    cx: 2804.524,
    cy: 4434.27,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5BC99F",
    cx: 2840.295,
    cy: 4403.719,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#650B93",
    cx: 2874.335,
    cy: 4374.646,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C3BD0B",
    cx: 2906.73,
    cy: 4346.978,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7B2B8F",
    cx: 2937.557,
    cy: 4320.649,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#95AB15",
    cx: 2966.888,
    cy: 4295.598,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C7E3A1",
    cx: 2994.805,
    cy: 4271.755,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1137D7",
    cx: 3021.385,
    cy: 4249.053,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9581A1",
    cx: 3046.662,
    cy: 4227.465,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C7692D",
    cx: 3070.713,
    cy: 4206.923,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D05E7",
    cx: 3093.605,
    cy: 4187.371,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D1769",
    cx: 3115.385,
    cy: 4168.77,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1FF399",
    cx: 3136.113,
    cy: 4151.066,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3DC7D7",
    cx: 3155.842,
    cy: 4134.216,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D98D4D",
    cx: 3174.603,
    cy: 4118.193,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#314DF3",
    cx: 3192.464,
    cy: 4102.938,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DB418D",
    cx: 3209.468,
    cy: 4088.415,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3DF3C7",
    cx: 3225.648,
    cy: 4074.596,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D3DB63",
    cx: 3241.04,
    cy: 4061.45,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#35EBC9",
    cx: 3255.68,
    cy: 4048.946,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2DF79D",
    cx: 3269.604,
    cy: 4037.054,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7FD0D",
    cx: 3282.85,
    cy: 4025.741,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#09D191",
    cx: 3295.453,
    cy: 4014.977,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E7797D",
    cx: 3307.447,
    cy: 4004.733,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C7AD2F",
    cx: 3318.866,
    cy: 3994.98,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D55389",
    cx: 3329.739,
    cy: 3985.694,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0B155F",
    cx: 3340.094,
    cy: 3976.85,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#355BC3",
    cx: 3349.953,
    cy: 3968.43,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#073FC9",
    cx: 3359.335,
    cy: 3960.417,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6DAB15",
    cx: 3368.255,
    cy: 3952.798,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D54D21",
    cx: 3376.721,
    cy: 3945.567,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#55F723",
    cx: 3384.8,
    cy: 3938.668,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B14D3F",
    cx: 3392.498,
    cy: 3932.093,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#17BB2D",
    cx: 3399.814,
    cy: 3925.844,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E39561",
    cx: 3406.759,
    cy: 3919.912,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2DED53",
    cx: 3413.395,
    cy: 3914.245,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BF9557",
    cx: 3419.703,
    cy: 3908.857,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#931551",
    cx: 3425.689,
    cy: 3903.745,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B2B55",
    cx: 3431.477,
    cy: 3898.801,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FBEF2D",
    cx: 3437.232,
    cy: 3893.886,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1193E9",
    cx: 3442.986,
    cy: 3888.972,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#07A533",
    cx: 3448.733,
    cy: 3884.063,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D5C1CB",
    cx: 3454.489,
    cy: 3879.147,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A54FE9",
    cx: 3460.24,
    cy: 3874.236,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0F292D",
    cx: 3465.995,
    cy: 3869.321,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EF49A1",
    cx: 3471.745,
    cy: 3864.409,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FB678D",
    cx: 3477.502,
    cy: 3859.492,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6B7D5F",
    cx: 3483.251,
    cy: 3854.582,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D2935",
    cx: 3489.004,
    cy: 3849.669,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#67ED0F",
    cx: 3494.76,
    cy: 3844.753,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BD37F3",
    cx: 3500.517,
    cy: 3839.835,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6317F9",
    cx: 3506.275,
    cy: 3834.918,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ED61F3",
    cx: 3512.027,
    cy: 3830.005,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#177D95",
    cx: 3517.783,
    cy: 3825.089,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#03CD25",
    cx: 3523.531,
    cy: 3820.18,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4B090B",
    cx: 3529.288,
    cy: 3815.263,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BB6313",
    cx: 3535.047,
    cy: 3810.344,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B1D1A3",
    cx: 3540.321,
    cy: 3805.84,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#75116B",
    cx: 2014.02,
    cy: 4915.591,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#999719",
    cx: 2081.249,
    cy: 4866.747,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FDA717",
    cx: 2146.877,
    cy: 4819.064,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#55D735",
    cx: 2209.371,
    cy: 4773.661,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#356925",
    cx: 2268.83,
    cy: 4730.461,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#05C313",
    cx: 2325.417,
    cy: 4689.348,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A5C733",
    cx: 2379.263,
    cy: 4650.227,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#251B05",
    cx: 2430.514,
    cy: 4612.99,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6FC71F",
    cx: 2479.292,
    cy: 4577.551,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6D352F",
    cx: 2525.704,
    cy: 4543.831,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#933FD7",
    cx: 2569.839,
    cy: 4511.765,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F2BF3",
    cx: 2611.841,
    cy: 4481.249,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A9D7BD",
    cx: 2651.825,
    cy: 4452.199,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3F71E7",
    cx: 2689.882,
    cy: 4424.548,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C131A9",
    cx: 2726.099,
    cy: 4398.236,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4781E1",
    cx: 2760.564,
    cy: 4373.195,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D7FD7B",
    cx: 2793.362,
    cy: 4349.366,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D5C19B",
    cx: 2824.568,
    cy: 4326.693,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A19D1F",
    cx: 2854.269,
    cy: 4305.114,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#09ABCB",
    cx: 2882.549,
    cy: 4284.568,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6F5DB9",
    cx: 2909.441,
    cy: 4265.029,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D9D38D",
    cx: 2935.03,
    cy: 4246.438,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#51531B",
    cx: 2959.386,
    cy: 4228.743,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2101B7",
    cx: 2982.558,
    cy: 4211.907,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D67A3",
    cx: 3004.611,
    cy: 4195.885,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#87175D",
    cx: 3025.601,
    cy: 4180.634,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0D67A9",
    cx: 3045.561,
    cy: 4166.132,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BB9F19",
    cx: 3064.564,
    cy: 4152.326,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ABF7C3",
    cx: 3082.655,
    cy: 4139.182,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#935B97",
    cx: 3099.87,
    cy: 4126.675,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F37743",
    cx: 3116.246,
    cy: 4114.777,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FB004B",
    cx: 3131.822,
    cy: 4103.461,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#436B17",
    cx: 3146.636,
    cy: 4092.698,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DFDDE1",
    cx: 3160.728,
    cy: 4082.459,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B6D0D",
    cx: 3174.137,
    cy: 4072.717,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2D1F59",
    cx: 3186.898,
    cy: 4063.445,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#93B7E7",
    cx: 3199.047,
    cy: 4054.618,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8F2D27",
    cx: 3210.615,
    cy: 4046.214,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F05AD",
    cx: 3221.632,
    cy: 4038.21,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F1C561",
    cx: 3232.121,
    cy: 4030.589,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B2DF9",
    cx: 3242.103,
    cy: 4023.337,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CD73F1",
    cx: 3251.593,
    cy: 4016.442,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CB3709",
    cx: 3260.601,
    cy: 4009.897,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5B734F",
    cx: 3269.196,
    cy: 4003.653,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#93E1AF",
    cx: 3277.386,
    cy: 3997.702,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4FD511",
    cx: 3285.17,
    cy: 3992.047,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9B29CF",
    cx: 3292.559,
    cy: 3986.678,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8BA533",
    cx: 3299.618,
    cy: 3981.549,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1BC9D5",
    cx: 3306.331,
    cy: 3976.672,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3DA15F",
    cx: 3312.698,
    cy: 3972.046,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#318979",
    cx: 3318.857,
    cy: 3967.572,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#55DFF3",
    cx: 3324.98,
    cy: 3963.123,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8B498F",
    cx: 3331.102,
    cy: 3958.675,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5D3531",
    cx: 3337.216,
    cy: 3954.233,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A92B39",
    cx: 3343.34,
    cy: 3949.783,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FD61DD",
    cx: 3349.458,
    cy: 3945.338,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7DFBC7",
    cx: 3355.581,
    cy: 3940.89,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B1995B",
    cx: 3361.7,
    cy: 3936.445,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E71165",
    cx: 3367.824,
    cy: 3931.995,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A7DFE5",
    cx: 3373.941,
    cy: 3927.551,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A92945",
    cx: 3380.061,
    cy: 3923.104,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7113BD",
    cx: 3386.186,
    cy: 3918.655,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F0F1B",
    cx: 3392.311,
    cy: 3914.204,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F3C119",
    cx: 3398.436,
    cy: 3909.754,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#07A3BB",
    cx: 3404.556,
    cy: 3905.307,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0FB94B",
    cx: 3410.68,
    cy: 3900.858,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B11901",
    cx: 3416.795,
    cy: 3896.415,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CB9F1B",
    cx: 3422.921,
    cy: 3891.965,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BB990F",
    cx: 3429.048,
    cy: 3887.513,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6BB9FB",
    cx: 3434.659,
    cy: 3883.436,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#795737",
    cx: 1825.993,
    cy: 4870.015,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#57B9B5",
    cx: 1896.846,
    cy: 4826.596,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D75D6D",
    cx: 1966.014,
    cy: 4784.21,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4B8F03",
    cx: 2031.877,
    cy: 4743.849,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#412BFD",
    cx: 2094.542,
    cy: 4705.448,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C37727",
    cx: 2154.181,
    cy: 4668.901,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#27F145",
    cx: 2210.931,
    cy: 4634.125,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D5B125",
    cx: 2264.945,
    cy: 4601.025,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2F9B3F",
    cx: 2316.353,
    cy: 4569.522,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#63A38D",
    cx: 2365.267,
    cy: 4539.547,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#59252B",
    cx: 2411.782,
    cy: 4511.043,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFD933",
    cx: 2456.05,
    cy: 4483.916,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EB4781",
    cx: 2498.189,
    cy: 4458.093,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E98D4B",
    cx: 2538.298,
    cy: 4433.514,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A7617F",
    cx: 2576.468,
    cy: 4410.124,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EB2923",
    cx: 2612.791,
    cy: 4387.864,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E55955",
    cx: 2647.358,
    cy: 4366.682,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A7BBC9",
    cx: 2680.247,
    cy: 4346.528,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FD8587",
    cx: 2711.55,
    cy: 4327.345,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#437B59",
    cx: 2741.354,
    cy: 4309.082,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8D67E1",
    cx: 2769.697,
    cy: 4291.713,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D5C99D",
    cx: 2796.665,
    cy: 4275.187,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A5CF73",
    cx: 2822.334,
    cy: 4259.457,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7DCDE9",
    cx: 2846.755,
    cy: 4244.491,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F2959",
    cx: 2869.998,
    cy: 4230.248,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#559F1F",
    cx: 2892.12,
    cy: 4216.692,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#67B573",
    cx: 2913.156,
    cy: 4203.801,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CD4FD1",
    cx: 2933.184,
    cy: 4191.528,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1FB3D9",
    cx: 2952.25,
    cy: 4179.844,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F29EF",
    cx: 2970.393,
    cy: 4168.726,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5D057F",
    cx: 2987.652,
    cy: 4158.149,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D10DD9",
    cx: 3004.068,
    cy: 4148.09,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3DE107",
    cx: 3019.681,
    cy: 4138.522,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8F8FD3",
    cx: 3034.533,
    cy: 4129.421,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#25D16B",
    cx: 3048.665,
    cy: 4120.761,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2155CB",
    cx: 3062.114,
    cy: 4112.519,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B55BDB",
    cx: 3074.918,
    cy: 4104.673,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#036BE3",
    cx: 3087.11,
    cy: 4097.202,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B74D6D",
    cx: 3098.72,
    cy: 4090.087,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#857FBD",
    cx: 3109.775,
    cy: 4083.312,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#851B89",
    cx: 3120.296,
    cy: 4076.865,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5103BD",
    cx: 3130.297,
    cy: 4070.736,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#89E765",
    cx: 3139.791,
    cy: 4064.919,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B5F149",
    cx: 3148.849,
    cy: 4059.368,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F6DE3",
    cx: 3157.481,
    cy: 4054.078,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#87695F",
    cx: 3165.685,
    cy: 4049.051,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1F0BCF",
    cx: 3173.472,
    cy: 4044.279,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DF8B2D",
    cx: 3180.912,
    cy: 4039.719,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0D2B7B",
    cx: 3187.987,
    cy: 4035.384,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5769BB",
    cx: 3194.698,
    cy: 4031.272,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6B21C9",
    cx: 3201.188,
    cy: 4027.294,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9B333B",
    cx: 3207.641,
    cy: 4023.34,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C3716B",
    cx: 3214.093,
    cy: 4019.386,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6FE707",
    cx: 3220.538,
    cy: 4015.437,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0BF397",
    cx: 3226.991,
    cy: 4011.482,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C7A535",
    cx: 3233.44,
    cy: 4007.531,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B3CD17",
    cx: 3239.893,
    cy: 4003.576,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#51DFA1",
    cx: 3246.341,
    cy: 3999.625,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1171AD",
    cx: 3252.796,
    cy: 3995.669,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F3B31F",
    cx: 3259.242,
    cy: 3991.719,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#63BB81",
    cx: 3265.693,
    cy: 3987.766,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#43C9D3",
    cx: 3272.147,
    cy: 3983.811,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F9EFD9",
    cx: 3278.603,
    cy: 3979.854,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#799DBF",
    cx: 3285.059,
    cy: 3975.899,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BDA34F",
    cx: 3291.509,
    cy: 3971.946,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8D616F",
    cx: 3297.963,
    cy: 3967.991,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#00DBE7",
    cx: 3304.408,
    cy: 3964.042,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#17B3B1",
    cx: 3310.863,
    cy: 3960.085,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#43ABAD",
    cx: 3317.321,
    cy: 3956.128,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BFD3EB",
    cx: 3323.235,
    cy: 3952.504,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EDD7B3",
    cx: 1642.121,
    cy: 4809.827,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#69B5BF",
    cx: 1716.163,
    cy: 4772.101,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#615D97",
    cx: 1788.443,
    cy: 4735.272,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7BB70D",
    cx: 1857.27,
    cy: 4700.203,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AD5197",
    cx: 1922.755,
    cy: 4666.837,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BF71BF",
    cx: 1985.077,
    cy: 4635.082,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#339B87",
    cx: 2044.38,
    cy: 4604.866,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A32DA3",
    cx: 2100.825,
    cy: 4576.105,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#45F3B9",
    cx: 2154.546,
    cy: 4548.733,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#59E749",
    cx: 2205.662,
    cy: 4522.688,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B6BDF",
    cx: 2254.27,
    cy: 4497.922,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DB832B",
    cx: 2300.529,
    cy: 4474.352,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1121D7",
    cx: 2344.564,
    cy: 4451.914,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B2901",
    cx: 2386.479,
    cy: 4430.558,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#13C9CB",
    cx: 2426.365,
    cy: 4410.234,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9941F1",
    cx: 2464.323,
    cy: 4390.894,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C59BC5",
    cx: 2500.446,
    cy: 4372.489,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#69BDB5",
    cx: 2534.814,
    cy: 4354.977,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FDF54F",
    cx: 2567.526,
    cy: 4338.31,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0FCB8F",
    cx: 2598.671,
    cy: 4322.44,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#59878D",
    cx: 2628.289,
    cy: 4307.349,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#57EB67",
    cx: 2656.471,
    cy: 4292.99,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#27D1DB",
    cx: 2683.295,
    cy: 4279.322,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3F3BFD",
    cx: 2708.815,
    cy: 4266.319,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C5A9E9",
    cx: 2733.104,
    cy: 4253.943,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C58F1F",
    cx: 2756.221,
    cy: 4242.165,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1DA375",
    cx: 2778.204,
    cy: 4230.964,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D3FB87",
    cx: 2799.133,
    cy: 4220.3,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C5AF8B",
    cx: 2819.057,
    cy: 4210.148,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E7FBE3",
    cx: 2838.016,
    cy: 4200.488,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7F0D6F",
    cx: 2856.052,
    cy: 4191.298,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5D3BA9",
    cx: 2873.206,
    cy: 4182.558,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8F8541",
    cx: 2889.522,
    cy: 4174.245,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3733E9",
    cx: 2905.042,
    cy: 4166.336,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F329AB",
    cx: 2919.81,
    cy: 4158.812,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0DFD37",
    cx: 2933.865,
    cy: 4151.65,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F13E1",
    cx: 2947.245,
    cy: 4144.833,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F3E115",
    cx: 2959.985,
    cy: 4138.341,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DFB355",
    cx: 2972.118,
    cy: 4132.16,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#43AF17",
    cx: 2983.67,
    cy: 4126.273,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7553CD",
    cx: 2994.664,
    cy: 4120.672,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#97C5EB",
    cx: 3005.116,
    cy: 4115.346,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4991D5",
    cx: 3015.036,
    cy: 4110.292,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E3F1E7",
    cx: 3024.502,
    cy: 4105.469,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B53547",
    cx: 3033.523,
    cy: 4100.873,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F3F375",
    cx: 3042.096,
    cy: 4096.504,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D53F5F",
    cx: 3050.234,
    cy: 4092.358,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D27F1",
    cx: 3058.009,
    cy: 4088.396,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DB2F03",
    cx: 3065.401,
    cy: 4084.63,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8F0DD1",
    cx: 3072.414,
    cy: 4081.056,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0B6799",
    cx: 3079.197,
    cy: 4077.6,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0B2B13",
    cx: 3085.94,
    cy: 4074.164,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2DF1E9",
    cx: 3092.682,
    cy: 4070.729,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D18DA5",
    cx: 3099.417,
    cy: 4067.298,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D3672B",
    cx: 3106.161,
    cy: 4063.861,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BF5BDB",
    cx: 3112.899,
    cy: 4060.428,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3BD3AF",
    cx: 3119.643,
    cy: 4056.992,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EBFF5F",
    cx: 3126.381,
    cy: 4053.559,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#75139F",
    cx: 3133.126,
    cy: 4050.122,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BDD1B1",
    cx: 3139.863,
    cy: 4046.689,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C9B3DF",
    cx: 3146.604,
    cy: 4043.255,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F14189",
    cx: 3153.349,
    cy: 4039.818,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A3819B",
    cx: 3160.095,
    cy: 4036.381,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#51D585",
    cx: 3166.841,
    cy: 4032.943,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E7C3CB",
    cx: 3173.581,
    cy: 4029.509,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3F3D59",
    cx: 3180.326,
    cy: 4026.073,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2FA55D",
    cx: 3187.061,
    cy: 4022.641,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C1572D",
    cx: 3193.807,
    cy: 4019.204,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A9218F",
    cx: 3200.555,
    cy: 4015.765,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D53533",
    cx: 3206.735,
    cy: 4012.616,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BF79CB",
    cx: 1463.538,
    cy: 4735.399,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#11B355",
    cx: 1540.312,
    cy: 4703.598,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#051FB3",
    cx: 1615.259,
    cy: 4672.554,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D53D9",
    cx: 1686.625,
    cy: 4642.994,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#753D7B",
    cx: 1754.526,
    cy: 4614.868,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C18161",
    cx: 1819.148,
    cy: 4588.101,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#91177B",
    cx: 1880.639,
    cy: 4562.63,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D178D",
    cx: 1939.166,
    cy: 4538.387,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9FE7D7",
    cx: 1994.869,
    cy: 4515.314,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BB435D",
    cx: 2047.871,
    cy: 4493.361,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#559B27",
    cx: 2098.272,
    cy: 4472.484,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9FBB39",
    cx: 2146.238,
    cy: 4452.616,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CD5173",
    cx: 2191.898,
    cy: 4433.703,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#91396B",
    cx: 2235.358,
    cy: 4415.701,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C15B2B",
    cx: 2276.717,
    cy: 4398.569,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3BBBAD",
    cx: 2316.075,
    cy: 4382.267,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#51F5AD",
    cx: 2353.53,
    cy: 4366.752,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EDEFDF",
    cx: 2389.167,
    cy: 4351.991,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BD6D61",
    cx: 2423.085,
    cy: 4337.942,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#973DE9",
    cx: 2455.379,
    cy: 4324.565,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AD7D77",
    cx: 2486.09,
    cy: 4311.844,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#57BD83",
    cx: 2515.313,
    cy: 4299.74,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#65ED29",
    cx: 2543.126,
    cy: 4288.219,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#21A3D7",
    cx: 2569.587,
    cy: 4277.258,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2B9DE7",
    cx: 2594.772,
    cy: 4266.827,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7725E3",
    cx: 2618.742,
    cy: 4256.898,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#03650F",
    cx: 2641.536,
    cy: 4247.456,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#777F5B",
    cx: 2663.237,
    cy: 4238.467,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8D116F",
    cx: 2683.896,
    cy: 4229.91,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D2B55",
    cx: 2703.555,
    cy: 4221.767,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#217745",
    cx: 2722.257,
    cy: 4214.021,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C3B1FD",
    cx: 2740.044,
    cy: 4206.653,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#95530D",
    cx: 2756.961,
    cy: 4199.646,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6169F3",
    cx: 2773.054,
    cy: 4192.979,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4F51AB",
    cx: 2788.367,
    cy: 4186.637,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79DB5B",
    cx: 2802.94,
    cy: 4180.601,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E721EB",
    cx: 2816.814,
    cy: 4174.854,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1BB1A3",
    cx: 2830.024,
    cy: 4169.382,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#294353",
    cx: 2842.605,
    cy: 4164.171,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9FE34F",
    cx: 2854.583,
    cy: 4159.209,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0B437D",
    cx: 2865.982,
    cy: 4154.488,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#130B99",
    cx: 2876.82,
    cy: 4149.999,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#87FDD5",
    cx: 2887.106,
    cy: 4145.738,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F76D6B",
    cx: 2896.922,
    cy: 4141.672,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#632F91",
    cx: 2906.275,
    cy: 4137.798,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F2583",
    cx: 2915.164,
    cy: 4134.116,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8D9947",
    cx: 2923.603,
    cy: 4130.621,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6BBFE3",
    cx: 2931.664,
    cy: 4127.281,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BF3D3F",
    cx: 2939.329,
    cy: 4124.106,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#133137",
    cx: 2946.601,
    cy: 4121.094,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5BF117",
    cx: 2953.634,
    cy: 4118.181,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#852FDB",
    cx: 2960.626,
    cy: 4115.285,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D17107",
    cx: 2967.617,
    cy: 4112.389,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CB31AB",
    cx: 2974.6,
    cy: 4109.497,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EF9781",
    cx: 2981.593,
    cy: 4106.6,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#755369",
    cx: 2988.58,
    cy: 4103.706,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#496573",
    cx: 2995.572,
    cy: 4100.81,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C34731",
    cx: 3002.559,
    cy: 4097.916,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A7EDB5",
    cx: 3009.553,
    cy: 4095.019,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#17F59B",
    cx: 3016.539,
    cy: 4092.125,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D9BA1",
    cx: 3023.528,
    cy: 4089.23,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1509E9",
    cx: 3030.522,
    cy: 4086.333,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5FF37B",
    cx: 3037.517,
    cy: 4083.436,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#00DD17",
    cx: 3044.511,
    cy: 4080.538,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#87B939",
    cx: 3051.5,
    cy: 4077.644,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#395773",
    cx: 3058.494,
    cy: 4074.747,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A9DFD3",
    cx: 3065.477,
    cy: 4071.854,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1BB30B",
    cx: 3072.472,
    cy: 4068.957,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#89A3C1",
    cx: 3079.469,
    cy: 4066.058,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8B0D1D",
    cx: 3085.878,
    cy: 4063.404,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#25E13B",
    cx: 1291.346,
    cy: 4647.188,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75B9",
    cx: 1370.379,
    cy: 4621.509,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CF49B5",
    cx: 1447.53,
    cy: 4596.441,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#15F98F",
    cx: 1520.995,
    cy: 4572.571,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CDF3EF",
    cx: 1590.893,
    cy: 4549.859,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#55EF5F",
    cx: 1657.416,
    cy: 4528.245,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CD11D7",
    cx: 1720.716,
    cy: 4507.677,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F53131",
    cx: 1780.965,
    cy: 4488.101,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6B355B",
    cx: 1838.307,
    cy: 4469.47,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C787AB",
    cx: 1892.867,
    cy: 4451.742,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#61657F",
    cx: 1944.751,
    cy: 4434.884,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E91389",
    cx: 1994.128,
    cy: 4418.84,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#49F7D5",
    cx: 2041.131,
    cy: 4403.568,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1DBF79",
    cx: 2085.87,
    cy: 4389.032,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B5410D",
    cx: 2128.445,
    cy: 4375.198,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BF1373",
    cx: 2168.962,
    cy: 4362.034,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B2B03",
    cx: 2207.518,
    cy: 4349.506,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#35E32B",
    cx: 2244.203,
    cy: 4337.586,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0D315F",
    cx: 2279.119,
    cy: 4326.241,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B69D1",
    cx: 2312.363,
    cy: 4315.439,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#61CDEB",
    cx: 2343.978,
    cy: 4305.167,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C75531",
    cx: 2374.06,
    cy: 4295.393,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F76BE1",
    cx: 2402.691,
    cy: 4286.09,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#61CBD7",
    cx: 2429.931,
    cy: 4277.239,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B92BE9",
    cx: 2455.857,
    cy: 4268.816,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4FA14F",
    cx: 2480.532,
    cy: 4260.798,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BB3BB5",
    cx: 2503.996,
    cy: 4253.174,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A3F949",
    cx: 2526.336,
    cy: 4245.916,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6D3B55",
    cx: 2547.603,
    cy: 4239.005,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A91BA1",
    cx: 2567.84,
    cy: 4232.43,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DD4389",
    cx: 2587.091,
    cy: 4226.175,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#97E7CF",
    cx: 2605.402,
    cy: 4220.226,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D335A7",
    cx: 2622.817,
    cy: 4214.567,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#55EBB3",
    cx: 2639.383,
    cy: 4209.185,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D735EB",
    cx: 2655.146,
    cy: 4204.063,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#718741",
    cx: 2670.148,
    cy: 4199.188,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2FC3A1",
    cx: 2684.43,
    cy: 4194.548,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8DB7AB",
    cx: 2698.029,
    cy: 4190.129,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BD4F5D",
    cx: 2710.98,
    cy: 4185.921,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6FB31B",
    cx: 2723.311,
    cy: 4181.915,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7FD329",
    cx: 2735.045,
    cy: 4178.102,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D21C1",
    cx: 2746.201,
    cy: 4174.477,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E96701",
    cx: 2756.79,
    cy: 4171.037,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F5AF7D",
    cx: 2766.894,
    cy: 4167.753,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#015311",
    cx: 2776.523,
    cy: 4164.625,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#07154F",
    cx: 2785.674,
    cy: 4161.652,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E97363",
    cx: 2794.36,
    cy: 4158.83,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDEB6B",
    cx: 2802.659,
    cy: 4156.133,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#37C1C1",
    cx: 2810.549,
    cy: 4153.569,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#772F4F",
    cx: 2818.035,
    cy: 4151.137,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#33333D",
    cx: 2825.275,
    cy: 4148.785,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C3C1D1",
    cx: 2832.473,
    cy: 4146.446,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8503F1",
    cx: 2839.669,
    cy: 4144.107,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B1D9A3",
    cx: 2846.858,
    cy: 4141.772,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8961CF",
    cx: 2854.056,
    cy: 4139.433,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3BA505",
    cx: 2861.249,
    cy: 4137.096,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8BCDE3",
    cx: 2868.447,
    cy: 4134.757,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#00B761",
    cx: 2875.639,
    cy: 4132.42,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DF7781",
    cx: 2882.839,
    cy: 4130.081,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C5FBF5",
    cx: 2890.03,
    cy: 4127.744,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EFF5E5",
    cx: 2897.225,
    cy: 4125.407,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#533F05",
    cx: 2904.424,
    cy: 4123.067,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C7071B",
    cx: 2911.625,
    cy: 4120.728,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#795D47",
    cx: 2918.826,
    cy: 4118.388,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#19F73F",
    cx: 2926.02,
    cy: 4116.05,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#17C599",
    cx: 2933.219,
    cy: 4113.711,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#47F337",
    cx: 2940.408,
    cy: 4111.375,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4F29E3",
    cx: 2947.609,
    cy: 4109.036,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E92F5F",
    cx: 2954.812,
    cy: 4106.695,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#87E717",
    cx: 2961.409,
    cy: 4104.552,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3F213B",
    cx: 1126.606,
    cy: 4545.738,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1FD95D",
    cx: 1207.409,
    cy: 4526.339,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#73B739",
    cx: 1286.29,
    cy: 4507.402,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#11E7CD",
    cx: 1361.401,
    cy: 4489.369,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B1C3A3",
    cx: 1432.866,
    cy: 4472.212,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#89FB7D",
    cx: 1500.879,
    cy: 4455.883,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#27E981",
    cx: 1565.598,
    cy: 4440.346,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#19290F",
    cx: 1627.197,
    cy: 4425.557,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8D6771",
    cx: 1685.823,
    cy: 4411.482,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CDBF2B",
    cx: 1741.607,
    cy: 4398.09,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5DA7D7",
    cx: 1794.653,
    cy: 4385.354,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#970597",
    cx: 1845.137,
    cy: 4373.234,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1DA17B",
    cx: 1893.193,
    cy: 4361.697,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C9B74F",
    cx: 1938.935,
    cy: 4350.715,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6B738F",
    cx: 1982.464,
    cy: 4340.265,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#07EFAD",
    cx: 2023.889,
    cy: 4330.32,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D9759F",
    cx: 2063.309,
    cy: 4320.856,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#791FFD",
    cx: 2100.816,
    cy: 4311.851,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D513D3",
    cx: 2136.515,
    cy: 4303.281,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EBEFC3",
    cx: 2170.504,
    cy: 4295.121,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9523B3",
    cx: 2202.827,
    cy: 4287.361,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#39C3E1",
    cx: 2233.583,
    cy: 4279.977,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#716DF7",
    cx: 2262.856,
    cy: 4272.949,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C5B5C9",
    cx: 2290.706,
    cy: 4266.263,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DBB96B",
    cx: 2317.213,
    cy: 4259.899,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3F6337",
    cx: 2342.441,
    cy: 4253.842,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FDA175",
    cx: 2366.431,
    cy: 4248.083,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ADA3C1",
    cx: 2389.271,
    cy: 4242.599,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E92951",
    cx: 2411.015,
    cy: 4237.379,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D5A7DF",
    cx: 2431.706,
    cy: 4232.412,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8DA725",
    cx: 2451.388,
    cy: 4227.687,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EFD1AF",
    cx: 2470.109,
    cy: 4223.192,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#314579",
    cx: 2487.915,
    cy: 4218.917,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#231DCD",
    cx: 2504.852,
    cy: 4214.851,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1367B1",
    cx: 2520.969,
    cy: 4210.981,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#33F1DB",
    cx: 2536.307,
    cy: 4207.299,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#132555",
    cx: 2550.908,
    cy: 4203.793,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A9A1EF",
    cx: 2564.813,
    cy: 4200.456,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#11BF69",
    cx: 2578.053,
    cy: 4197.277,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2D0DE1",
    cx: 2590.66,
    cy: 4194.25,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0533C9",
    cx: 2602.658,
    cy: 4191.37,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3565B3",
    cx: 2614.064,
    cy: 4188.631,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A1715D",
    cx: 2624.891,
    cy: 4186.032,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#75EBDF",
    cx: 2635.221,
    cy: 4183.552,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A58B8D",
    cx: 2645.065,
    cy: 4181.188,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6985BF",
    cx: 2654.421,
    cy: 4178.942,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#932981",
    cx: 2663.302,
    cy: 4176.811,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CB91D3",
    cx: 2671.787,
    cy: 4174.773,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6DED8D",
    cx: 2679.854,
    cy: 4172.836,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#093F3B",
    cx: 2687.508,
    cy: 4170.999,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0FD5CF",
    cx: 2694.91,
    cy: 4169.222,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#15CF93",
    cx: 2702.269,
    cy: 4167.455,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#75FB63",
    cx: 2709.627,
    cy: 4165.689,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CFE173",
    cx: 2716.976,
    cy: 4163.924,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#63219F",
    cx: 2724.336,
    cy: 4162.157,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#338F75",
    cx: 2731.69,
    cy: 4160.392,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C17FCB",
    cx: 2739.049,
    cy: 4158.625,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ED4B1F",
    cx: 2746.403,
    cy: 4156.859,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E59DCF",
    cx: 2753.764,
    cy: 4155.092,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7B092F",
    cx: 2761.116,
    cy: 4153.327,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9B6169",
    cx: 2768.472,
    cy: 4151.562,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D1719B",
    cx: 2775.833,
    cy: 4149.794,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C34747",
    cx: 2783.195,
    cy: 4148.026,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CBF369",
    cx: 2790.557,
    cy: 4146.259,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#65D9A5",
    cx: 2797.913,
    cy: 4144.493,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0F09D3",
    cx: 2805.273,
    cy: 4142.726,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9331D5",
    cx: 2812.624,
    cy: 4140.961,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7BC755",
    cx: 2819.986,
    cy: 4139.194,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9FC503",
    cx: 2827.35,
    cy: 4137.426,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2D5D3B",
    cx: 2834.095,
    cy: 4135.807,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E72F55",
    cx: 970.333,
    cy: 4431.677,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B41E7",
    cx: 1052.409,
    cy: 4418.678,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#27B139",
    cx: 1132.532,
    cy: 4405.987,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3D819B",
    cx: 1208.827,
    cy: 4393.903,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C1A397",
    cx: 1281.417,
    cy: 4382.406,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#872B1D",
    cx: 1350.503,
    cy: 4371.464,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6FF339",
    cx: 1416.241,
    cy: 4361.052,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C700C3",
    cx: 1478.81,
    cy: 4351.142,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E1E93B",
    cx: 1538.36,
    cy: 4341.71,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B36F3B",
    cx: 1595.022,
    cy: 4332.736,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5B6F31",
    cx: 1648.905,
    cy: 4324.202,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#791115",
    cx: 1700.183,
    cy: 4316.08,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#337DBD",
    cx: 1748.997,
    cy: 4308.349,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2B21F3",
    cx: 1795.459,
    cy: 4300.99,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9DDFA9",
    cx: 1839.674,
    cy: 4293.987,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F71D15",
    cx: 1881.751,
    cy: 4287.323,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#730B07",
    cx: 1921.793,
    cy: 4280.98,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#976BDD",
    cx: 1959.891,
    cy: 4274.947,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1FBBAB",
    cx: 1996.152,
    cy: 4269.204,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#19D54D",
    cx: 2030.676,
    cy: 4263.735,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E1F957",
    cx: 2063.509,
    cy: 4258.535,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D781E7",
    cx: 2094.749,
    cy: 4253.587,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#11957D",
    cx: 2124.483,
    cy: 4248.877,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#814181",
    cx: 2152.772,
    cy: 4244.397,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#31FD1F",
    cx: 2179.697,
    cy: 4240.133,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E30FCB",
    cx: 2205.322,
    cy: 4236.074,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B533CD",
    cx: 2229.69,
    cy: 4232.214,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7B2501",
    cx: 2252.89,
    cy: 4228.54,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EF0D77",
    cx: 2274.976,
    cy: 4225.042,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EB8DA3",
    cx: 2295.993,
    cy: 4221.713,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F75583",
    cx: 2315.986,
    cy: 4218.547,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1381CB",
    cx: 2335.001,
    cy: 4215.535,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#951131",
    cx: 2353.087,
    cy: 4212.67,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4507D1",
    cx: 2370.292,
    cy: 4209.945,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F11C1",
    cx: 2386.662,
    cy: 4207.353,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0D7F0D",
    cx: 2402.242,
    cy: 4204.885,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DBBB13",
    cx: 2417.074,
    cy: 4202.536,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#47BF89",
    cx: 2431.197,
    cy: 4200.299,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6BE317",
    cx: 2444.646,
    cy: 4198.169,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79BF23",
    cx: 2457.452,
    cy: 4196.141,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#21CDB7",
    cx: 2469.638,
    cy: 4194.21,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5987B9",
    cx: 2481.224,
    cy: 4192.375,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DB7D3B",
    cx: 2492.221,
    cy: 4190.634,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0567F7",
    cx: 2502.714,
    cy: 4188.972,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B32187",
    cx: 2512.714,
    cy: 4187.388,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7F590B",
    cx: 2522.217,
    cy: 4185.883,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#398B9F",
    cx: 2531.238,
    cy: 4184.454,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#674B2D",
    cx: 2539.856,
    cy: 4183.089,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9521E5",
    cx: 2548.051,
    cy: 4181.791,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FD1FA3",
    cx: 2555.825,
    cy: 4180.56,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9FFB19",
    cx: 2563.344,
    cy: 4179.369,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D51E7",
    cx: 2570.819,
    cy: 4178.185,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FD1D2D",
    cx: 2578.292,
    cy: 4177.001,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8F6BE1",
    cx: 2585.758,
    cy: 4175.819,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B9430F",
    cx: 2593.234,
    cy: 4174.635,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#09E9F7",
    cx: 2600.703,
    cy: 4173.452,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E76F39",
    cx: 2608.178,
    cy: 4172.268,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F14325",
    cx: 2615.648,
    cy: 4171.085,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#85BDF7",
    cx: 2623.125,
    cy: 4169.9,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#41BB0D",
    cx: 2630.593,
    cy: 4168.718,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0D0D49",
    cx: 2638.064,
    cy: 4167.534,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#53D5CF",
    cx: 2645.542,
    cy: 4166.35,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D121CD",
    cx: 2653.02,
    cy: 4165.166,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C14FF9",
    cx: 2660.498,
    cy: 4163.981,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#21831D",
    cx: 2667.969,
    cy: 4162.798,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E5BD45",
    cx: 2675.446,
    cy: 4161.614,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#11DFB3",
    cx: 2682.912,
    cy: 4160.431,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CF1BDD",
    cx: 2690.39,
    cy: 4159.247,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#215D75",
    cx: 2697.87,
    cy: 4158.062,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BB4D73",
    cx: 2704.721,
    cy: 4156.977,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6F9967",
    cx: 823.49,
    cy: 4305.707,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F92FB7",
    cx: 906.334,
    cy: 4299.187,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#83750F",
    cx: 987.205,
    cy: 4292.822,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#01314B",
    cx: 1064.213,
    cy: 4286.762,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BBBBE9",
    cx: 1137.482,
    cy: 4280.995,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#49DFB3",
    cx: 1207.212,
    cy: 4275.507,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#91B913",
    cx: 1273.565,
    cy: 4270.285,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3953FB",
    cx: 1336.719,
    cy: 4265.315,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#61F5A5",
    cx: 1396.825,
    cy: 4260.584,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#57A3DB",
    cx: 1454.017,
    cy: 4256.083,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#255D1B",
    cx: 1508.403,
    cy: 4251.803,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DFFF63",
    cx: 1560.161,
    cy: 4247.729,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#155F03",
    cx: 1609.431,
    cy: 4243.852,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#97AD29",
    cx: 1656.327,
    cy: 4240.161,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#17C573",
    cx: 1700.955,
    cy: 4236.649,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#85C9F5",
    cx: 1743.425,
    cy: 4233.307,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A3D1D7",
    cx: 1783.841,
    cy: 4230.125,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B5FF65",
    cx: 1822.295,
    cy: 4227.099,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CB05AB",
    cx: 1858.894,
    cy: 4224.219,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DB63FD",
    cx: 1893.742,
    cy: 4221.476,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F389F3",
    cx: 1926.881,
    cy: 4218.868,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#39553D",
    cx: 1958.413,
    cy: 4216.387,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2D2563",
    cx: 1988.425,
    cy: 4214.024,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E71DA1",
    cx: 2016.979,
    cy: 4211.777,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5B693B",
    cx: 2044.154,
    cy: 4209.639,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D53AD",
    cx: 2070.019,
    cy: 4207.603,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4B07A9",
    cx: 2094.615,
    cy: 4205.667,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8F19AB",
    cx: 2118.032,
    cy: 4203.824,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DF19C3",
    cx: 2140.324,
    cy: 4202.07,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#55258F",
    cx: 2161.538,
    cy: 4200.4,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4B09A7",
    cx: 2181.717,
    cy: 4198.812,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ABF58B",
    cx: 2200.91,
    cy: 4197.302,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A78161",
    cx: 2219.165,
    cy: 4195.865,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4DC79B",
    cx: 2236.531,
    cy: 4194.498,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9FD957",
    cx: 2253.054,
    cy: 4193.198,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#851BED",
    cx: 2268.779,
    cy: 4191.96,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5DADF5",
    cx: 2283.75,
    cy: 4190.782,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D56D83",
    cx: 2298.005,
    cy: 4189.66,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A1ADB3",
    cx: 2311.58,
    cy: 4188.592,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7F83BB",
    cx: 2324.505,
    cy: 4187.574,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D59D0B",
    cx: 2336.805,
    cy: 4186.606,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#618B9F",
    cx: 2348.5,
    cy: 4185.686,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E3B7EB",
    cx: 2359.599,
    cy: 4184.813,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0D7737",
    cx: 2370.19,
    cy: 4183.979,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5929C1",
    cx: 2380.283,
    cy: 4183.185,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#037321",
    cx: 2389.875,
    cy: 4182.43,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D1EB95",
    cx: 2398.98,
    cy: 4181.713,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E557BB",
    cx: 2407.679,
    cy: 4181.028,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ADC91B",
    cx: 2415.95,
    cy: 4180.377,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1905C9",
    cx: 2423.797,
    cy: 4179.76,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A74BDD",
    cx: 2431.386,
    cy: 4179.163,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FDC757",
    cx: 2438.931,
    cy: 4178.569,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3DB12B",
    cx: 2446.475,
    cy: 4177.975,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C7857B",
    cx: 2454.01,
    cy: 4177.382,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1D43DF",
    cx: 2461.556,
    cy: 4176.788,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C3D599",
    cx: 2469.095,
    cy: 4176.195,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D75353",
    cx: 2476.64,
    cy: 4175.601,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F9EB1B",
    cx: 2484.179,
    cy: 4175.008,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C9536B",
    cx: 2491.726,
    cy: 4174.414,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CB6F95",
    cx: 2499.264,
    cy: 4173.821,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#73B10B",
    cx: 2506.805,
    cy: 4173.227,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3947A5",
    cx: 2514.352,
    cy: 4172.633,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4317BF",
    cx: 2521.9,
    cy: 4172.039,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0FD1F3",
    cx: 2529.448,
    cy: 4171.445,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A739A7",
    cx: 2536.99,
    cy: 4170.852,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A50381",
    cx: 2544.536,
    cy: 4170.258,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0F5355",
    cx: 2552.071,
    cy: 4169.665,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A7195B",
    cx: 2559.619,
    cy: 4169.07,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C5B58B",
    cx: 2567.17,
    cy: 4168.476,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7FCB13",
    cx: 2574.085,
    cy: 4167.932,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F50915",
    cx: 686.985,
    cy: 4168.602,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7B9B4D",
    cx: 770.084,
    cy: 4168.602,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D19D79",
    cx: 851.206,
    cy: 4168.602,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E9B9B3",
    cx: 928.452,
    cy: 4168.602,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#87D91D",
    cx: 1001.947,
    cy: 4168.602,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F2F3B",
    cx: 1071.893,
    cy: 4168.602,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#856FC7",
    cx: 1138.451,
    cy: 4168.602,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#972971",
    cx: 1201.8,
    cy: 4168.602,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2583A9",
    cx: 1262.093,
    cy: 4168.602,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#794763",
    cx: 1319.461,
    cy: 4168.602,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#719B9F",
    cx: 1374.015,
    cy: 4168.602,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B1AB33",
    cx: 1425.933,
    cy: 4168.602,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#03897F",
    cx: 1475.355,
    cy: 4168.602,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7317C9",
    cx: 1522.397,
    cy: 4168.602,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0BBBB5",
    cx: 1567.162,
    cy: 4168.602,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1BB343",
    cx: 1609.764,
    cy: 4168.602,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#836D2B",
    cx: 1650.305,
    cy: 4168.602,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#958349",
    cx: 1688.878,
    cy: 4168.602,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FBA1A1",
    cx: 1725.59,
    cy: 4168.602,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#27E53B",
    cx: 1760.545,
    cy: 4168.602,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0963EF",
    cx: 1793.787,
    cy: 4168.602,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0BAB17",
    cx: 1825.417,
    cy: 4168.602,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D5B0F",
    cx: 1855.522,
    cy: 4168.602,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4B1533",
    cx: 1884.163,
    cy: 4168.602,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6FC5D5",
    cx: 1911.423,
    cy: 4168.602,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#618D29",
    cx: 1937.368,
    cy: 4168.602,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B19965",
    cx: 1962.04,
    cy: 4168.602,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D3A79B",
    cx: 1985.529,
    cy: 4168.602,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#15DD1F",
    cx: 2007.891,
    cy: 4168.602,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A3B99B",
    cx: 2029.169,
    cy: 4168.602,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D75581",
    cx: 2049.411,
    cy: 4168.602,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2381F9",
    cx: 2068.664,
    cy: 4168.602,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E9AB5B",
    cx: 2086.975,
    cy: 4168.602,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#559381",
    cx: 2104.394,
    cy: 4168.602,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#073FD9",
    cx: 2120.969,
    cy: 4168.602,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#699FAF",
    cx: 2136.742,
    cy: 4168.602,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8D5DB1",
    cx: 2151.759,
    cy: 4168.602,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4F91DD",
    cx: 2166.058,
    cy: 4168.602,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EDCB81",
    cx: 2179.675,
    cy: 4168.602,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CF5B45",
    cx: 2192.641,
    cy: 4168.602,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2977C9",
    cx: 2204.979,
    cy: 4168.602,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3F81FF",
    cx: 2216.709,
    cy: 4168.602,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5BBBAD",
    cx: 2227.844,
    cy: 4168.602,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3D8195",
    cx: 2238.467,
    cy: 4168.602,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#33BB4D",
    cx: 2248.591,
    cy: 4168.602,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A341ED",
    cx: 2258.213,
    cy: 4168.602,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#054BAF",
    cx: 2267.346,
    cy: 4168.602,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4B87D3",
    cx: 2276.072,
    cy: 4168.602,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#07AFA3",
    cx: 2284.369,
    cy: 4168.602,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FD8529",
    cx: 2292.24,
    cy: 4168.602,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E15D31",
    cx: 2299.853,
    cy: 4168.602,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#43E9B9",
    cx: 2307.421,
    cy: 4168.602,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1D2383",
    cx: 2314.988,
    cy: 4168.602,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#35F56D",
    cx: 2322.546,
    cy: 4168.602,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#89194B",
    cx: 2330.115,
    cy: 4168.602,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5FB569",
    cx: 2337.677,
    cy: 4168.602,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E50DFB",
    cx: 2345.246,
    cy: 4168.602,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#27396D",
    cx: 2352.809,
    cy: 4168.602,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2D553D",
    cx: 2360.379,
    cy: 4168.602,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F73F53",
    cx: 2367.94,
    cy: 4168.602,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#476D33",
    cx: 2375.505,
    cy: 4168.602,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8F1B91",
    cx: 2383.075,
    cy: 4168.602,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E9832B",
    cx: 2390.646,
    cy: 4168.602,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1517CD",
    cx: 2398.218,
    cy: 4168.602,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#578503",
    cx: 2405.782,
    cy: 4168.602,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#33E93F",
    cx: 2413.352,
    cy: 4168.602,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0B2715",
    cx: 2420.911,
    cy: 4168.602,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#090B2F",
    cx: 2428.482,
    cy: 4168.602,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C925BF",
    cx: 2436.056,
    cy: 4168.602,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2B4519",
    cx: 2442.992,
    cy: 4168.602,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#11D34B",
    cx: 561.656,
    cy: 4021.211,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A17339",
    cx: 644.5,
    cy: 4027.731,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8F0DF3",
    cx: 725.371,
    cy: 4034.096,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E7714D",
    cx: 802.379,
    cy: 4040.156,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9949E9",
    cx: 875.648,
    cy: 4045.923,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4DFD09",
    cx: 945.378,
    cy: 4051.411,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#93E961",
    cx: 1011.731,
    cy: 4056.633,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6D45A5",
    cx: 1074.885,
    cy: 4061.603,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2DA3D7",
    cx: 1134.991,
    cy: 4066.333,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E181CF",
    cx: 1192.183,
    cy: 4070.834,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AFF175",
    cx: 1246.569,
    cy: 4075.115,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D6BA5",
    cx: 1298.327,
    cy: 4079.188,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#67918B",
    cx: 1347.597,
    cy: 4083.066,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9DEF9D",
    cx: 1394.493,
    cy: 4086.757,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#55E5A9",
    cx: 1439.121,
    cy: 4090.269,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4B0D33",
    cx: 1481.591,
    cy: 4093.612,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9D711B",
    cx: 1522.007,
    cy: 4096.792,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D1EFE7",
    cx: 1560.461,
    cy: 4099.819,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4B0B9D",
    cx: 1597.06,
    cy: 4102.699,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2B079D",
    cx: 1631.908,
    cy: 4105.441,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#617557",
    cx: 1665.047,
    cy: 4108.05,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9D2F3D",
    cx: 1696.579,
    cy: 4110.531,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#81FDCD",
    cx: 1726.591,
    cy: 4112.894,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BB6D1B",
    cx: 1755.145,
    cy: 4115.141,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AB3795",
    cx: 1782.32,
    cy: 4117.279,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4F13D7",
    cx: 1808.185,
    cy: 4119.315,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AB6BF5",
    cx: 1832.781,
    cy: 4121.251,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#41D707",
    cx: 1856.198,
    cy: 4123.094,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6D17EF",
    cx: 1878.49,
    cy: 4124.848,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F10DC5",
    cx: 1899.704,
    cy: 4126.518,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D3A387",
    cx: 1919.883,
    cy: 4128.106,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A96F0F",
    cx: 1939.076,
    cy: 4129.616,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#23A119",
    cx: 1957.331,
    cy: 4131.053,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3747A5",
    cx: 1974.697,
    cy: 4132.42,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B34775",
    cx: 1991.22,
    cy: 4133.72,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A563ED",
    cx: 2006.945,
    cy: 4134.958,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F1EDD7",
    cx: 2021.916,
    cy: 4136.136,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B4159",
    cx: 2036.171,
    cy: 4137.258,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7BE3D5",
    cx: 2049.746,
    cy: 4138.326,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E96DA5",
    cx: 2062.671,
    cy: 4139.343,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E58D47",
    cx: 2074.971,
    cy: 4140.312,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7523C5",
    cx: 2086.666,
    cy: 4141.232,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F76D7B",
    cx: 2097.765,
    cy: 4142.105,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5B5923",
    cx: 2108.356,
    cy: 4142.939,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C3437F",
    cx: 2118.449,
    cy: 4143.733,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5D1325",
    cx: 2128.041,
    cy: 4144.488,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A39F95",
    cx: 2137.146,
    cy: 4145.205,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#99D101",
    cx: 2145.845,
    cy: 4145.89,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#673F79",
    cx: 2154.116,
    cy: 4146.541,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#239B53",
    cx: 2161.963,
    cy: 4147.158,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B78307",
    cx: 2169.552,
    cy: 4147.755,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CDD5AD",
    cx: 2177.097,
    cy: 4148.349,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B501FD",
    cx: 2184.641,
    cy: 4148.943,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9DA10B",
    cx: 2192.176,
    cy: 4149.536,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1385C7",
    cx: 2199.722,
    cy: 4150.129,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E7A92F",
    cx: 2207.261,
    cy: 4150.723,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6D6B2D",
    cx: 2214.806,
    cy: 4151.317,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4BFD5F",
    cx: 2222.345,
    cy: 4151.91,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C17BE3",
    cx: 2229.892,
    cy: 4152.504,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A1D711",
    cx: 2237.43,
    cy: 4153.097,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F5FDB5",
    cx: 2244.971,
    cy: 4153.691,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#49CF0F",
    cx: 2252.518,
    cy: 4154.285,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A9E7C1",
    cx: 2260.066,
    cy: 4154.879,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#019BA7",
    cx: 2267.614,
    cy: 4155.473,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EFD535",
    cx: 2275.156,
    cy: 4156.066,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#85EB95",
    cx: 2282.702,
    cy: 4156.66,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#15D35B",
    cx: 2290.238,
    cy: 4157.253,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#918B47",
    cx: 2297.785,
    cy: 4157.847,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5B1F85",
    cx: 2305.336,
    cy: 4158.441,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FD3F25",
    cx: 2312.251,
    cy: 4158.986,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BFA341",
    cx: 448.279,
    cy: 3864.44,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C1CB93",
    cx: 530.355,
    cy: 3877.44,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#797D17",
    cx: 610.478,
    cy: 3890.13,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B3F7A7",
    cx: 686.773,
    cy: 3902.214,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#294345",
    cx: 759.364,
    cy: 3913.711,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#00AD4D",
    cx: 828.449,
    cy: 3924.653,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F3798F",
    cx: 894.187,
    cy: 3935.065,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5B7995",
    cx: 956.757,
    cy: 3944.975,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#27B3AF",
    cx: 1016.306,
    cy: 3954.407,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F32D6B",
    cx: 1072.969,
    cy: 3963.382,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DF437D",
    cx: 1126.851,
    cy: 3971.916,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6BD3DD",
    cx: 1178.13,
    cy: 3980.037,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#873DF5",
    cx: 1226.943,
    cy: 3987.769,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C747D5",
    cx: 1273.406,
    cy: 3995.128,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D9ADA9",
    cx: 1317.62,
    cy: 4002.131,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#31F3F1",
    cx: 1359.698,
    cy: 4008.795,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1DFDD9",
    cx: 1399.739,
    cy: 4015.137,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#59E74B",
    cx: 1437.837,
    cy: 4021.171,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9115F9",
    cx: 1474.098,
    cy: 4026.914,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#939D31",
    cx: 1508.622,
    cy: 4032.382,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#99CF5D",
    cx: 1541.455,
    cy: 4037.583,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7F810D",
    cx: 1572.695,
    cy: 4042.531,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8B1B13",
    cx: 1602.43,
    cy: 4047.24,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C7035D",
    cx: 1630.719,
    cy: 4051.72,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7877D",
    cx: 1657.643,
    cy: 4055.985,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#47518D",
    cx: 1683.268,
    cy: 4060.043,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1D974B",
    cx: 1707.637,
    cy: 4063.903,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8F7B5F",
    cx: 1730.836,
    cy: 4067.578,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#71C569",
    cx: 1752.922,
    cy: 4071.076,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F9713D",
    cx: 1773.939,
    cy: 4074.404,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#797915",
    cx: 1793.932,
    cy: 4077.571,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDF33F",
    cx: 1812.948,
    cy: 4080.583,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3D4FCB",
    cx: 1831.034,
    cy: 4083.447,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#65EF43",
    cx: 1848.238,
    cy: 4086.172,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BF83A1",
    cx: 1864.609,
    cy: 4088.765,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B8B0B",
    cx: 1880.188,
    cy: 4091.233,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#61D3FD",
    cx: 1895.02,
    cy: 4093.582,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1509BF",
    cx: 1909.143,
    cy: 4095.819,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#853F59",
    cx: 1922.592,
    cy: 4097.949,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#85CB65",
    cx: 1935.398,
    cy: 4099.977,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#37DF63",
    cx: 1947.584,
    cy: 4101.907,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C9790F",
    cx: 1959.171,
    cy: 4103.742,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DB85C1",
    cx: 1970.167,
    cy: 4105.484,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#81D151",
    cx: 1980.66,
    cy: 4107.146,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AB4783",
    cx: 1990.66,
    cy: 4108.729,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BF3B81",
    cx: 2000.163,
    cy: 4110.235,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0D8B69",
    cx: 2009.184,
    cy: 4111.664,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F3E7DD",
    cx: 2017.802,
    cy: 4113.028,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#435BAD",
    cx: 2025.997,
    cy: 4114.327,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5D2B23",
    cx: 2033.771,
    cy: 4115.558,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#152DD9",
    cx: 2041.29,
    cy: 4116.749,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F3BB3",
    cx: 2048.765,
    cy: 4117.933,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7B55A1",
    cx: 2056.239,
    cy: 4119.116,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FBA3F9",
    cx: 2063.704,
    cy: 4120.298,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AD4B63",
    cx: 2071.18,
    cy: 4121.483,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E7F7E9",
    cx: 2078.649,
    cy: 4122.666,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F3FE3",
    cx: 2086.125,
    cy: 4123.85,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5BE743",
    cx: 2093.594,
    cy: 4125.033,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AB5583",
    cx: 2101.071,
    cy: 4126.217,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#21FB9F",
    cx: 2108.539,
    cy: 4127.4,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F3E5AB",
    cx: 2116.011,
    cy: 4128.583,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2BF1C9",
    cx: 2123.488,
    cy: 4129.768,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7D9F3",
    cx: 2130.966,
    cy: 4130.952,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#31A96B",
    cx: 2138.444,
    cy: 4132.136,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C921AD",
    cx: 2145.916,
    cy: 4133.32,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#39773F",
    cx: 2153.392,
    cy: 4134.504,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#698DCB",
    cx: 2160.858,
    cy: 4135.686,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B9F87",
    cx: 2168.336,
    cy: 4136.871,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AB51C1",
    cx: 2175.816,
    cy: 4138.056,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9103B1",
    cx: 2182.667,
    cy: 4139.141,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#319BAB",
    cx: 347.551,
    cy: 3699.259,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#056DE3",
    cx: 428.354,
    cy: 3718.658,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2DA969",
    cx: 507.234,
    cy: 3737.595,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C1637F",
    cx: 582.346,
    cy: 3755.628,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#77D72D",
    cx: 653.811,
    cy: 3772.785,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BFDD45",
    cx: 721.824,
    cy: 3789.114,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#636D8D",
    cx: 786.543,
    cy: 3804.651,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F51DED",
    cx: 848.142,
    cy: 3819.44,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3F91A9",
    cx: 906.768,
    cy: 3833.515,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D55135",
    cx: 962.552,
    cy: 3846.907,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CF991B",
    cx: 1015.598,
    cy: 3859.643,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7F911",
    cx: 1066.082,
    cy: 3871.763,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AF5193",
    cx: 1114.138,
    cy: 3883.3,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#77AD51",
    cx: 1159.88,
    cy: 3894.282,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#291D2F",
    cx: 1203.409,
    cy: 3904.732,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A92DAF",
    cx: 1244.834,
    cy: 3914.677,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D93AD",
    cx: 1284.254,
    cy: 3924.141,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7FAD03",
    cx: 1321.761,
    cy: 3933.146,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#371BFB",
    cx: 1357.46,
    cy: 3941.716,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6177EB",
    cx: 1391.449,
    cy: 3949.876,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3BE3A5",
    cx: 1423.772,
    cy: 3957.636,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#41CB91",
    cx: 1454.527,
    cy: 3965.02,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#873351",
    cx: 1483.801,
    cy: 3972.048,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#253FC1",
    cx: 1511.651,
    cy: 3978.735,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#83CF35",
    cx: 1538.158,
    cy: 3985.098,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2F5F09",
    cx: 1563.386,
    cy: 3991.155,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3BB72D",
    cx: 1587.376,
    cy: 3996.915,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8F1B81",
    cx: 1610.216,
    cy: 4002.398,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#31BDB1",
    cx: 1631.96,
    cy: 4007.618,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B0149",
    cx: 1652.651,
    cy: 4012.585,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AB4559",
    cx: 1672.333,
    cy: 4017.311,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E7C7ED",
    cx: 1691.054,
    cy: 4021.805,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D99583",
    cx: 1708.86,
    cy: 4026.08,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#01A95B",
    cx: 1725.797,
    cy: 4030.146,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A1A7A9",
    cx: 1741.914,
    cy: 4034.016,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B3E5A9",
    cx: 1757.252,
    cy: 4037.698,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#69A7A9",
    cx: 1771.853,
    cy: 4041.204,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#812951",
    cx: 1785.757,
    cy: 4044.542,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5115C3",
    cx: 1798.998,
    cy: 4047.72,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BF39B5",
    cx: 1811.605,
    cy: 4050.747,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9949CD",
    cx: 1823.603,
    cy: 4053.627,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FDD79F",
    cx: 1835.009,
    cy: 4056.366,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7751E7",
    cx: 1845.835,
    cy: 4058.965,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#012349",
    cx: 1856.166,
    cy: 4061.445,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9B73E7",
    cx: 1866.01,
    cy: 4063.809,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#17A791",
    cx: 1875.366,
    cy: 4066.055,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D12D2B",
    cx: 1884.247,
    cy: 4068.187,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9D915B",
    cx: 1892.732,
    cy: 4070.224,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0D0109",
    cx: 1900.799,
    cy: 4072.161,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D95D01",
    cx: 1908.453,
    cy: 4073.998,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D9211B",
    cx: 1915.855,
    cy: 4075.775,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#810967",
    cx: 1923.214,
    cy: 4077.542,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D1149",
    cx: 1930.572,
    cy: 4079.309,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8F69A1",
    cx: 1937.921,
    cy: 4081.073,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6F17BB",
    cx: 1945.281,
    cy: 4082.84,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DF00E9",
    cx: 1952.635,
    cy: 4084.605,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5161F3",
    cx: 1959.994,
    cy: 4086.372,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#977B77",
    cx: 1967.348,
    cy: 4088.138,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#138723",
    cx: 1974.709,
    cy: 4089.905,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BD2FE5",
    cx: 1982.061,
    cy: 4091.67,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#43EBEF",
    cx: 1989.417,
    cy: 4093.436,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0FF5CF",
    cx: 1996.778,
    cy: 4095.203,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F38B3D",
    cx: 2004.14,
    cy: 4096.971,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#571FDF",
    cx: 2011.502,
    cy: 4098.738,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E3C91B",
    cx: 2018.858,
    cy: 4100.504,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#639F45",
    cx: 2026.218,
    cy: 4102.271,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D9C7EF",
    cx: 2033.568,
    cy: 4104.036,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#777D2D",
    cx: 2040.93,
    cy: 4105.803,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B0FDF",
    cx: 2048.295,
    cy: 4107.571,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#13450D",
    cx: 2055.04,
    cy: 4109.19,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E139AB",
    cx: 260.093,
    cy: 3526.683,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#89C36F",
    cx: 339.126,
    cy: 3552.362,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EFF3E7",
    cx: 416.277,
    cy: 3577.43,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9327C9",
    cx: 489.742,
    cy: 3601.3,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#096D33",
    cx: 559.64,
    cy: 3624.011,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AD0739",
    cx: 626.163,
    cy: 3645.626,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#51C1AD",
    cx: 689.463,
    cy: 3666.193,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AB3977",
    cx: 749.712,
    cy: 3685.77,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BF8F91",
    cx: 807.054,
    cy: 3704.401,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FD6793",
    cx: 861.614,
    cy: 3722.129,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#396995",
    cx: 913.498,
    cy: 3738.987,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#055FA7",
    cx: 962.875,
    cy: 3755.03,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2D5B49",
    cx: 1009.878,
    cy: 3770.302,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E3DF67",
    cx: 1054.617,
    cy: 3784.839,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3FD381",
    cx: 1097.192,
    cy: 3798.673,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5FB3CB",
    cx: 1137.709,
    cy: 3811.837,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CDCF93",
    cx: 1176.265,
    cy: 3824.365,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BDB9D5",
    cx: 1212.95,
    cy: 3836.285,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C78745",
    cx: 1247.866,
    cy: 3847.629,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A34175",
    cx: 1281.11,
    cy: 3858.431,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C96F7B",
    cx: 1312.725,
    cy: 3868.703,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#29AF23",
    cx: 1342.806,
    cy: 3878.478,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B195F9",
    cx: 1371.438,
    cy: 3887.781,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2DC38B",
    cx: 1398.678,
    cy: 3896.631,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DF7DCD",
    cx: 1424.604,
    cy: 3905.055,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6BD511",
    cx: 1449.279,
    cy: 3913.072,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9D7B57",
    cx: 1472.743,
    cy: 3920.697,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#070D59",
    cx: 1495.083,
    cy: 3927.955,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D94D7D",
    cx: 1516.35,
    cy: 3934.865,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1BB19B",
    cx: 1536.587,
    cy: 3941.441,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F76579",
    cx: 1555.838,
    cy: 3947.696,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#29B1EF",
    cx: 1574.148,
    cy: 3953.645,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8BA1F1",
    cx: 1591.564,
    cy: 3959.304,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8FF1B1",
    cx: 1608.13,
    cy: 3964.686,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E3BF1F",
    cx: 1623.893,
    cy: 3969.808,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BD2BD7",
    cx: 1638.895,
    cy: 3974.682,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DD3DAB",
    cx: 1653.177,
    cy: 3979.323,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C300FD",
    cx: 1666.776,
    cy: 3983.741,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C54527",
    cx: 1679.727,
    cy: 3987.949,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A5172F",
    cx: 1692.057,
    cy: 3991.956,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FDB30F",
    cx: 1703.792,
    cy: 3995.769,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ABDDAF",
    cx: 1714.948,
    cy: 3999.394,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#795FC3",
    cx: 1725.537,
    cy: 4002.834,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#45936F",
    cx: 1735.641,
    cy: 4006.117,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E7CF87",
    cx: 1745.27,
    cy: 4009.246,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D8519",
    cx: 1754.42,
    cy: 4012.219,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5123A3",
    cx: 1763.107,
    cy: 4015.041,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4DEFB1",
    cx: 1771.406,
    cy: 4017.738,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E763B1",
    cx: 1779.296,
    cy: 4020.302,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B3F369",
    cx: 1786.782,
    cy: 4022.734,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3F39B9",
    cx: 1794.022,
    cy: 4025.086,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F709C1",
    cx: 1801.22,
    cy: 4027.425,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#935B21",
    cx: 1808.416,
    cy: 4029.763,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E3FB35",
    cx: 1815.604,
    cy: 4032.099,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BB4D09",
    cx: 1822.803,
    cy: 4034.438,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#17099D",
    cx: 1829.996,
    cy: 4036.775,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B1309",
    cx: 1837.194,
    cy: 4039.114,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79CF7F",
    cx: 1844.386,
    cy: 4041.451,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F98721",
    cx: 1851.586,
    cy: 4043.79,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#652383",
    cx: 1858.777,
    cy: 4046.126,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2DA117",
    cx: 1865.971,
    cy: 4048.464,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D3EBC7",
    cx: 1873.171,
    cy: 4050.803,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A9B363",
    cx: 1880.372,
    cy: 4053.143,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F5DF5",
    cx: 1887.573,
    cy: 4055.483,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#059D27",
    cx: 1894.767,
    cy: 4057.82,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F59D17",
    cx: 1901.966,
    cy: 4060.159,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#896BA3",
    cx: 1909.155,
    cy: 4062.495,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A7B70D",
    cx: 1916.356,
    cy: 4064.835,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D5763",
    cx: 1923.559,
    cy: 4067.175,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2D4F91",
    cx: 1930.156,
    cy: 4069.319,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#53ED83",
    cx: 186.445,
    cy: 3347.777,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B3411B",
    cx: 263.219,
    cy: 3379.577,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E16923",
    cx: 338.166,
    cy: 3410.621,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3D8395",
    cx: 409.532,
    cy: 3440.182,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#779DE3",
    cx: 477.433,
    cy: 3468.307,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F3AD51",
    cx: 542.054,
    cy: 3495.075,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F37B71",
    cx: 603.545,
    cy: 3520.545,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ED8BB9",
    cx: 662.073,
    cy: 3544.788,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#13F5FB",
    cx: 717.776,
    cy: 3567.861,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#93C97B",
    cx: 770.777,
    cy: 3589.815,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#85DBFB",
    cx: 821.179,
    cy: 3610.692,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#63C53B",
    cx: 869.144,
    cy: 3630.56,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EF6FF5",
    cx: 914.805,
    cy: 3649.473,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#415745",
    cx: 958.265,
    cy: 3667.475,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#15E3E3",
    cx: 999.624,
    cy: 3684.606,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0FD117",
    cx: 1038.982,
    cy: 3700.909,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7DBFE9",
    cx: 1076.437,
    cy: 3716.423,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D9E9B3",
    cx: 1112.074,
    cy: 3731.184,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FBBF61",
    cx: 1145.992,
    cy: 3745.234,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DB75FD",
    cx: 1178.286,
    cy: 3758.61,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#01B55F",
    cx: 1208.997,
    cy: 3771.332,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#21E1BB",
    cx: 1238.219,
    cy: 3783.436,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#973B29",
    cx: 1266.033,
    cy: 3794.956,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E3A999",
    cx: 1292.494,
    cy: 3805.917,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6F018D",
    cx: 1317.679,
    cy: 3816.349,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4B5FAD",
    cx: 1341.649,
    cy: 3826.278,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A54F65",
    cx: 1364.443,
    cy: 3835.719,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#17F9CB",
    cx: 1386.144,
    cy: 3844.708,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#55E913",
    cx: 1406.803,
    cy: 3853.265,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#89A583",
    cx: 1426.462,
    cy: 3861.408,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4F35B7",
    cx: 1445.163,
    cy: 3869.155,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9B81F1",
    cx: 1462.95,
    cy: 3876.522,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AF1BB5",
    cx: 1479.868,
    cy: 3883.53,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5737E5",
    cx: 1495.961,
    cy: 3890.196,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3D0F3B",
    cx: 1511.274,
    cy: 3896.539,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6F35D9",
    cx: 1525.847,
    cy: 3902.575,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#275975",
    cx: 1539.721,
    cy: 3908.322,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D9985",
    cx: 1552.931,
    cy: 3913.794,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E78775",
    cx: 1565.512,
    cy: 3919.005,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D31F85",
    cx: 1577.49,
    cy: 3923.966,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#254789",
    cx: 1588.889,
    cy: 3928.688,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#295113",
    cx: 1599.727,
    cy: 3933.177,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4F3D33",
    cx: 1610.013,
    cy: 3937.438,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#25ED07",
    cx: 1619.828,
    cy: 3941.503,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6D21A9",
    cx: 1629.182,
    cy: 3945.377,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#11A309",
    cx: 1638.071,
    cy: 3949.06,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#07E1DB",
    cx: 1646.509,
    cy: 3952.555,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#81432B",
    cx: 1654.571,
    cy: 3955.894,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AB7BBD",
    cx: 1662.236,
    cy: 3959.069,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#65A721",
    cx: 1669.508,
    cy: 3962.081,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#230153",
    cx: 1676.541,
    cy: 3964.994,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#952D2F",
    cx: 1683.533,
    cy: 3967.891,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CBD303",
    cx: 1690.524,
    cy: 3970.786,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6373B7",
    cx: 1697.507,
    cy: 3973.679,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F1D92F",
    cx: 1704.5,
    cy: 3976.575,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9563A3",
    cx: 1711.487,
    cy: 3979.469,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#05ABE3",
    cx: 1718.479,
    cy: 3982.366,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ABCB41",
    cx: 1725.466,
    cy: 3985.26,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#392B3F",
    cx: 1732.46,
    cy: 3988.157,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6F51A5",
    cx: 1739.445,
    cy: 3991.05,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1135E3",
    cx: 1746.434,
    cy: 3993.945,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5341ED",
    cx: 1753.428,
    cy: 3996.842,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5D9D15",
    cx: 1760.424,
    cy: 3999.74,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4513F1",
    cx: 1767.418,
    cy: 4002.637,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#175B99",
    cx: 1774.407,
    cy: 4005.532,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#69F927",
    cx: 1781.401,
    cy: 4008.429,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F917F3",
    cx: 1788.384,
    cy: 4011.321,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D9AF15",
    cx: 1795.379,
    cy: 4014.219,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4935D7",
    cx: 1802.376,
    cy: 4017.117,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CF373F",
    cx: 1808.785,
    cy: 4019.771,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DF2515",
    cx: 127.062,
    cy: 3163.644,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#27FB6F",
    cx: 201.104,
    cy: 3201.37,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#01F31F",
    cx: 273.384,
    cy: 3238.199,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#65FFC3",
    cx: 342.211,
    cy: 3273.268,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ED953F",
    cx: 407.695,
    cy: 3306.634,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7303CB",
    cx: 470.018,
    cy: 3338.389,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1F47C1",
    cx: 529.321,
    cy: 3368.605,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C165B7",
    cx: 585.766,
    cy: 3397.365,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E3FB23",
    cx: 639.487,
    cy: 3424.738,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A7DF91",
    cx: 690.602,
    cy: 3450.782,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#21FD5B",
    cx: 739.21,
    cy: 3475.549,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7DCBB3",
    cx: 785.47,
    cy: 3499.12,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3F4D0B",
    cx: 829.505,
    cy: 3521.557,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#811D9F",
    cx: 871.419,
    cy: 3542.913,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#492B21",
    cx: 911.306,
    cy: 3563.237,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C561DD",
    cx: 949.264,
    cy: 3582.577,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#37991F",
    cx: 985.386,
    cy: 3600.982,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E78F15",
    cx: 1019.755,
    cy: 3618.494,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F147D7",
    cx: 1052.466,
    cy: 3635.161,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#63E52B",
    cx: 1083.611,
    cy: 3651.031,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BFFD51",
    cx: 1113.23,
    cy: 3666.122,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#133FFD",
    cx: 1141.412,
    cy: 3680.481,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FB71A3",
    cx: 1168.236,
    cy: 3694.149,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#65075F",
    cx: 1193.756,
    cy: 3707.152,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#511533",
    cx: 1218.044,
    cy: 3719.527,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A367D3",
    cx: 1241.161,
    cy: 3731.306,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FDCB43",
    cx: 1263.145,
    cy: 3742.507,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#418589",
    cx: 1284.073,
    cy: 3753.171,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#215D11",
    cx: 1303.998,
    cy: 3763.323,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D769E1",
    cx: 1322.957,
    cy: 3772.983,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9317F3",
    cx: 1340.993,
    cy: 3782.173,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1F9761",
    cx: 1358.147,
    cy: 3790.913,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#617753",
    cx: 1374.463,
    cy: 3799.227,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2F9563",
    cx: 1389.983,
    cy: 3807.135,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DB3DA9",
    cx: 1404.751,
    cy: 3814.659,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#114B03",
    cx: 1418.806,
    cy: 3821.82,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F919F7",
    cx: 1432.186,
    cy: 3828.638,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B169D3",
    cx: 1444.926,
    cy: 3835.129,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F32921",
    cx: 1457.059,
    cy: 3841.312,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A1EBF1",
    cx: 1468.611,
    cy: 3847.198,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7F8DCF",
    cx: 1479.605,
    cy: 3852.799,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#372FB5",
    cx: 1490.057,
    cy: 3858.125,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C723A9",
    cx: 1499.977,
    cy: 3863.179,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#47B99D",
    cx: 1509.443,
    cy: 3868.002,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#03199F",
    cx: 1518.464,
    cy: 3872.599,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#91E3ED",
    cx: 1527.036,
    cy: 3876.967,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E557EF",
    cx: 1535.175,
    cy: 3881.113,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#811369",
    cx: 1542.949,
    cy: 3885.075,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B9FBD7",
    cx: 1550.342,
    cy: 3888.841,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D59A5",
    cx: 1557.355,
    cy: 3892.415,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C93335",
    cx: 1564.138,
    cy: 3895.871,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0BC3D5",
    cx: 1570.881,
    cy: 3899.307,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E9D133",
    cx: 1577.623,
    cy: 3902.742,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6737D9",
    cx: 1584.357,
    cy: 3906.173,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D956D",
    cx: 1591.102,
    cy: 3909.61,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D5F9FD",
    cx: 1597.84,
    cy: 3913.043,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F92D0B",
    cx: 1604.584,
    cy: 3916.479,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5B6D01",
    cx: 1611.322,
    cy: 3919.912,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5B61C5",
    cx: 1618.067,
    cy: 3923.349,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CDC96B",
    cx: 1624.804,
    cy: 3926.782,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#37AFE9",
    cx: 1631.544,
    cy: 3930.216,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7B252B",
    cx: 1638.289,
    cy: 3933.653,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EB514F",
    cx: 1645.036,
    cy: 3937.09,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#950149",
    cx: 1651.781,
    cy: 3940.528,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AD65E5",
    cx: 1658.522,
    cy: 3943.962,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#99B1A3",
    cx: 1665.266,
    cy: 3947.398,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C7D5EB",
    cx: 1672.001,
    cy: 3950.83,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B55133",
    cx: 1678.747,
    cy: 3954.267,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BB3D77",
    cx: 1685.496,
    cy: 3957.706,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7ADA9",
    cx: 1691.676,
    cy: 3960.855,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B1335B",
    cx: 82.308,
    cy: 2975.419,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ED29F1",
    cx: 153.162,
    cy: 3018.839,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#774DFB",
    cx: 222.329,
    cy: 3061.225,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F347DB",
    cx: 288.192,
    cy: 3101.586,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F3178F",
    cx: 350.857,
    cy: 3139.987,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#999D7B",
    cx: 410.496,
    cy: 3176.534,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#139DAD",
    cx: 467.246,
    cy: 3211.31,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B9F51",
    cx: 521.26,
    cy: 3244.41,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B36315",
    cx: 572.668,
    cy: 3275.913,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#05B3B5",
    cx: 621.583,
    cy: 3305.887,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BF0B17",
    cx: 668.098,
    cy: 3334.392,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9D2137",
    cx: 712.365,
    cy: 3361.519,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#23331B",
    cx: 754.504,
    cy: 3387.342,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8BBFA7",
    cx: 794.614,
    cy: 3411.921,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#655383",
    cx: 832.783,
    cy: 3435.311,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#49E3CF",
    cx: 869.107,
    cy: 3457.57,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1965D1",
    cx: 903.673,
    cy: 3478.753,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CB0F8F",
    cx: 936.562,
    cy: 3498.907,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#69DDA7",
    cx: 967.865,
    cy: 3518.089,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BD711F",
    cx: 997.669,
    cy: 3536.353,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8B17C3",
    cx: 1026.012,
    cy: 3553.722,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#675F9F",
    cx: 1052.981,
    cy: 3570.249,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#11CF51",
    cx: 1078.65,
    cy: 3585.979,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#178177",
    cx: 1103.07,
    cy: 3600.944,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6F1109",
    cx: 1126.313,
    cy: 3615.187,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A51961",
    cx: 1148.435,
    cy: 3628.743,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#991551",
    cx: 1169.471,
    cy: 3641.634,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#05571F",
    cx: 1189.499,
    cy: 3653.907,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#193745",
    cx: 1208.565,
    cy: 3665.591,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AFA13F",
    cx: 1226.708,
    cy: 3676.709,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4F6171",
    cx: 1243.968,
    cy: 3687.285,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#61C1E3",
    cx: 1260.383,
    cy: 3697.345,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#95E157",
    cx: 1275.996,
    cy: 3706.913,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#95E38F",
    cx: 1290.848,
    cy: 3716.014,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6F6BBB",
    cx: 1304.98,
    cy: 3724.674,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FBFB65",
    cx: 1318.43,
    cy: 3732.916,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#53B5F5",
    cx: 1331.233,
    cy: 3740.762,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D11AF",
    cx: 1343.426,
    cy: 3748.233,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E51B0D",
    cx: 1355.036,
    cy: 3755.348,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3F3985",
    cx: 1366.091,
    cy: 3762.123,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A7AB37",
    cx: 1376.611,
    cy: 3768.569,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#59C15F",
    cx: 1386.613,
    cy: 3774.698,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#737D0F",
    cx: 1396.106,
    cy: 3780.516,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B1750B",
    cx: 1405.164,
    cy: 3786.067,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8373CF",
    cx: 1413.796,
    cy: 3791.357,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#390509",
    cx: 1422,
    cy: 3796.384,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2B6943",
    cx: 1429.788,
    cy: 3801.156,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D7789",
    cx: 1437.228,
    cy: 3805.715,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8775B7",
    cx: 1444.302,
    cy: 3810.051,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8FBDA1",
    cx: 1451.013,
    cy: 3814.163,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DF1D03",
    cx: 1457.504,
    cy: 3818.141,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CDF123",
    cx: 1463.957,
    cy: 3822.095,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1DE3BF",
    cx: 1470.409,
    cy: 3826.049,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#313557",
    cx: 1476.853,
    cy: 3829.998,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#11DD79",
    cx: 1483.307,
    cy: 3833.953,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F93795",
    cx: 1489.755,
    cy: 3837.904,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F09AF",
    cx: 1496.208,
    cy: 3841.859,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6739EF",
    cx: 1502.656,
    cy: 3845.81,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DFFB21",
    cx: 1509.111,
    cy: 3849.766,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1117A3",
    cx: 1515.558,
    cy: 3853.716,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D711DB",
    cx: 1522.008,
    cy: 3857.669,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DB99ED",
    cx: 1528.463,
    cy: 3861.624,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CD15E1",
    cx: 1534.918,
    cy: 3865.58,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9B951D",
    cx: 1541.374,
    cy: 3869.536,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#73C1FD",
    cx: 1547.824,
    cy: 3873.489,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7F9B85",
    cx: 1554.278,
    cy: 3877.444,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0FAF2B",
    cx: 1560.723,
    cy: 3881.393,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#216375",
    cx: 1567.179,
    cy: 3885.349,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#47BFC3",
    cx: 1573.636,
    cy: 3889.307,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#39237D",
    cx: 1579.55,
    cy: 3892.931,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3F41B7",
    cx: 52.46,
    cy: 2784.264,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2DD1E9",
    cx: 119.689,
    cy: 2833.108,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7F353F",
    cx: 185.318,
    cy: 2880.791,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C117BF",
    cx: 247.811,
    cy: 2926.195,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7697F",
    cx: 307.27,
    cy: 2969.394,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#67E179",
    cx: 363.857,
    cy: 3010.507,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ED7D23",
    cx: 417.704,
    cy: 3049.629,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2B8D9B",
    cx: 468.955,
    cy: 3086.865,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0D99A1",
    cx: 517.732,
    cy: 3122.304,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#333197",
    cx: 564.144,
    cy: 3156.024,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#412121",
    cx: 608.279,
    cy: 3188.09,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#157DCD",
    cx: 650.282,
    cy: 3218.607,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2D1D0B",
    cx: 690.265,
    cy: 3247.656,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0161A3",
    cx: 728.322,
    cy: 3275.306,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BB4165",
    cx: 764.539,
    cy: 3301.619,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A969DD",
    cx: 799.004,
    cy: 3326.66,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E1779D",
    cx: 831.802,
    cy: 3350.489,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79CD6F",
    cx: 863.008,
    cy: 3373.162,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#278FC1",
    cx: 892.71,
    cy: 3394.741,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#77E9BD",
    cx: 920.989,
    cy: 3415.287,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CD6D51",
    cx: 947.882,
    cy: 3434.826,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2FE9CB",
    cx: 973.471,
    cy: 3453.417,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4DA599",
    cx: 997.826,
    cy: 3471.113,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C1ED8D",
    cx: 1020.998,
    cy: 3487.948,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#995B51",
    cx: 1043.051,
    cy: 3503.97,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#27D5EB",
    cx: 1064.041,
    cy: 3519.22,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#914DC1",
    cx: 1084.001,
    cy: 3533.723,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D379B3",
    cx: 1103.005,
    cy: 3547.529,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#01759F",
    cx: 1121.095,
    cy: 3560.673,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#71F7BD",
    cx: 1138.31,
    cy: 3573.18,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8DBFE3",
    cx: 1154.686,
    cy: 3585.078,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C7B585",
    cx: 1170.262,
    cy: 3596.394,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AB39C7",
    cx: 1185.076,
    cy: 3607.158,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D3997",
    cx: 1199.168,
    cy: 3617.396,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#310BEB",
    cx: 1212.578,
    cy: 3627.138,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5D3D55",
    cx: 1225.339,
    cy: 3636.41,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#872D27",
    cx: 1237.487,
    cy: 3645.237,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3D9115",
    cx: 1249.056,
    cy: 3653.641,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B5B0B",
    cx: 1260.072,
    cy: 3661.645,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3951E3",
    cx: 1270.561,
    cy: 3669.266,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4DBBAF",
    cx: 1280.543,
    cy: 3676.519,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EFADC5",
    cx: 1290.033,
    cy: 3683.414,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B6B83",
    cx: 1299.041,
    cy: 3689.958,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9DC5AB",
    cx: 1307.636,
    cy: 3696.202,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D329EB",
    cx: 1315.826,
    cy: 3702.153,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79C539",
    cx: 1323.61,
    cy: 3707.809,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#935FB9",
    cx: 1331,
    cy: 3713.177,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#00499F",
    cx: 1338.059,
    cy: 3718.306,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8FD37F",
    cx: 1344.771,
    cy: 3723.183,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9B35ED",
    cx: 1351.139,
    cy: 3727.809,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#579BE9",
    cx: 1357.297,
    cy: 3732.284,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E3B32F",
    cx: 1363.42,
    cy: 3736.732,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F5595B",
    cx: 1369.542,
    cy: 3741.18,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9DE3D1",
    cx: 1375.657,
    cy: 3745.622,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1D8173",
    cx: 1381.78,
    cy: 3750.072,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#27819D",
    cx: 1387.899,
    cy: 3754.517,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C559C1",
    cx: 1394.022,
    cy: 3758.965,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6B8B17",
    cx: 1400.14,
    cy: 3763.411,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#95E50B",
    cx: 1406.265,
    cy: 3767.86,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#472B61",
    cx: 1412.381,
    cy: 3772.304,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EB4773",
    cx: 1418.501,
    cy: 3776.751,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1FCDA5",
    cx: 1424.626,
    cy: 3781.201,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CFC13B",
    cx: 1430.751,
    cy: 3785.651,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1FE361",
    cx: 1436.876,
    cy: 3790.101,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#85A789",
    cx: 1442.996,
    cy: 3794.548,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F975E9",
    cx: 1449.12,
    cy: 3798.997,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ED215F",
    cx: 1455.236,
    cy: 3803.44,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#57CB03",
    cx: 1461.361,
    cy: 3807.89,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9BC317",
    cx: 1467.488,
    cy: 3812.342,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C7B7E3",
    cx: 1473.1,
    cy: 3816.419,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AF0B01",
    cx: 37.702,
    cy: 2591.356,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3DC761",
    cx: 100.891,
    cy: 2645.325,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8D0583",
    cx: 162.576,
    cy: 2698.009,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#239B77",
    cx: 221.315,
    cy: 2748.177,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B139F7",
    cx: 277.201,
    cy: 2795.908,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#00EF29",
    cx: 330.388,
    cy: 2841.334,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2DE5B7",
    cx: 380.999,
    cy: 2884.56,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#650D83",
    cx: 429.171,
    cy: 2925.702,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D7F7B",
    cx: 475.017,
    cy: 2964.859,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#536B43",
    cx: 518.64,
    cy: 3002.117,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3FC717",
    cx: 560.124,
    cy: 3037.547,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6DB74B",
    cx: 599.602,
    cy: 3071.265,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2FD991",
    cx: 637.183,
    cy: 3103.362,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B11DB3",
    cx: 672.954,
    cy: 3133.913,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3FCF53",
    cx: 706.994,
    cy: 3162.986,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EFA163",
    cx: 739.389,
    cy: 3190.653,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3D97E7",
    cx: 770.216,
    cy: 3216.982,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FDA355",
    cx: 799.547,
    cy: 3242.033,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6F3B01",
    cx: 827.464,
    cy: 3265.876,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#731155",
    cx: 854.043,
    cy: 3288.578,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#27A911",
    cx: 879.32,
    cy: 3310.167,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A7EB09",
    cx: 903.372,
    cy: 3330.708,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#876D83",
    cx: 926.264,
    cy: 3350.26,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AF756D",
    cx: 948.043,
    cy: 3368.862,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B53D4D",
    cx: 968.772,
    cy: 3386.565,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#39CD59",
    cx: 988.5,
    cy: 3403.415,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0BDBA1",
    cx: 1007.261,
    cy: 3419.438,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2B03FD",
    cx: 1025.123,
    cy: 3434.693,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79B9C9",
    cx: 1042.126,
    cy: 3449.216,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2D47B3",
    cx: 1058.307,
    cy: 3463.035,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F5BDAD",
    cx: 1073.699,
    cy: 3476.181,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F4703",
    cx: 1088.339,
    cy: 3488.685,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4FB7E3",
    cx: 1102.263,
    cy: 3500.577,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B797B1",
    cx: 1115.508,
    cy: 3511.89,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0D7D37",
    cx: 1128.112,
    cy: 3522.654,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BFE1E5",
    cx: 1140.106,
    cy: 3532.898,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#554D93",
    cx: 1151.525,
    cy: 3542.651,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#15D51B",
    cx: 1162.398,
    cy: 3551.938,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6D117B",
    cx: 1172.752,
    cy: 3560.781,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#19F9FD",
    cx: 1182.611,
    cy: 3569.201,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4957E3",
    cx: 1191.994,
    cy: 3577.215,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79850F",
    cx: 1200.914,
    cy: 3584.833,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#059147",
    cx: 1209.38,
    cy: 3592.064,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#77E10F",
    cx: 1217.458,
    cy: 3598.963,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#43D921",
    cx: 1225.156,
    cy: 3605.539,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F4F31",
    cx: 1232.473,
    cy: 3611.787,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ED2755",
    cx: 1239.418,
    cy: 3617.719,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F1DFB",
    cx: 1246.053,
    cy: 3623.386,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4B1D6F",
    cx: 1252.362,
    cy: 3628.774,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FB1F19",
    cx: 1258.347,
    cy: 3633.886,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6FB1AB",
    cx: 1264.136,
    cy: 3638.83,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#49F1CB",
    cx: 1269.891,
    cy: 3643.745,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EF0577",
    cx: 1275.645,
    cy: 3648.659,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D9C521",
    cx: 1281.392,
    cy: 3653.568,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D8F93",
    cx: 1287.148,
    cy: 3658.484,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2F77EF",
    cx: 1292.898,
    cy: 3663.396,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#192D33",
    cx: 1298.653,
    cy: 3668.311,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7B913",
    cx: 1304.404,
    cy: 3673.222,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5D59D3",
    cx: 1310.161,
    cy: 3678.139,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#91B7F1",
    cx: 1315.91,
    cy: 3683.049,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C15F89",
    cx: 1321.662,
    cy: 3687.962,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#05EBCF",
    cx: 1327.419,
    cy: 3692.879,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#95A95F",
    cx: 1333.176,
    cy: 3697.796,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2F5D35",
    cx: 1338.933,
    cy: 3702.713,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A7B575",
    cx: 1344.686,
    cy: 3707.626,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7F5397",
    cx: 1350.442,
    cy: 3712.542,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#252F1F",
    cx: 1356.189,
    cy: 3717.451,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#434113",
    cx: 1361.947,
    cy: 3722.368,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AD4D6F",
    cx: 1367.706,
    cy: 3727.287,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B3756D",
    cx: 1372.98,
    cy: 3731.792,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#595B93",
    cx: 38.124,
    cy: 2397.885,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D5E999",
    cx: 96.884,
    cy: 2456.645,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#01E13F",
    cx: 154.246,
    cy: 2514.007,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#99DFCF",
    cx: 208.867,
    cy: 2568.628,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B9CD03",
    cx: 260.836,
    cy: 2620.597,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A183B9",
    cx: 310.296,
    cy: 2670.056,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AB6DA7",
    cx: 357.359,
    cy: 2717.119,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B30D79",
    cx: 402.154,
    cy: 2761.915,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2B8377",
    cx: 444.787,
    cy: 2804.547,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#970959",
    cx: 485.353,
    cy: 2845.113,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A5A36F",
    cx: 523.928,
    cy: 2883.688,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C5BF55",
    cx: 560.64,
    cy: 2920.4,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0961A5",
    cx: 595.586,
    cy: 2955.347,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EDB31F",
    cx: 628.85,
    cy: 2988.61,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#973513",
    cx: 660.504,
    cy: 3020.264,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#99377F",
    cx: 690.628,
    cy: 3050.388,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#13132F",
    cx: 719.294,
    cy: 3079.055,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E17125",
    cx: 746.57,
    cy: 3106.33,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0D77A5",
    cx: 772.529,
    cy: 3132.29,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BB07CD",
    cx: 797.246,
    cy: 3157.007,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#37E53F",
    cx: 820.752,
    cy: 3180.512,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E9CF83",
    cx: 843.117,
    cy: 3202.878,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3F5F93",
    cx: 864.405,
    cy: 3224.165,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#099FBD",
    cx: 884.657,
    cy: 3244.418,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#67F3E5",
    cx: 903.933,
    cy: 3263.693,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A153E7",
    cx: 922.279,
    cy: 3282.039,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A5F7DB",
    cx: 939.725,
    cy: 3299.485,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#71F521",
    cx: 956.334,
    cy: 3316.094,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2DDF65",
    cx: 972.146,
    cy: 3331.906,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FB05C7",
    cx: 987.192,
    cy: 3346.953,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9B8F5B",
    cx: 1001.505,
    cy: 3361.266,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4BABF5",
    cx: 1015.119,
    cy: 3374.879,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#256785",
    cx: 1028.067,
    cy: 3387.828,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5517BF",
    cx: 1040.384,
    cy: 3400.145,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7FCBFF",
    cx: 1052.104,
    cy: 3411.865,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#23BFB7",
    cx: 1063.258,
    cy: 3423.018,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CBEFE3",
    cx: 1073.876,
    cy: 3433.637,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F5714B",
    cx: 1083.987,
    cy: 3443.748,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AF99ED",
    cx: 1093.616,
    cy: 3453.376,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A19145",
    cx: 1102.784,
    cy: 3462.544,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#353DCF",
    cx: 1111.508,
    cy: 3471.269,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FBD9E3",
    cx: 1119.803,
    cy: 3479.564,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9D076D",
    cx: 1127.676,
    cy: 3487.437,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E339C3",
    cx: 1135.188,
    cy: 3494.949,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7CD25",
    cx: 1142.347,
    cy: 3502.107,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3DE17B",
    cx: 1149.151,
    cy: 3508.911,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C54137",
    cx: 1155.609,
    cy: 3515.369,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#23A73F",
    cx: 1161.779,
    cy: 3521.539,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8DF1B3",
    cx: 1167.646,
    cy: 3527.406,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6F1199",
    cx: 1173.211,
    cy: 3532.972,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CDB911",
    cx: 1178.594,
    cy: 3538.354,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#49611D",
    cx: 1183.946,
    cy: 3543.706,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#59EB0B",
    cx: 1189.296,
    cy: 3549.057,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C7F3C3",
    cx: 1194.641,
    cy: 3554.401,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B143FB",
    cx: 1199.993,
    cy: 3559.753,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EFD3E7",
    cx: 1205.34,
    cy: 3565.101,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A76527",
    cx: 1210.692,
    cy: 3570.453,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ED1F13",
    cx: 1216.04,
    cy: 3575.8,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#15BB3F",
    cx: 1221.393,
    cy: 3581.153,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9FF971",
    cx: 1226.739,
    cy: 3586.5,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#81A783",
    cx: 1232.088,
    cy: 3591.849,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A785A5",
    cx: 1237.441,
    cy: 3597.202,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8B8DB5",
    cx: 1242.795,
    cy: 3602.556,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1153AD",
    cx: 1248.149,
    cy: 3607.909,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8F1DE7",
    cx: 1253.498,
    cy: 3613.258,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6DF9DB",
    cx: 1258.85,
    cy: 3618.611,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#935771",
    cx: 1264.195,
    cy: 3623.956,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#930F3F",
    cx: 1269.549,
    cy: 3629.309,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CB2573",
    cx: 1274.904,
    cy: 3634.665,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E56DA1",
    cx: 1279.809,
    cy: 3639.57,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#056945",
    cx: 53.725,
    cy: 2205.043,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79A973",
    cx: 107.694,
    cy: 2268.232,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2BB587",
    cx: 160.378,
    cy: 2329.918,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0BF3AB",
    cx: 210.546,
    cy: 2388.656,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#47B371",
    cx: 258.277,
    cy: 2444.542,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DB7F31",
    cx: 303.703,
    cy: 2497.73,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1311DD",
    cx: 346.929,
    cy: 2548.34,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0D004D",
    cx: 388.071,
    cy: 2596.512,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDCD81",
    cx: 427.228,
    cy: 2642.358,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B1775",
    cx: 464.486,
    cy: 2685.982,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EDD9E3",
    cx: 499.916,
    cy: 2727.465,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#63954B",
    cx: 533.634,
    cy: 2766.944,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2F5FF9",
    cx: 565.731,
    cy: 2804.525,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D309BF",
    cx: 596.282,
    cy: 2840.295,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B14161",
    cx: 625.355,
    cy: 2874.335,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D173C5",
    cx: 653.022,
    cy: 2906.73,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#43004D",
    cx: 679.351,
    cy: 2937.557,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0BF94B",
    cx: 704.403,
    cy: 2966.888,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D18F0D",
    cx: 728.246,
    cy: 2994.805,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8B2D91",
    cx: 750.947,
    cy: 3021.385,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7DD5DF",
    cx: 772.536,
    cy: 3046.662,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#27F50F",
    cx: 793.078,
    cy: 3070.713,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#91DF65",
    cx: 812.629,
    cy: 3093.606,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E75BEF",
    cx: 831.231,
    cy: 3115.385,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#871377",
    cx: 848.934,
    cy: 3136.113,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B07DD",
    cx: 865.784,
    cy: 3155.842,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#717BAD",
    cx: 881.807,
    cy: 3174.603,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F92D51",
    cx: 897.062,
    cy: 3192.464,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#71B94F",
    cx: 911.585,
    cy: 3209.468,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6DC7A5",
    cx: 925.404,
    cy: 3225.648,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D967C5",
    cx: 938.55,
    cy: 3241.04,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#610387",
    cx: 951.054,
    cy: 3255.68,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2FE1D5",
    cx: 962.946,
    cy: 3269.604,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DD2F77",
    cx: 974.259,
    cy: 3282.85,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4B598B",
    cx: 985.023,
    cy: 3295.453,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2DEB71",
    cx: 995.268,
    cy: 3307.448,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#55839B",
    cx: 1005.02,
    cy: 3318.866,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DF7323",
    cx: 1014.307,
    cy: 3329.74,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2D4369",
    cx: 1023.15,
    cy: 3340.094,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3597D5",
    cx: 1031.57,
    cy: 3349.953,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A90FD7",
    cx: 1039.584,
    cy: 3359.335,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D315C3",
    cx: 1047.202,
    cy: 3368.255,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#65A3A3",
    cx: 1054.433,
    cy: 3376.721,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7DA3DD",
    cx: 1061.333,
    cy: 3384.8,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C137AB",
    cx: 1067.908,
    cy: 3392.498,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E93100",
    cx: 1074.156,
    cy: 3399.814,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#19975F",
    cx: 1080.088,
    cy: 3406.76,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4581B5",
    cx: 1085.755,
    cy: 3413.395,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#876F79",
    cx: 1091.143,
    cy: 3419.704,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#73A975",
    cx: 1096.255,
    cy: 3425.689,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6F2F7D",
    cx: 1101.199,
    cy: 3431.477,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AB4F09",
    cx: 1106.114,
    cy: 3437.232,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#395F1F",
    cx: 1111.029,
    cy: 3442.986,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#637339",
    cx: 1115.937,
    cy: 3448.733,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A94111",
    cx: 1120.853,
    cy: 3454.489,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1F0D8F",
    cx: 1125.764,
    cy: 3460.24,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#45F745",
    cx: 1130.68,
    cy: 3465.995,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8DCBBB",
    cx: 1135.591,
    cy: 3471.746,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#33A313",
    cx: 1140.508,
    cy: 3477.502,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DB0589",
    cx: 1145.418,
    cy: 3483.251,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C9EB2D",
    cx: 1150.331,
    cy: 3489.004,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0BDF5B",
    cx: 1155.248,
    cy: 3494.76,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B52F09",
    cx: 1160.165,
    cy: 3500.518,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5FB761",
    cx: 1165.082,
    cy: 3506.275,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F9F3A7",
    cx: 1169.995,
    cy: 3512.027,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F83B9",
    cx: 1174.911,
    cy: 3517.783,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79B71B",
    cx: 1179.82,
    cy: 3523.531,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#85932D",
    cx: 1184.737,
    cy: 3529.288,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1D5F2F",
    cx: 1189.656,
    cy: 3535.047,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#03D7A7",
    cx: 1194.161,
    cy: 3540.322,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ED2D15",
    cx: 84.409,
    cy: 2014.02,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8FCD4D",
    cx: 133.253,
    cy: 2081.249,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F71F9F",
    cx: 180.935,
    cy: 2146.877,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E94D57",
    cx: 226.339,
    cy: 2209.371,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#499B21",
    cx: 269.539,
    cy: 2268.83,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E9397F",
    cx: 310.652,
    cy: 2325.417,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BB7F11",
    cx: 349.774,
    cy: 2379.263,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D1873B",
    cx: 387.01,
    cy: 2430.514,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A31137",
    cx: 422.449,
    cy: 2479.292,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#35A761",
    cx: 456.169,
    cy: 2525.704,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BBE797",
    cx: 488.235,
    cy: 2569.839,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B1C5D3",
    cx: 518.752,
    cy: 2611.842,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#77AF9B",
    cx: 547.801,
    cy: 2651.825,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E3F951",
    cx: 575.451,
    cy: 2689.882,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F35FEB",
    cx: 601.764,
    cy: 2726.099,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9BEBE1",
    cx: 626.805,
    cy: 2760.564,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8D01F7",
    cx: 650.634,
    cy: 2793.362,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#413BCF",
    cx: 673.307,
    cy: 2824.568,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#557733",
    cx: 694.886,
    cy: 2854.27,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6BA91D",
    cx: 715.432,
    cy: 2882.549,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#137DBD",
    cx: 734.971,
    cy: 2909.442,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C7F7ED",
    cx: 753.562,
    cy: 2935.031,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9D1B0F",
    cx: 771.258,
    cy: 2959.386,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#952DB5",
    cx: 788.093,
    cy: 2982.558,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#49571B",
    cx: 804.115,
    cy: 3004.611,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CB157D",
    cx: 819.365,
    cy: 3025.601,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#010D59",
    cx: 833.867,
    cy: 3045.562,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DB2F5B",
    cx: 847.674,
    cy: 3064.564,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CF2745",
    cx: 860.818,
    cy: 3082.655,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4B8939",
    cx: 873.325,
    cy: 3099.87,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B5BF49",
    cx: 885.223,
    cy: 3116.246,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EF25A5",
    cx: 896.539,
    cy: 3131.822,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0DC33B",
    cx: 907.303,
    cy: 3146.636,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EF5583",
    cx: 917.541,
    cy: 3160.728,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1F532D",
    cx: 927.283,
    cy: 3174.137,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2BB5AB",
    cx: 936.555,
    cy: 3186.899,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#099D7B",
    cx: 945.381,
    cy: 3199.047,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B97DFF",
    cx: 953.786,
    cy: 3210.615,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FB8755",
    cx: 961.79,
    cy: 3221.632,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F7107",
    cx: 969.411,
    cy: 3232.121,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#71A3F1",
    cx: 976.663,
    cy: 3242.103,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D7631D",
    cx: 983.558,
    cy: 3251.593,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#01033F",
    cx: 990.103,
    cy: 3260.601,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B2D07",
    cx: 996.347,
    cy: 3269.196,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9BF3A5",
    cx: 1002.298,
    cy: 3277.386,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#41A9DF",
    cx: 1007.953,
    cy: 3285.17,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#551FD5",
    cx: 1013.322,
    cy: 3292.559,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#092B7D",
    cx: 1018.451,
    cy: 3299.619,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6D5B63",
    cx: 1023.328,
    cy: 3306.331,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A7494B",
    cx: 1027.954,
    cy: 3312.699,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F9B23",
    cx: 1032.428,
    cy: 3318.857,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#011FFD",
    cx: 1036.877,
    cy: 3324.98,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9D2BC7",
    cx: 1041.325,
    cy: 3331.102,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4555E5",
    cx: 1045.767,
    cy: 3337.217,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F9BDD",
    cx: 1050.216,
    cy: 3343.34,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4BEB25",
    cx: 1054.661,
    cy: 3349.458,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C90BB3",
    cx: 1059.11,
    cy: 3355.582,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0F5D83",
    cx: 1063.556,
    cy: 3361.7,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ED99EF",
    cx: 1068.005,
    cy: 3367.824,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#274363",
    cx: 1072.449,
    cy: 3373.941,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A33BE1",
    cx: 1076.896,
    cy: 3380.061,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B5E7F1",
    cx: 1081.345,
    cy: 3386.186,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#371DE3",
    cx: 1085.796,
    cy: 3392.311,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EB0B2F",
    cx: 1090.246,
    cy: 3398.436,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#27DDF3",
    cx: 1094.693,
    cy: 3404.556,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CD73CD",
    cx: 1099.142,
    cy: 3410.68,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#777F55",
    cx: 1103.585,
    cy: 3416.796,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C59927",
    cx: 1108.035,
    cy: 3422.921,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C19163",
    cx: 1112.487,
    cy: 3429.048,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B9DC9",
    cx: 1116.564,
    cy: 3434.66,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5953C7",
    cx: 129.984,
    cy: 1825.993,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8D9701",
    cx: 173.404,
    cy: 1896.846,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AF4BCD",
    cx: 215.79,
    cy: 1966.014,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BBD3C5",
    cx: 256.151,
    cy: 2031.877,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0329F3",
    cx: 294.552,
    cy: 2094.542,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FDFD9F",
    cx: 331.098,
    cy: 2154.181,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#33F72B",
    cx: 365.875,
    cy: 2210.931,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ED2D4D",
    cx: 398.975,
    cy: 2264.945,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#03197D",
    cx: 430.477,
    cy: 2316.353,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#89AB4B",
    cx: 460.452,
    cy: 2365.267,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4DBB6F",
    cx: 488.957,
    cy: 2411.782,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C30967",
    cx: 516.084,
    cy: 2456.05,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0DDB63",
    cx: 541.907,
    cy: 2498.189,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FB5175",
    cx: 566.486,
    cy: 2538.298,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#81A589",
    cx: 589.876,
    cy: 2576.468,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2B6527",
    cx: 612.135,
    cy: 2612.791,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#91097D",
    cx: 633.318,
    cy: 2647.358,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#111F77",
    cx: 653.472,
    cy: 2680.247,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8BA15B",
    cx: 672.654,
    cy: 2711.55,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#71E505",
    cx: 690.918,
    cy: 2741.354,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#990B37",
    cx: 708.287,
    cy: 2769.697,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B4DF3",
    cx: 724.813,
    cy: 2796.665,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C783BF",
    cx: 740.543,
    cy: 2822.334,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#53FB47",
    cx: 755.508,
    cy: 2846.755,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FB0FA1",
    cx: 769.752,
    cy: 2869.998,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6BE35D",
    cx: 783.308,
    cy: 2892.12,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7F359",
    cx: 796.199,
    cy: 2913.156,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D15B3B",
    cx: 808.472,
    cy: 2933.184,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#59A3F1",
    cx: 820.156,
    cy: 2952.25,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#958BCB",
    cx: 831.274,
    cy: 2970.393,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#05ED85",
    cx: 841.85,
    cy: 2987.652,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1BED3F",
    cx: 851.91,
    cy: 3004.068,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D5132B",
    cx: 861.477,
    cy: 3019.681,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#23E547",
    cx: 870.579,
    cy: 3034.533,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8DFBA5",
    cx: 879.239,
    cy: 3048.665,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B18733",
    cx: 887.481,
    cy: 3062.114,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5BA16D",
    cx: 895.327,
    cy: 3074.918,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#27DF8F",
    cx: 902.798,
    cy: 3087.11,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#99F323",
    cx: 909.913,
    cy: 3098.72,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EFEFCD",
    cx: 916.687,
    cy: 3109.775,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5983DD",
    cx: 923.134,
    cy: 3120.296,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D3E1F1",
    cx: 929.263,
    cy: 3130.297,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7BB5CD",
    cx: 935.081,
    cy: 3139.791,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3DB7B1",
    cx: 940.632,
    cy: 3148.849,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F91D5B",
    cx: 945.922,
    cy: 3157.481,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#558BB1",
    cx: 950.949,
    cy: 3165.685,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#43F573",
    cx: 955.721,
    cy: 3173.472,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EF4DD1",
    cx: 960.28,
    cy: 3180.912,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E5D9E1",
    cx: 964.615,
    cy: 3187.987,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#57697D",
    cx: 968.728,
    cy: 3194.698,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F155C7",
    cx: 972.705,
    cy: 3201.188,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8D9583",
    cx: 976.66,
    cy: 3207.641,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EDB1BD",
    cx: 980.614,
    cy: 3214.093,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#71995B",
    cx: 984.563,
    cy: 3220.538,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#451DBD",
    cx: 988.518,
    cy: 3226.991,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#67BF61",
    cx: 992.469,
    cy: 3233.44,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#074F2B",
    cx: 996.423,
    cy: 3239.893,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#672769",
    cx: 1000.375,
    cy: 3246.341,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#13417F",
    cx: 1004.331,
    cy: 3252.796,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B94D5F",
    cx: 1008.281,
    cy: 3259.242,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1DB1E3",
    cx: 1012.234,
    cy: 3265.693,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1BBD3B",
    cx: 1016.189,
    cy: 3272.147,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E96B51",
    cx: 1020.145,
    cy: 3278.603,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EF55CD",
    cx: 1024.101,
    cy: 3285.059,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#375BC1",
    cx: 1028.054,
    cy: 3291.509,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#875DCB",
    cx: 1032.009,
    cy: 3297.963,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0DAD9F",
    cx: 1035.958,
    cy: 3304.408,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#673FFD",
    cx: 1039.914,
    cy: 3310.863,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C1716B",
    cx: 1043.871,
    cy: 3317.321,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#630F95",
    cx: 1047.496,
    cy: 3323.235,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DBBD5D",
    cx: 190.172,
    cy: 1642.121,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CF7925",
    cx: 227.899,
    cy: 1716.163,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E75523",
    cx: 264.727,
    cy: 1788.443,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B50BD7",
    cx: 299.796,
    cy: 1857.27,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#93A7C3",
    cx: 333.162,
    cy: 1922.755,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C7B105",
    cx: 364.917,
    cy: 1985.077,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EF7FFB",
    cx: 395.134,
    cy: 2044.38,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C5BF1B",
    cx: 423.894,
    cy: 2100.825,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#89D569",
    cx: 451.266,
    cy: 2154.546,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DF074F",
    cx: 477.311,
    cy: 2205.662,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BFE919",
    cx: 502.078,
    cy: 2254.27,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5D9195",
    cx: 525.648,
    cy: 2300.529,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#17F921",
    cx: 548.085,
    cy: 2344.564,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1BB7B3",
    cx: 569.441,
    cy: 2386.479,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6393D1",
    cx: 589.765,
    cy: 2426.365,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A3F711",
    cx: 609.106,
    cy: 2464.323,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DD97BB",
    cx: 627.51,
    cy: 2500.446,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C72B2B",
    cx: 645.022,
    cy: 2534.814,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#675399",
    cx: 661.69,
    cy: 2567.526,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#496543",
    cx: 677.559,
    cy: 2598.671,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2DED7D",
    cx: 692.65,
    cy: 2628.289,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#53E92D",
    cx: 707.01,
    cy: 2656.471,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1BA317",
    cx: 720.677,
    cy: 2683.295,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2F155D",
    cx: 733.68,
    cy: 2708.815,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B3F9E1",
    cx: 746.056,
    cy: 2733.104,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BDDB23",
    cx: 757.835,
    cy: 2756.221,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8BA791",
    cx: 769.036,
    cy: 2778.204,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E1B5D1",
    cx: 779.699,
    cy: 2799.133,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#25A581",
    cx: 789.851,
    cy: 2819.057,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#217B45",
    cx: 799.512,
    cy: 2838.016,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D79FAD",
    cx: 808.701,
    cy: 2856.052,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D9BFCB",
    cx: 817.442,
    cy: 2873.206,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D36D9B",
    cx: 825.755,
    cy: 2889.522,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#57E33F",
    cx: 833.663,
    cy: 2905.042,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#91893B",
    cx: 841.188,
    cy: 2919.81,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#01A565",
    cx: 848.349,
    cy: 2933.865,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A5EDC3",
    cx: 855.166,
    cy: 2947.245,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#21AD57",
    cx: 861.658,
    cy: 2959.985,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#89BF79",
    cx: 867.84,
    cy: 2972.118,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CD51E5",
    cx: 873.726,
    cy: 2983.67,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#03BB57",
    cx: 879.327,
    cy: 2994.664,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D21A3",
    cx: 884.653,
    cy: 3005.116,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B54D89",
    cx: 889.708,
    cy: 3015.036,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D7A191",
    cx: 894.531,
    cy: 3024.502,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FDAB77",
    cx: 899.127,
    cy: 3033.523,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F155DB",
    cx: 903.495,
    cy: 3042.096,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AB93F1",
    cx: 907.642,
    cy: 3050.234,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#57A933",
    cx: 911.603,
    cy: 3058.009,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D501BB",
    cx: 915.37,
    cy: 3065.401,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B135C5",
    cx: 918.943,
    cy: 3072.414,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0FD53F",
    cx: 922.399,
    cy: 3079.197,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D101CB",
    cx: 925.835,
    cy: 3085.94,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DD9189",
    cx: 929.27,
    cy: 3092.682,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1F47D5",
    cx: 932.702,
    cy: 3099.417,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A98D75",
    cx: 936.138,
    cy: 3106.161,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#57772F",
    cx: 939.571,
    cy: 3112.899,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#05B3FD",
    cx: 943.007,
    cy: 3119.643,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D7DFD1",
    cx: 946.441,
    cy: 3126.381,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3727E3",
    cx: 949.878,
    cy: 3133.126,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5DDB9F",
    cx: 953.31,
    cy: 3139.863,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#31F9EB",
    cx: 956.745,
    cy: 3146.604,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7125FB",
    cx: 960.181,
    cy: 3153.349,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#47358B",
    cx: 963.619,
    cy: 3160.095,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B52F49",
    cx: 967.056,
    cy: 3166.841,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#070DF5",
    cx: 970.49,
    cy: 3173.581,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#33AB99",
    cx: 973.927,
    cy: 3180.326,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E3150D",
    cx: 977.358,
    cy: 3187.061,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#218903",
    cx: 980.796,
    cy: 3193.807,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A913B3",
    cx: 984.234,
    cy: 3200.555,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#574BDB",
    cx: 987.383,
    cy: 3206.735,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3DA757",
    cx: 264.601,
    cy: 1463.539,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6F4915",
    cx: 296.402,
    cy: 1540.312,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B9AF21",
    cx: 327.446,
    cy: 1615.259,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AB516D",
    cx: 357.007,
    cy: 1686.625,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AD457B",
    cx: 385.132,
    cy: 1754.526,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9D7F9D",
    cx: 411.899,
    cy: 1819.148,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E3BD53",
    cx: 437.37,
    cy: 1880.639,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ED376B",
    cx: 461.613,
    cy: 1939.166,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B5701",
    cx: 484.685,
    cy: 1994.869,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A33F73",
    cx: 506.639,
    cy: 2047.871,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4F57F5",
    cx: 527.516,
    cy: 2098.272,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2D2BD3",
    cx: 547.384,
    cy: 2146.238,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B2BBB",
    cx: 566.297,
    cy: 2191.898,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#532367",
    cx: 584.299,
    cy: 2235.359,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#21A177",
    cx: 601.431,
    cy: 2276.717,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CF3FFD",
    cx: 617.734,
    cy: 2316.076,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#21152D",
    cx: 633.248,
    cy: 2353.53,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9D27CD",
    cx: 648.009,
    cy: 2389.167,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#91930D",
    cx: 662.058,
    cy: 2423.085,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0565E9",
    cx: 675.435,
    cy: 2455.379,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#23F7B3",
    cx: 688.156,
    cy: 2486.09,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1D9D13",
    cx: 700.26,
    cy: 2515.313,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#697B39",
    cx: 711.781,
    cy: 2543.126,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B3CD8F",
    cx: 722.742,
    cy: 2569.587,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B7372D",
    cx: 733.173,
    cy: 2594.772,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E34F83",
    cx: 743.102,
    cy: 2618.742,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ED5D7B",
    cx: 752.544,
    cy: 2641.536,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A745B7",
    cx: 761.533,
    cy: 2663.237,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ED0D81",
    cx: 770.09,
    cy: 2683.897,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D1FB19",
    cx: 778.233,
    cy: 2703.556,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B1CFBD",
    cx: 785.979,
    cy: 2722.257,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CD3D27",
    cx: 793.347,
    cy: 2740.044,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EF3D89",
    cx: 800.354,
    cy: 2756.961,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A74F8B",
    cx: 807.02,
    cy: 2773.054,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F3AB4D",
    cx: 813.363,
    cy: 2788.367,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#331185",
    cx: 819.399,
    cy: 2802.94,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F13121",
    cx: 825.146,
    cy: 2816.814,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8B8347",
    cx: 830.618,
    cy: 2830.024,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#39BD35",
    cx: 835.829,
    cy: 2842.605,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1D9DDD",
    cx: 840.791,
    cy: 2854.583,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F5CBEB",
    cx: 845.512,
    cy: 2865.983,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BF3765",
    cx: 850.001,
    cy: 2876.82,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#135319",
    cx: 854.262,
    cy: 2887.106,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2D7941",
    cx: 858.328,
    cy: 2896.922,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EDB19D",
    cx: 862.202,
    cy: 2906.275,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0343EF",
    cx: 865.884,
    cy: 2915.164,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#85E999",
    cx: 869.379,
    cy: 2923.603,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#930915",
    cx: 872.719,
    cy: 2931.664,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D97DDF",
    cx: 875.894,
    cy: 2939.329,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2F792B",
    cx: 878.906,
    cy: 2946.601,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4FD763",
    cx: 881.819,
    cy: 2953.634,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D1BF11",
    cx: 884.715,
    cy: 2960.626,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E3F5E5",
    cx: 887.611,
    cy: 2967.617,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B3817F",
    cx: 890.503,
    cy: 2974.6,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#23EFF5",
    cx: 893.4,
    cy: 2981.593,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EF1967",
    cx: 896.294,
    cy: 2988.58,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2F4FE5",
    cx: 899.19,
    cy: 2995.572,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C9E303",
    cx: 902.084,
    cy: 3002.559,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#61C95F",
    cx: 904.981,
    cy: 3009.553,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DD2967",
    cx: 907.875,
    cy: 3016.539,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CBE781",
    cx: 910.77,
    cy: 3023.528,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C529F1",
    cx: 913.667,
    cy: 3030.522,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C7D300",
    cx: 916.564,
    cy: 3037.517,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#99BDD7",
    cx: 919.462,
    cy: 3044.512,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C98DC9",
    cx: 922.357,
    cy: 3051.501,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C3F15F",
    cx: 925.253,
    cy: 3058.494,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#09A5EF",
    cx: 928.146,
    cy: 3065.478,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0DE5E3",
    cx: 931.043,
    cy: 3072.472,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#172383",
    cx: 933.942,
    cy: 3079.469,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8B135B",
    cx: 936.596,
    cy: 3085.878,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#57E7F7",
    cx: 352.812,
    cy: 1291.346,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#53591D",
    cx: 378.491,
    cy: 1370.379,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7FF595",
    cx: 403.559,
    cy: 1447.53,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DD39D9",
    cx: 427.43,
    cy: 1520.995,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5B0331",
    cx: 450.141,
    cy: 1590.893,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3543EF",
    cx: 471.756,
    cy: 1657.416,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4BCB81",
    cx: 492.323,
    cy: 1720.716,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F12563",
    cx: 511.899,
    cy: 1780.965,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5B1907",
    cx: 530.53,
    cy: 1838.307,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#739D83",
    cx: 548.258,
    cy: 1892.867,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D3B38F",
    cx: 565.116,
    cy: 1944.751,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EBFBDB",
    cx: 581.16,
    cy: 1994.128,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#911F17",
    cx: 596.432,
    cy: 2041.131,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7BF3D3",
    cx: 610.969,
    cy: 2085.87,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1FE3C5",
    cx: 624.802,
    cy: 2128.445,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EBED3F",
    cx: 637.967,
    cy: 2168.962,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1FC965",
    cx: 650.495,
    cy: 2207.518,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#53A913",
    cx: 662.414,
    cy: 2244.203,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C5593D",
    cx: 673.759,
    cy: 2279.119,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2B0D9D",
    cx: 684.561,
    cy: 2312.363,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F5D161",
    cx: 694.833,
    cy: 2343.978,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ADCF8B",
    cx: 704.607,
    cy: 2374.06,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9D7FF3",
    cx: 713.91,
    cy: 2402.691,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8577B5",
    cx: 722.761,
    cy: 2429.931,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#47CF05",
    cx: 731.185,
    cy: 2455.857,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#494D7F",
    cx: 739.202,
    cy: 2480.532,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B59D8F",
    cx: 746.826,
    cy: 2503.996,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79E9FD",
    cx: 754.085,
    cy: 2526.336,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AD973B",
    cx: 760.995,
    cy: 2547.603,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3D5B15",
    cx: 767.57,
    cy: 2567.84,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8F95A9",
    cx: 773.825,
    cy: 2587.091,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#33B91D",
    cx: 779.775,
    cy: 2605.402,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#25490D",
    cx: 785.433,
    cy: 2622.817,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1F85BF",
    cx: 790.816,
    cy: 2639.383,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CDE315",
    cx: 795.938,
    cy: 2655.146,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F58935",
    cx: 800.812,
    cy: 2670.148,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#419B15",
    cx: 805.453,
    cy: 2684.43,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3DF331",
    cx: 809.871,
    cy: 2698.029,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#33D97F",
    cx: 814.079,
    cy: 2710.98,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5B5F5B",
    cx: 818.086,
    cy: 2723.311,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D9F3A9",
    cx: 821.898,
    cy: 2735.045,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B7D9D",
    cx: 825.523,
    cy: 2746.201,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8FA123",
    cx: 828.964,
    cy: 2756.79,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6F5387",
    cx: 832.247,
    cy: 2766.894,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B375BF",
    cx: 835.375,
    cy: 2776.523,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3BF331",
    cx: 838.349,
    cy: 2785.674,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7F3107",
    cx: 841.171,
    cy: 2794.36,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#99D7E7",
    cx: 843.867,
    cy: 2802.659,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#314F03",
    cx: 846.431,
    cy: 2810.549,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B39F83",
    cx: 848.864,
    cy: 2818.035,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9BDB7D",
    cx: 851.216,
    cy: 2825.275,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D999B9",
    cx: 853.555,
    cy: 2832.473,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A97BA7",
    cx: 855.893,
    cy: 2839.669,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#11B351",
    cx: 858.229,
    cy: 2846.858,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E3DFBF",
    cx: 860.568,
    cy: 2854.056,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2791C9",
    cx: 862.904,
    cy: 2861.249,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#85E569",
    cx: 865.243,
    cy: 2868.447,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F6DB9",
    cx: 867.58,
    cy: 2875.639,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E78B55",
    cx: 869.92,
    cy: 2882.839,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D3301",
    cx: 872.256,
    cy: 2890.03,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#257919",
    cx: 874.594,
    cy: 2897.225,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#85097D",
    cx: 876.933,
    cy: 2904.424,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C18FC1",
    cx: 879.273,
    cy: 2911.625,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5FE993",
    cx: 881.612,
    cy: 2918.826,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8947D1",
    cx: 883.95,
    cy: 2926.02,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EBA929",
    cx: 886.289,
    cy: 2933.219,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#51392F",
    cx: 888.625,
    cy: 2940.408,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F2F07",
    cx: 890.965,
    cy: 2947.609,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4729D3",
    cx: 893.305,
    cy: 2954.812,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AD5F3D",
    cx: 895.448,
    cy: 2961.409,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#13CDAF",
    cx: 454.261,
    cy: 1126.606,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9DB36F",
    cx: 473.66,
    cy: 1207.409,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#877BC5",
    cx: 492.598,
    cy: 1286.29,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B41E1",
    cx: 510.63,
    cy: 1361.401,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#034181",
    cx: 527.788,
    cy: 1432.866,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6FEBB9",
    cx: 544.116,
    cy: 1500.879,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0D2109",
    cx: 559.654,
    cy: 1565.598,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DFF1A1",
    cx: 574.442,
    cy: 1627.197,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ABAB43",
    cx: 588.517,
    cy: 1685.823,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F95513",
    cx: 601.91,
    cy: 1741.607,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FF315F",
    cx: 614.645,
    cy: 1794.654,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4DAB67",
    cx: 626.765,
    cy: 1845.137,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#61D1C3",
    cx: 638.302,
    cy: 1893.194,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B339C1",
    cx: 649.284,
    cy: 1938.935,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#293B59",
    cx: 659.734,
    cy: 1982.464,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79494B",
    cx: 669.68,
    cy: 2023.889,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0D0FCF",
    cx: 679.144,
    cy: 2063.309,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5DBDC5",
    cx: 688.148,
    cy: 2100.816,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DB5143",
    cx: 696.719,
    cy: 2136.515,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6BD1E1",
    cx: 704.879,
    cy: 2170.504,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#051DF9",
    cx: 712.639,
    cy: 2202.827,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7F3DFD",
    cx: 720.023,
    cy: 2233.583,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#25432F",
    cx: 727.051,
    cy: 2262.856,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F1BD91",
    cx: 733.737,
    cy: 2290.706,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4FE3DD",
    cx: 740.1,
    cy: 2317.213,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9119A5",
    cx: 746.157,
    cy: 2342.441,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DBF351",
    cx: 751.917,
    cy: 2366.431,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#654D3D",
    cx: 757.4,
    cy: 2389.271,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A1BBCF",
    cx: 762.62,
    cy: 2411.015,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#73A5DD",
    cx: 767.588,
    cy: 2431.706,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ED990D",
    cx: 772.313,
    cy: 2451.388,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CD3D33",
    cx: 776.808,
    cy: 2470.109,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FDC7D7",
    cx: 781.082,
    cy: 2487.915,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D11739",
    cx: 785.149,
    cy: 2504.852,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DB3165",
    cx: 789.018,
    cy: 2520.969,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AB634F",
    cx: 792.7,
    cy: 2536.307,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D38F95",
    cx: 796.206,
    cy: 2550.908,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D9A925",
    cx: 799.544,
    cy: 2564.813,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0B6553",
    cx: 802.723,
    cy: 2578.053,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5783B7",
    cx: 805.749,
    cy: 2590.66,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B573FB",
    cx: 808.63,
    cy: 2602.658,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7F19A5",
    cx: 811.368,
    cy: 2614.064,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C9D7C1",
    cx: 813.967,
    cy: 2624.891,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9D4B91",
    cx: 816.447,
    cy: 2635.221,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#15CF09",
    cx: 818.811,
    cy: 2645.065,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3963E3",
    cx: 821.057,
    cy: 2654.421,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#171BA1",
    cx: 823.189,
    cy: 2663.302,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#270BEB",
    cx: 825.226,
    cy: 2671.787,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#251709",
    cx: 827.163,
    cy: 2679.854,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C57941",
    cx: 829,
    cy: 2687.508,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A38353",
    cx: 830.778,
    cy: 2694.91,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4913BB",
    cx: 832.544,
    cy: 2702.269,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DB6375",
    cx: 834.311,
    cy: 2709.627,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#61C571",
    cx: 836.075,
    cy: 2716.976,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3515D7",
    cx: 837.842,
    cy: 2724.336,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#013DAD",
    cx: 839.608,
    cy: 2731.69,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#17BD15",
    cx: 841.374,
    cy: 2739.049,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#213F05",
    cx: 843.14,
    cy: 2746.403,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#738F9F",
    cx: 844.907,
    cy: 2753.764,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#19F9F3",
    cx: 846.672,
    cy: 2761.116,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#51CBF1",
    cx: 848.438,
    cy: 2768.472,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F9BB7",
    cx: 850.205,
    cy: 2775.833,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B317A7",
    cx: 851.973,
    cy: 2783.195,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#03BF89",
    cx: 853.74,
    cy: 2790.557,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#991D03",
    cx: 855.506,
    cy: 2797.913,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E739B1",
    cx: 857.273,
    cy: 2805.273,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5B235F",
    cx: 859.038,
    cy: 2812.624,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B9916F",
    cx: 860.806,
    cy: 2819.986,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AB7FBD",
    cx: 862.574,
    cy: 2827.35,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0B1BCD",
    cx: 864.193,
    cy: 2834.095,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B116F",
    cx: 568.323,
    cy: 970.333,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0BF1EF",
    cx: 581.322,
    cy: 1052.409,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FB1FF3",
    cx: 594.013,
    cy: 1132.532,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CDA751",
    cx: 606.096,
    cy: 1208.827,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8537B7",
    cx: 617.594,
    cy: 1281.418,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2FF1D5",
    cx: 628.536,
    cy: 1350.503,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D9EF00",
    cx: 638.948,
    cy: 1416.241,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#439331",
    cx: 648.858,
    cy: 1478.811,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#371F61",
    cx: 658.289,
    cy: 1538.36,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CD6DBB",
    cx: 667.264,
    cy: 1595.023,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2F03AB",
    cx: 675.798,
    cy: 1648.905,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#675FD5",
    cx: 683.92,
    cy: 1700.184,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CD6FBD",
    cx: 691.651,
    cy: 1748.997,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#15A53B",
    cx: 699.01,
    cy: 1795.46,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1FFB1D",
    cx: 706.013,
    cy: 1839.674,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FD15B5",
    cx: 712.677,
    cy: 1881.751,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B195EB",
    cx: 719.019,
    cy: 1921.793,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7FFBC5",
    cx: 725.053,
    cy: 1959.891,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EF097F",
    cx: 730.796,
    cy: 1996.152,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#63A52F",
    cx: 736.265,
    cy: 2030.676,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A9C943",
    cx: 741.465,
    cy: 2063.509,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8B35D9",
    cx: 746.413,
    cy: 2094.749,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#83FB03",
    cx: 751.122,
    cy: 2124.484,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3F1F5D",
    cx: 755.603,
    cy: 2152.772,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#610DED",
    cx: 759.867,
    cy: 2179.697,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#11DD2D",
    cx: 763.926,
    cy: 2205.322,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8F2B57",
    cx: 767.785,
    cy: 2229.69,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4BD7B7",
    cx: 771.46,
    cy: 2252.89,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B1498D",
    cx: 774.958,
    cy: 2274.977,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#21EB89",
    cx: 778.287,
    cy: 2295.993,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CDF38B",
    cx: 781.453,
    cy: 2315.986,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E93D47",
    cx: 784.465,
    cy: 2335.001,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D3E761",
    cx: 787.33,
    cy: 2353.088,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#651B41",
    cx: 790.054,
    cy: 2370.292,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7DA3A1",
    cx: 792.647,
    cy: 2386.662,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BB8993",
    cx: 795.115,
    cy: 2402.242,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#734905",
    cx: 797.464,
    cy: 2417.074,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0DDB31",
    cx: 799.701,
    cy: 2431.197,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F9F5C5",
    cx: 801.831,
    cy: 2444.646,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#553D69",
    cx: 803.859,
    cy: 2457.452,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B53FB",
    cx: 805.789,
    cy: 2469.638,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#45138B",
    cx: 807.624,
    cy: 2481.225,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AFC965",
    cx: 809.366,
    cy: 2492.221,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9FC319",
    cx: 811.028,
    cy: 2502.714,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#21CD71",
    cx: 812.612,
    cy: 2512.714,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F6FC9",
    cx: 814.117,
    cy: 2522.217,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9BB959",
    cx: 815.546,
    cy: 2531.238,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D13737",
    cx: 816.911,
    cy: 2539.856,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#43B76F",
    cx: 818.209,
    cy: 2548.051,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#458B5B",
    cx: 819.44,
    cy: 2555.825,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CF7937",
    cx: 820.631,
    cy: 2563.344,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F35B8F",
    cx: 821.815,
    cy: 2570.819,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D54DDF",
    cx: 822.998,
    cy: 2578.293,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E5753F",
    cx: 824.181,
    cy: 2585.758,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C159C7",
    cx: 825.365,
    cy: 2593.234,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B6951",
    cx: 826.548,
    cy: 2600.703,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AFFD9D",
    cx: 827.732,
    cy: 2608.178,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E35B85",
    cx: 828.915,
    cy: 2615.648,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#87F7C3",
    cx: 830.099,
    cy: 2623.125,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BD5F43",
    cx: 831.282,
    cy: 2630.593,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F19BB9",
    cx: 832.465,
    cy: 2638.065,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#516399",
    cx: 833.65,
    cy: 2645.542,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0FD311",
    cx: 834.834,
    cy: 2653.02,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DFD531",
    cx: 836.018,
    cy: 2660.498,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#77F33F",
    cx: 837.202,
    cy: 2667.969,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#75E3E3",
    cx: 838.386,
    cy: 2675.446,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6DFBD9",
    cx: 839.569,
    cy: 2682.912,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DB4547",
    cx: 840.753,
    cy: 2690.39,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CBFBEB",
    cx: 841.938,
    cy: 2697.87,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8517E3",
    cx: 843.023,
    cy: 2704.721,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EF7731",
    cx: 694.294,
    cy: 823.49,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BBDB2B",
    cx: 700.813,
    cy: 906.334,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EBBF89",
    cx: 707.178,
    cy: 987.205,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#65FF39",
    cx: 713.239,
    cy: 1064.213,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F77B3D",
    cx: 719.005,
    cy: 1137.482,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#892B59",
    cx: 724.493,
    cy: 1207.212,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#053335",
    cx: 729.715,
    cy: 1273.565,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8FF531",
    cx: 734.686,
    cy: 1336.719,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4381EF",
    cx: 739.416,
    cy: 1396.825,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3931A3",
    cx: 743.917,
    cy: 1454.017,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6F31CF",
    cx: 748.197,
    cy: 1508.403,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D51FAD",
    cx: 752.271,
    cy: 1560.161,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CD65AD",
    cx: 756.148,
    cy: 1609.431,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#693FA1",
    cx: 759.839,
    cy: 1656.327,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#51BFE1",
    cx: 763.352,
    cy: 1700.955,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0F7D2B",
    cx: 766.694,
    cy: 1743.425,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#171971",
    cx: 769.875,
    cy: 1783.841,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D5053F",
    cx: 772.901,
    cy: 1822.295,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D7B34B",
    cx: 775.782,
    cy: 1858.894,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#499BFB",
    cx: 778.524,
    cy: 1893.742,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#278F35",
    cx: 781.132,
    cy: 1926.881,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D1AB47",
    cx: 783.614,
    cy: 1958.413,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F1EB1F",
    cx: 785.976,
    cy: 1988.425,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#75A36D",
    cx: 788.223,
    cy: 2016.979,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E92701",
    cx: 790.362,
    cy: 2044.154,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FF252D",
    cx: 792.397,
    cy: 2070.019,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0B3D25",
    cx: 794.333,
    cy: 2094.615,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5D8B71",
    cx: 796.176,
    cy: 2118.032,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#951F63",
    cx: 797.931,
    cy: 2140.324,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DD67A9",
    cx: 799.6,
    cy: 2161.538,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D5638B",
    cx: 801.188,
    cy: 2181.717,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#419181",
    cx: 802.699,
    cy: 2200.91,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F12D2B",
    cx: 804.136,
    cy: 2219.166,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#131B1F",
    cx: 805.502,
    cy: 2236.531,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0197DB",
    cx: 806.803,
    cy: 2253.054,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F51D2F",
    cx: 808.04,
    cy: 2268.779,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DBC7B5",
    cx: 809.218,
    cy: 2283.75,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B70BEB",
    cx: 810.34,
    cy: 2298.005,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FB47CB",
    cx: 811.409,
    cy: 2311.58,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1D3DB1",
    cx: 812.426,
    cy: 2324.505,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BBAFBF",
    cx: 813.394,
    cy: 2336.805,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5D618D",
    cx: 814.314,
    cy: 2348.5,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B9A31D",
    cx: 815.188,
    cy: 2359.599,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F78D57",
    cx: 816.021,
    cy: 2370.19,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B37519",
    cx: 816.816,
    cy: 2380.283,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#63796D",
    cx: 817.571,
    cy: 2389.875,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6F93E9",
    cx: 818.287,
    cy: 2398.98,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CD9933",
    cx: 818.972,
    cy: 2407.679,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#27AF1B",
    cx: 819.623,
    cy: 2415.95,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E78757",
    cx: 820.24,
    cy: 2423.797,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4FD71D",
    cx: 820.838,
    cy: 2431.386,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1FB5F5",
    cx: 821.431,
    cy: 2438.931,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E55FE3",
    cx: 822.025,
    cy: 2446.475,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#297F7D",
    cx: 822.618,
    cy: 2454.01,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4F5977",
    cx: 823.212,
    cy: 2461.556,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#21A1F9",
    cx: 823.805,
    cy: 2469.095,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#93092D",
    cx: 824.399,
    cy: 2476.64,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#73A733",
    cx: 824.993,
    cy: 2484.179,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E5CB29",
    cx: 825.587,
    cy: 2491.726,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D9DFD9",
    cx: 826.18,
    cy: 2499.264,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#23F9E7",
    cx: 826.773,
    cy: 2506.805,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BF8DF7",
    cx: 827.367,
    cy: 2514.352,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#375D85",
    cx: 827.961,
    cy: 2521.9,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#89AFFB",
    cx: 828.555,
    cy: 2529.448,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9BDB65",
    cx: 829.149,
    cy: 2536.99,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#77D10F",
    cx: 829.743,
    cy: 2544.536,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B159E3",
    cx: 830.336,
    cy: 2552.072,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#074317",
    cx: 830.93,
    cy: 2559.619,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#29EBA3",
    cx: 831.524,
    cy: 2567.17,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C72107",
    cx: 832.068,
    cy: 2574.085,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#19A797",
    cx: 831.397,
    cy: 686.985,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C15DD9",
    cx: 831.397,
    cy: 770.084,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4F21DF",
    cx: 831.397,
    cy: 851.206,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#67AF35",
    cx: 831.397,
    cy: 928.452,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#07CF43",
    cx: 831.397,
    cy: 1001.947,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4B1B15",
    cx: 831.397,
    cy: 1071.893,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2B11EF",
    cx: 831.397,
    cy: 1138.451,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9B8559",
    cx: 831.397,
    cy: 1201.8,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8D3127",
    cx: 831.397,
    cy: 1262.093,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F59B0F",
    cx: 831.397,
    cy: 1319.461,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9D47D9",
    cx: 831.397,
    cy: 1374.015,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0BB37B",
    cx: 831.397,
    cy: 1425.933,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ED51B7",
    cx: 831.397,
    cy: 1475.355,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#39C321",
    cx: 831.397,
    cy: 1522.397,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F9C945",
    cx: 831.397,
    cy: 1567.162,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D95907",
    cx: 831.397,
    cy: 1609.764,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#834DDF",
    cx: 831.397,
    cy: 1650.305,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D10D99",
    cx: 831.397,
    cy: 1688.878,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C1B585",
    cx: 831.397,
    cy: 1725.59,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F25EB",
    cx: 831.397,
    cy: 1760.545,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5FA561",
    cx: 831.397,
    cy: 1793.787,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AB91A1",
    cx: 831.397,
    cy: 1825.417,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3FA7B3",
    cx: 831.397,
    cy: 1855.522,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5B0F63",
    cx: 831.397,
    cy: 1884.163,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#99E7E9",
    cx: 831.397,
    cy: 1911.423,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7B99DD",
    cx: 831.397,
    cy: 1937.368,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9D5799",
    cx: 831.397,
    cy: 1962.04,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#41E5C3",
    cx: 831.397,
    cy: 1985.529,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#596721",
    cx: 831.397,
    cy: 2007.891,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CB5703",
    cx: 831.397,
    cy: 2029.169,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#615B9D",
    cx: 831.397,
    cy: 2049.411,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#73E111",
    cx: 831.397,
    cy: 2068.664,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B7F923",
    cx: 831.397,
    cy: 2086.975,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AB4F4D",
    cx: 831.397,
    cy: 2104.394,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C71967",
    cx: 831.397,
    cy: 2120.969,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7F79B7",
    cx: 831.397,
    cy: 2136.742,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7B93D9",
    cx: 831.397,
    cy: 2151.759,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F50D05",
    cx: 831.397,
    cy: 2166.058,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D78B1B",
    cx: 831.397,
    cy: 2179.675,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9927CF",
    cx: 831.397,
    cy: 2192.641,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#017DBF",
    cx: 831.397,
    cy: 2204.979,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F695B",
    cx: 831.397,
    cy: 2216.709,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DF0D37",
    cx: 831.397,
    cy: 2227.844,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D30995",
    cx: 831.397,
    cy: 2238.467,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#732967",
    cx: 831.397,
    cy: 2248.591,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7109E3",
    cx: 831.397,
    cy: 2258.213,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6D5761",
    cx: 831.397,
    cy: 2267.346,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#69A54F",
    cx: 831.397,
    cy: 2276.072,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E1FD0B",
    cx: 831.397,
    cy: 2284.369,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8DA18F",
    cx: 831.397,
    cy: 2292.24,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#05D5D5",
    cx: 831.397,
    cy: 2299.853,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#13196D",
    cx: 831.397,
    cy: 2307.421,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2F2BE9",
    cx: 831.397,
    cy: 2314.988,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C5174D",
    cx: 831.397,
    cy: 2322.546,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#970577",
    cx: 831.397,
    cy: 2330.115,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#616D00",
    cx: 831.397,
    cy: 2337.677,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F90359",
    cx: 831.397,
    cy: 2345.246,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3DE573",
    cx: 831.397,
    cy: 2352.809,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F5B977",
    cx: 831.397,
    cy: 2360.379,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9937C1",
    cx: 831.397,
    cy: 2367.94,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4DD12D",
    cx: 831.397,
    cy: 2375.505,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6D67EB",
    cx: 831.397,
    cy: 2383.075,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#256D9F",
    cx: 831.397,
    cy: 2390.646,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1FBF8B",
    cx: 831.397,
    cy: 2398.218,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2DBDE9",
    cx: 831.397,
    cy: 2405.782,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3DE19F",
    cx: 831.397,
    cy: 2413.352,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#55616F",
    cx: 831.397,
    cy: 2420.911,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CD7581",
    cx: 831.397,
    cy: 2428.482,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AFAFAD",
    cx: 831.397,
    cy: 2436.056,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DD11C3",
    cx: 831.397,
    cy: 2442.992,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#655581",
    cx: 978.789,
    cy: 561.656,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#151339",
    cx: 972.269,
    cy: 644.5,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#23A59B",
    cx: 965.904,
    cy: 725.371,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E5D317",
    cx: 959.843,
    cy: 802.379,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A9B303",
    cx: 954.077,
    cy: 875.648,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9D35EF",
    cx: 948.589,
    cy: 945.378,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#31A3DB",
    cx: 943.367,
    cy: 1011.731,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9FFD17",
    cx: 938.397,
    cy: 1074.885,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6B0B85",
    cx: 933.666,
    cy: 1134.991,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0505E5",
    cx: 929.165,
    cy: 1192.183,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C347F3",
    cx: 924.885,
    cy: 1246.569,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C7F14F",
    cx: 920.811,
    cy: 1298.327,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#939FDB",
    cx: 916.934,
    cy: 1347.597,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#45053F",
    cx: 913.243,
    cy: 1394.493,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8F6129",
    cx: 909.731,
    cy: 1439.121,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B51571",
    cx: 906.388,
    cy: 1481.591,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BB07AB",
    cx: 903.207,
    cy: 1522.007,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#319577",
    cx: 900.181,
    cy: 1560.461,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#016B65",
    cx: 897.301,
    cy: 1597.06,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#05AFD1",
    cx: 894.558,
    cy: 1631.908,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C5B749",
    cx: 891.95,
    cy: 1665.047,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1F6151",
    cx: 889.468,
    cy: 1696.579,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#19DD19",
    cx: 887.106,
    cy: 1726.591,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#795F4B",
    cx: 884.859,
    cy: 1755.145,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#354D8D",
    cx: 882.72,
    cy: 1782.32,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9D4595",
    cx: 880.685,
    cy: 1808.185,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2D7559",
    cx: 878.749,
    cy: 1832.781,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3353F3",
    cx: 876.906,
    cy: 1856.198,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#013D11",
    cx: 875.151,
    cy: 1878.49,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#851B09",
    cx: 873.482,
    cy: 1899.704,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D7D3C3",
    cx: 871.894,
    cy: 1919.883,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F5B727",
    cx: 870.383,
    cy: 1939.076,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7945F1",
    cx: 868.947,
    cy: 1957.331,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AB3BF9",
    cx: 867.58,
    cy: 1974.697,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#494F5D",
    cx: 866.279,
    cy: 1991.22,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5DC7A9",
    cx: 865.042,
    cy: 2006.945,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E9B38F",
    cx: 863.864,
    cy: 2021.916,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8F5B51",
    cx: 862.742,
    cy: 2036.171,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7B4195",
    cx: 861.673,
    cy: 2049.746,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9B1B37",
    cx: 860.656,
    cy: 2062.671,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CBA733",
    cx: 859.688,
    cy: 2074.971,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B94F0F",
    cx: 858.768,
    cy: 2086.666,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D6D7D",
    cx: 857.894,
    cy: 2097.765,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F96DBF",
    cx: 857.061,
    cy: 2108.356,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E7AFB1",
    cx: 856.266,
    cy: 2118.449,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8FBDF1",
    cx: 855.511,
    cy: 2128.041,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0B51BD",
    cx: 854.795,
    cy: 2137.146,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#13832F",
    cx: 854.11,
    cy: 2145.845,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8565C9",
    cx: 853.459,
    cy: 2154.116,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C58B63",
    cx: 852.842,
    cy: 2161.963,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5557AD",
    cx: 852.244,
    cy: 2169.552,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#276D75",
    cx: 851.651,
    cy: 2177.097,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#65F50B",
    cx: 851.057,
    cy: 2184.641,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6BC923",
    cx: 850.464,
    cy: 2192.176,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7B83D9",
    cx: 849.87,
    cy: 2199.722,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#59BB7B",
    cx: 849.277,
    cy: 2207.261,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#574DF3",
    cx: 848.683,
    cy: 2214.806,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#970921",
    cx: 848.09,
    cy: 2222.345,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#002501",
    cx: 847.496,
    cy: 2229.892,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CF8B5D",
    cx: 846.902,
    cy: 2237.43,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#91BB63",
    cx: 846.309,
    cy: 2244.971,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ABE17F",
    cx: 845.715,
    cy: 2252.518,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AD13AF",
    cx: 845.121,
    cy: 2260.066,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9B5FA1",
    cx: 844.527,
    cy: 2267.614,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BDA9A5",
    cx: 843.933,
    cy: 2275.156,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C73781",
    cx: 843.339,
    cy: 2282.702,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#317B45",
    cx: 842.746,
    cy: 2290.238,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F1381",
    cx: 842.152,
    cy: 2297.785,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7DE799",
    cx: 841.558,
    cy: 2305.336,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2FFDBF",
    cx: 841.014,
    cy: 2312.251,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2F93DD",
    cx: 1135.559,
    cy: 448.279,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3D2BE3",
    cx: 1122.559,
    cy: 530.355,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#69B5B3",
    cx: 1109.869,
    cy: 610.478,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#310B6D",
    cx: 1097.785,
    cy: 686.773,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#75E963",
    cx: 1086.288,
    cy: 759.364,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0599CD",
    cx: 1075.346,
    cy: 828.449,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B3653B",
    cx: 1064.934,
    cy: 894.187,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0D99ED",
    cx: 1055.024,
    cy: 956.757,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A551BB",
    cx: 1045.592,
    cy: 1016.306,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F75979",
    cx: 1036.618,
    cy: 1072.969,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#49293F",
    cx: 1028.084,
    cy: 1126.851,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1DED57",
    cx: 1019.962,
    cy: 1178.13,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F2DC7",
    cx: 1012.231,
    cy: 1226.943,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#01974F",
    cx: 1004.872,
    cy: 1273.406,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2DBF5D",
    cx: 997.869,
    cy: 1317.62,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EBCF37",
    cx: 991.204,
    cy: 1359.698,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#994701",
    cx: 984.862,
    cy: 1399.739,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BD0B01",
    cx: 978.828,
    cy: 1437.837,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B8D39",
    cx: 973.085,
    cy: 1474.098,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A95D47",
    cx: 967.617,
    cy: 1508.622,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F13B29",
    cx: 962.417,
    cy: 1541.455,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#410D03",
    cx: 957.469,
    cy: 1572.695,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F117D",
    cx: 952.759,
    cy: 1602.43,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#754179",
    cx: 948.279,
    cy: 1630.719,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#87973B",
    cx: 944.015,
    cy: 1657.643,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#377F85",
    cx: 939.956,
    cy: 1683.268,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D97B33",
    cx: 936.096,
    cy: 1707.637,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#91A12B",
    cx: 932.422,
    cy: 1730.836,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0B49CF",
    cx: 928.924,
    cy: 1752.922,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7BB907",
    cx: 925.595,
    cy: 1773.939,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C5E3CD",
    cx: 922.428,
    cy: 1793.932,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#75AFC5",
    cx: 919.417,
    cy: 1812.948,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D9572F",
    cx: 916.552,
    cy: 1831.034,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A5A779",
    cx: 913.827,
    cy: 1848.238,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C5E71D",
    cx: 911.234,
    cy: 1864.609,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F3F25",
    cx: 908.767,
    cy: 1880.188,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F353D3",
    cx: 906.418,
    cy: 1895.02,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#63FF5B",
    cx: 904.181,
    cy: 1909.143,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#19C5D3",
    cx: 902.051,
    cy: 1922.592,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#671F99",
    cx: 900.022,
    cy: 1935.398,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#17810D",
    cx: 898.092,
    cy: 1947.584,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2F1BF1",
    cx: 896.257,
    cy: 1959.171,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#635BE1",
    cx: 894.515,
    cy: 1970.167,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AFC913",
    cx: 892.854,
    cy: 1980.66,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#77E32F",
    cx: 891.27,
    cy: 1990.66,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#975B47",
    cx: 889.765,
    cy: 2000.163,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#716569",
    cx: 888.336,
    cy: 2009.184,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AF4B81",
    cx: 886.971,
    cy: 2017.802,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#03798F",
    cx: 885.673,
    cy: 2025.997,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8D7FDB",
    cx: 884.442,
    cy: 2033.771,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#89C75D",
    cx: 883.251,
    cy: 2041.29,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#530389",
    cx: 882.067,
    cy: 2048.765,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ADB3E7",
    cx: 880.883,
    cy: 2056.239,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D55BAB",
    cx: 879.701,
    cy: 2063.704,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3BC989",
    cx: 878.517,
    cy: 2071.18,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BF4B71",
    cx: 877.334,
    cy: 2078.649,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A1C793",
    cx: 876.15,
    cy: 2086.125,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0B93EB",
    cx: 874.967,
    cy: 2093.594,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#75B19D",
    cx: 873.782,
    cy: 2101.071,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6FDB95",
    cx: 872.6,
    cy: 2108.539,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#53A7C7",
    cx: 871.416,
    cy: 2116.011,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E55979",
    cx: 870.232,
    cy: 2123.488,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5FDB8F",
    cx: 869.047,
    cy: 2130.966,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E311CB",
    cx: 867.863,
    cy: 2138.444,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#29697D",
    cx: 866.68,
    cy: 2145.916,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#31F579",
    cx: 865.496,
    cy: 2153.392,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#39C7A7",
    cx: 864.313,
    cy: 2160.858,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6909AF",
    cx: 863.129,
    cy: 2168.336,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#552519",
    cx: 861.944,
    cy: 2175.816,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#59D7AB",
    cx: 860.859,
    cy: 2182.667,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#57D901",
    cx: 1300.741,
    cy: 347.551,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A7295D",
    cx: 1281.342,
    cy: 428.354,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7DCF97",
    cx: 1262.404,
    cy: 507.235,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7363A1",
    cx: 1244.372,
    cy: 582.346,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D50133",
    cx: 1227.215,
    cy: 653.811,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ADD9BD",
    cx: 1210.886,
    cy: 721.824,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#496D4F",
    cx: 1195.349,
    cy: 786.543,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#370F5D",
    cx: 1180.56,
    cy: 848.142,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6F7F9B",
    cx: 1166.485,
    cy: 906.768,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#176D6D",
    cx: 1153.092,
    cy: 962.552,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#65B9E9",
    cx: 1140.357,
    cy: 1015.599,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#63D559",
    cx: 1128.237,
    cy: 1066.082,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#15A975",
    cx: 1116.7,
    cy: 1114.139,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7593B9",
    cx: 1105.718,
    cy: 1159.88,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D7B555",
    cx: 1095.268,
    cy: 1203.409,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C73F37",
    cx: 1085.323,
    cy: 1244.834,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E9DB6B",
    cx: 1075.859,
    cy: 1284.254,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F3AFA9",
    cx: 1066.854,
    cy: 1321.761,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2577C9",
    cx: 1058.283,
    cy: 1357.46,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#050FC1",
    cx: 1050.123,
    cy: 1391.449,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C7EDCB",
    cx: 1042.363,
    cy: 1423.772,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F1FB5B",
    cx: 1034.979,
    cy: 1454.528,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#03A775",
    cx: 1027.952,
    cy: 1483.801,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#97D375",
    cx: 1021.265,
    cy: 1511.651,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0BDD6D",
    cx: 1014.902,
    cy: 1538.158,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F9B9C9",
    cx: 1008.845,
    cy: 1563.386,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C9570B",
    cx: 1003.085,
    cy: 1587.376,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8D8D4B",
    cx: 997.602,
    cy: 1610.217,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E5BD15",
    cx: 992.382,
    cy: 1631.96,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#99C957",
    cx: 987.414,
    cy: 1652.651,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0B7B49",
    cx: 982.689,
    cy: 1672.333,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#099BE1",
    cx: 978.195,
    cy: 1691.054,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5153A7",
    cx: 973.92,
    cy: 1708.86,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4949A3",
    cx: 969.853,
    cy: 1725.797,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F3A343",
    cx: 965.984,
    cy: 1741.914,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BB07EF",
    cx: 962.302,
    cy: 1757.252,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F323B3",
    cx: 958.796,
    cy: 1771.854,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDAD61",
    cx: 955.458,
    cy: 1785.758,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2B174F",
    cx: 952.279,
    cy: 1798.998,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#434DD5",
    cx: 949.253,
    cy: 1811.605,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#236555",
    cx: 946.372,
    cy: 1823.603,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#237B0D",
    cx: 943.634,
    cy: 1835.009,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6D73D7",
    cx: 941.035,
    cy: 1845.836,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3991F7",
    cx: 938.555,
    cy: 1856.166,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4F2163",
    cx: 936.191,
    cy: 1866.01,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#23DBB3",
    cx: 933.945,
    cy: 1875.366,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B098B",
    cx: 931.813,
    cy: 1884.247,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1315C3",
    cx: 929.776,
    cy: 1892.732,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ABD16D",
    cx: 927.839,
    cy: 1900.799,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#33AD97",
    cx: 926.002,
    cy: 1908.453,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A5613F",
    cx: 924.225,
    cy: 1915.855,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#716BE1",
    cx: 922.458,
    cy: 1923.214,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C92959",
    cx: 920.691,
    cy: 1930.572,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2173C1",
    cx: 918.927,
    cy: 1937.921,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6F5300",
    cx: 917.16,
    cy: 1945.281,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#753F8F",
    cx: 915.394,
    cy: 1952.635,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CFE7BF",
    cx: 913.628,
    cy: 1959.994,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E9C371",
    cx: 911.862,
    cy: 1967.348,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9DA37B",
    cx: 910.095,
    cy: 1974.709,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1959C3",
    cx: 908.33,
    cy: 1982.061,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3F1193",
    cx: 906.564,
    cy: 1989.417,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9107A5",
    cx: 904.797,
    cy: 1996.778,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D9A557",
    cx: 903.029,
    cy: 2004.14,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#67DFDB",
    cx: 901.262,
    cy: 2011.502,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6B414D",
    cx: 899.496,
    cy: 2018.858,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5B032F",
    cx: 897.729,
    cy: 2026.219,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B03F9",
    cx: 895.964,
    cy: 2033.568,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D8DBB",
    cx: 894.197,
    cy: 2040.931,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1933BB",
    cx: 892.429,
    cy: 2048.295,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2B176F",
    cx: 890.809,
    cy: 2055.04,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#871569",
    cx: 1473.317,
    cy: 260.094,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#99D747",
    cx: 1447.638,
    cy: 339.126,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4F4553",
    cx: 1422.57,
    cy: 416.277,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#558183",
    cx: 1398.7,
    cy: 489.742,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BD5F9B",
    cx: 1375.989,
    cy: 559.641,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E3C197",
    cx: 1354.374,
    cy: 626.163,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7935E7",
    cx: 1333.807,
    cy: 689.463,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BB4FDB",
    cx: 1314.23,
    cy: 749.712,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E1F761",
    cx: 1295.599,
    cy: 807.054,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#215553",
    cx: 1277.871,
    cy: 861.614,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DFC799",
    cx: 1261.013,
    cy: 913.498,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F3DB9F",
    cx: 1244.97,
    cy: 962.875,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#63354F",
    cx: 1229.697,
    cy: 1009.878,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8121BD",
    cx: 1215.161,
    cy: 1054.618,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D3A515",
    cx: 1201.327,
    cy: 1097.193,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DBEDA3",
    cx: 1188.163,
    cy: 1137.709,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F151EF",
    cx: 1175.635,
    cy: 1176.265,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#55219D",
    cx: 1163.715,
    cy: 1212.95,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#49DFFD",
    cx: 1152.37,
    cy: 1247.866,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3F5DE1",
    cx: 1141.569,
    cy: 1281.11,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#978107",
    cx: 1131.297,
    cy: 1312.725,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#61373B",
    cx: 1121.522,
    cy: 1342.807,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#85AB73",
    cx: 1112.219,
    cy: 1371.438,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A5F1C1",
    cx: 1103.369,
    cy: 1398.678,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BB9B1B",
    cx: 1094.945,
    cy: 1424.604,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D183CB",
    cx: 1086.927,
    cy: 1449.279,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4F5D09",
    cx: 1079.303,
    cy: 1472.744,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1F8351",
    cx: 1072.045,
    cy: 1495.083,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B3F7A1",
    cx: 1065.135,
    cy: 1516.35,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6B81F5",
    cx: 1058.559,
    cy: 1536.587,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F303CB",
    cx: 1052.304,
    cy: 1555.838,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#11A17F",
    cx: 1046.355,
    cy: 1574.149,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#795D95",
    cx: 1040.696,
    cy: 1591.564,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#87255F",
    cx: 1035.313,
    cy: 1608.13,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9BE775",
    cx: 1030.192,
    cy: 1623.894,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79E591",
    cx: 1025.317,
    cy: 1638.895,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#03354D",
    cx: 1020.677,
    cy: 1653.177,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C7B771",
    cx: 1016.258,
    cy: 1666.776,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EF978F",
    cx: 1012.05,
    cy: 1679.727,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#176565",
    cx: 1008.044,
    cy: 1692.057,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#891F55",
    cx: 1004.231,
    cy: 1703.792,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C78913",
    cx: 1000.606,
    cy: 1714.948,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#09B307",
    cx: 997.166,
    cy: 1725.537,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6D73D1",
    cx: 993.883,
    cy: 1735.641,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3F33F5",
    cx: 990.754,
    cy: 1745.27,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B15939",
    cx: 987.781,
    cy: 1754.421,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FD83FF",
    cx: 984.958,
    cy: 1763.107,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DF1939",
    cx: 982.262,
    cy: 1771.406,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E1C35B",
    cx: 979.698,
    cy: 1779.296,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0F0579",
    cx: 977.266,
    cy: 1786.782,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CDC9CB",
    cx: 974.914,
    cy: 1794.022,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#57D3F1",
    cx: 972.575,
    cy: 1801.22,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E90557",
    cx: 970.237,
    cy: 1808.417,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#257BB7",
    cx: 967.901,
    cy: 1815.605,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3D1743",
    cx: 965.562,
    cy: 1822.804,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#017DF3",
    cx: 963.225,
    cy: 1829.996,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#595773",
    cx: 960.886,
    cy: 1837.194,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F10383",
    cx: 958.549,
    cy: 1844.386,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#55D793",
    cx: 956.21,
    cy: 1851.586,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#29B187",
    cx: 953.873,
    cy: 1858.777,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E177DB",
    cx: 951.536,
    cy: 1865.972,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#296159",
    cx: 949.196,
    cy: 1873.171,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#233333",
    cx: 946.857,
    cy: 1880.372,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#996729",
    cx: 944.517,
    cy: 1887.573,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#51E749",
    cx: 942.179,
    cy: 1894.767,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#51AFDB",
    cx: 939.84,
    cy: 1901.967,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AF2BD5",
    cx: 937.505,
    cy: 1909.155,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8F4135",
    cx: 935.165,
    cy: 1916.356,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E32B2D",
    cx: 932.824,
    cy: 1923.559,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B18505",
    cx: 930.681,
    cy: 1930.156,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#094F4F",
    cx: 1652.223,
    cy: 186.445,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3D95A5",
    cx: 1620.422,
    cy: 263.219,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FB7BC3",
    cx: 1589.378,
    cy: 338.166,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F30DE9",
    cx: 1559.818,
    cy: 409.532,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7F0B33",
    cx: 1531.692,
    cy: 477.433,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CBA1A9",
    cx: 1504.925,
    cy: 542.055,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F6F2F",
    cx: 1479.455,
    cy: 603.546,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#05892B",
    cx: 1455.212,
    cy: 662.073,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EF7DAF",
    cx: 1432.139,
    cy: 717.776,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BFD769",
    cx: 1410.185,
    cy: 770.778,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6765A1",
    cx: 1389.308,
    cy: 821.179,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#838F6F",
    cx: 1369.44,
    cy: 869.145,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B5D74D",
    cx: 1350.527,
    cy: 914.805,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7935F7",
    cx: 1332.525,
    cy: 958.265,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7DE783",
    cx: 1315.394,
    cy: 999.624,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A1B9CD",
    cx: 1299.091,
    cy: 1038.983,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#339F09",
    cx: 1283.577,
    cy: 1076.437,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3BCD5B",
    cx: 1268.815,
    cy: 1112.074,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5D331F",
    cx: 1254.766,
    cy: 1145.992,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EF19A1",
    cx: 1241.389,
    cy: 1178.286,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D3E937",
    cx: 1228.668,
    cy: 1208.997,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F05DF",
    cx: 1216.564,
    cy: 1238.219,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#214169",
    cx: 1205.043,
    cy: 1266.033,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E3C181",
    cx: 1194.083,
    cy: 1292.494,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D735A5",
    cx: 1183.651,
    cy: 1317.679,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7E3FB",
    cx: 1173.722,
    cy: 1341.649,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B55161",
    cx: 1164.28,
    cy: 1364.443,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#37EDDB",
    cx: 1155.292,
    cy: 1386.144,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#358D77",
    cx: 1146.734,
    cy: 1406.804,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#631935",
    cx: 1138.591,
    cy: 1426.463,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0785EB",
    cx: 1130.845,
    cy: 1445.164,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4F2F9D",
    cx: 1123.477,
    cy: 1462.951,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B699B",
    cx: 1116.47,
    cy: 1479.868,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#915983",
    cx: 1109.804,
    cy: 1495.961,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C7CDF9",
    cx: 1103.461,
    cy: 1511.274,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8B410D",
    cx: 1097.425,
    cy: 1525.847,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9B67FD",
    cx: 1091.678,
    cy: 1539.721,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#331385",
    cx: 1086.206,
    cy: 1552.931,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1145F3",
    cx: 1080.995,
    cy: 1565.512,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3307D7",
    cx: 1076.033,
    cy: 1577.49,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#516913",
    cx: 1071.312,
    cy: 1588.89,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A9C565",
    cx: 1066.823,
    cy: 1599.727,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6D3D0D",
    cx: 1062.562,
    cy: 1610.013,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#73151B",
    cx: 1058.496,
    cy: 1619.828,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5943CF",
    cx: 1054.622,
    cy: 1629.182,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#270173",
    cx: 1050.94,
    cy: 1638.071,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8521AD",
    cx: 1047.445,
    cy: 1646.509,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2F4DE9",
    cx: 1044.106,
    cy: 1654.571,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FD75A3",
    cx: 1040.931,
    cy: 1662.236,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DF65A1",
    cx: 1037.918,
    cy: 1669.508,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#95F7FB",
    cx: 1035.005,
    cy: 1676.541,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#55C361",
    cx: 1032.109,
    cy: 1683.533,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#23DF1F",
    cx: 1029.213,
    cy: 1690.524,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8B093D",
    cx: 1026.321,
    cy: 1697.507,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#635F57",
    cx: 1023.424,
    cy: 1704.5,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C123FB",
    cx: 1020.53,
    cy: 1711.487,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CF413F",
    cx: 1017.634,
    cy: 1718.479,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3775AB",
    cx: 1014.74,
    cy: 1725.466,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#51A5AB",
    cx: 1011.843,
    cy: 1732.46,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#49A79F",
    cx: 1008.949,
    cy: 1739.445,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D3E9AB",
    cx: 1006.054,
    cy: 1746.435,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7BF527",
    cx: 1003.157,
    cy: 1753.429,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#151B07",
    cx: 1000.26,
    cy: 1760.424,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5FBF3D",
    cx: 997.363,
    cy: 1767.419,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7F1791",
    cx: 994.468,
    cy: 1774.407,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#43D985",
    cx: 991.571,
    cy: 1781.401,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#35CF85",
    cx: 988.678,
    cy: 1788.384,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4BD9BF",
    cx: 985.781,
    cy: 1795.379,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B5A3BF",
    cx: 982.883,
    cy: 1802.376,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#45DF07",
    cx: 980.228,
    cy: 1808.785,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#134979",
    cx: 1836.356,
    cy: 127.062,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CB2F35",
    cx: 1798.63,
    cy: 201.104,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C9D943",
    cx: 1761.801,
    cy: 273.384,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878537",
    cx: 1726.732,
    cy: 342.211,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B7AF7F",
    cx: 1693.366,
    cy: 407.695,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CDFB43",
    cx: 1661.611,
    cy: 470.018,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0F05C3",
    cx: 1631.395,
    cy: 529.321,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F1EFE9",
    cx: 1602.635,
    cy: 585.766,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C7573F",
    cx: 1575.262,
    cy: 639.487,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C3B729",
    cx: 1549.218,
    cy: 690.602,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#535F9F",
    cx: 1524.451,
    cy: 739.21,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C73963",
    cx: 1500.88,
    cy: 785.47,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2D2FDB",
    cx: 1478.443,
    cy: 829.505,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ED1921",
    cx: 1457.087,
    cy: 871.419,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9B3D75",
    cx: 1436.764,
    cy: 911.306,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C7036B",
    cx: 1417.423,
    cy: 949.264,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#91C7D7",
    cx: 1399.018,
    cy: 985.386,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#130F95",
    cx: 1381.506,
    cy: 1019.755,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4DFB7D",
    cx: 1364.839,
    cy: 1052.466,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8329B3",
    cx: 1348.97,
    cy: 1083.611,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#333975",
    cx: 1333.878,
    cy: 1113.23,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0B65B9",
    cx: 1319.519,
    cy: 1141.412,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#33CD59",
    cx: 1305.851,
    cy: 1168.236,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDA177",
    cx: 1292.848,
    cy: 1193.756,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#490769",
    cx: 1280.473,
    cy: 1218.044,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E1C3D1",
    cx: 1268.694,
    cy: 1241.161,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8F2923",
    cx: 1257.493,
    cy: 1263.145,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9775A9",
    cx: 1246.829,
    cy: 1284.073,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#997BA3",
    cx: 1236.677,
    cy: 1303.998,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9B3369",
    cx: 1227.017,
    cy: 1322.957,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DB1F1F",
    cx: 1217.827,
    cy: 1340.993,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3F01B7",
    cx: 1209.087,
    cy: 1358.147,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#736B79",
    cx: 1200.773,
    cy: 1374.463,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D3B3AB",
    cx: 1192.865,
    cy: 1389.983,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#03B355",
    cx: 1185.341,
    cy: 1404.751,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0131A3",
    cx: 1178.18,
    cy: 1418.806,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#31FBCF",
    cx: 1171.362,
    cy: 1432.186,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#632FF1",
    cx: 1164.87,
    cy: 1444.926,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#31EB0F",
    cx: 1158.689,
    cy: 1457.059,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E90D7B",
    cx: 1152.802,
    cy: 1468.611,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F18BAF",
    cx: 1147.201,
    cy: 1479.605,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BD719F",
    cx: 1141.875,
    cy: 1490.057,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#31ABB7",
    cx: 1136.821,
    cy: 1499.977,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C9652B",
    cx: 1131.998,
    cy: 1509.443,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B34DAF",
    cx: 1127.401,
    cy: 1518.464,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FF8FC9",
    cx: 1123.033,
    cy: 1527.036,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9599DD",
    cx: 1118.887,
    cy: 1535.175,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C76DBD",
    cx: 1114.925,
    cy: 1542.949,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B18D2D",
    cx: 1111.159,
    cy: 1550.342,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8D0F9F",
    cx: 1107.585,
    cy: 1557.355,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D593AB",
    cx: 1104.129,
    cy: 1564.138,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0FBFB7",
    cx: 1100.693,
    cy: 1570.881,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#35F553",
    cx: 1097.258,
    cy: 1577.623,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5791D7",
    cx: 1093.827,
    cy: 1584.357,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#05B969",
    cx: 1090.39,
    cy: 1591.102,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B52357",
    cx: 1086.957,
    cy: 1597.84,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6DCD4F",
    cx: 1083.521,
    cy: 1604.584,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9B53CF",
    cx: 1080.088,
    cy: 1611.322,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5FC1FD",
    cx: 1076.651,
    cy: 1618.067,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#073F77",
    cx: 1073.218,
    cy: 1624.804,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B13B5D",
    cx: 1069.784,
    cy: 1631.544,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9BC76F",
    cx: 1066.347,
    cy: 1638.289,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3FED37",
    cx: 1062.91,
    cy: 1645.036,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FD270B",
    cx: 1059.472,
    cy: 1651.781,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#471FF5",
    cx: 1056.038,
    cy: 1658.522,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EBEF5F",
    cx: 1052.602,
    cy: 1665.266,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5D059D",
    cx: 1049.17,
    cy: 1672.001,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#394BB5",
    cx: 1045.733,
    cy: 1678.747,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F1D5E9",
    cx: 1042.294,
    cy: 1685.496,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F3F5A7",
    cx: 1039.145,
    cy: 1691.676,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E9695F",
    cx: 2024.58,
    cy: 82.308,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E9D13B",
    cx: 1981.161,
    cy: 153.162,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#558105",
    cx: 1938.775,
    cy: 222.329,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2D0DED",
    cx: 1898.414,
    cy: 288.192,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E5518F",
    cx: 1860.013,
    cy: 350.857,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3F471B",
    cx: 1823.466,
    cy: 410.496,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#916549",
    cx: 1788.69,
    cy: 467.246,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0B5339",
    cx: 1755.59,
    cy: 521.26,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6B6B01",
    cx: 1724.087,
    cy: 572.668,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#972D57",
    cx: 1694.112,
    cy: 621.583,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B95BD1",
    cx: 1665.608,
    cy: 668.097,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C75787",
    cx: 1638.481,
    cy: 712.365,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DD999F",
    cx: 1612.658,
    cy: 754.504,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BBC34B",
    cx: 1588.079,
    cy: 794.613,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F969E3",
    cx: 1564.689,
    cy: 832.783,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B94F61",
    cx: 1542.429,
    cy: 869.107,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2D1B6F",
    cx: 1521.247,
    cy: 903.673,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D7F5A5",
    cx: 1501.093,
    cy: 936.562,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#51696F",
    cx: 1481.91,
    cy: 967.865,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0F1B49",
    cx: 1463.646,
    cy: 997.669,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F3DD0B",
    cx: 1446.278,
    cy: 1026.012,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B97DB1",
    cx: 1429.751,
    cy: 1052.98,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#55A991",
    cx: 1414.021,
    cy: 1078.649,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#39F13B",
    cx: 1399.056,
    cy: 1103.07,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#61851F",
    cx: 1384.813,
    cy: 1126.313,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A9ED27",
    cx: 1371.257,
    cy: 1148.435,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8B1D45",
    cx: 1358.366,
    cy: 1169.471,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ADCB7F",
    cx: 1346.093,
    cy: 1189.499,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AD1783",
    cx: 1334.409,
    cy: 1208.565,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F8993",
    cx: 1323.291,
    cy: 1226.708,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#37BF97",
    cx: 1312.714,
    cy: 1243.967,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9DEBDD",
    cx: 1302.655,
    cy: 1260.383,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E9FBB7",
    cx: 1293.087,
    cy: 1275.996,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#19B715",
    cx: 1283.986,
    cy: 1290.848,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#634355",
    cx: 1275.326,
    cy: 1304.98,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9D4D15",
    cx: 1267.084,
    cy: 1318.429,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2149F1",
    cx: 1259.238,
    cy: 1331.233,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#81C363",
    cx: 1251.766,
    cy: 1343.425,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C1114F",
    cx: 1244.651,
    cy: 1355.036,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#33473D",
    cx: 1237.877,
    cy: 1366.09,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6F43C7",
    cx: 1231.43,
    cy: 1376.611,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9FBBBD",
    cx: 1225.301,
    cy: 1386.613,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E18BD3",
    cx: 1219.484,
    cy: 1396.106,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C76749",
    cx: 1213.933,
    cy: 1405.164,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#73754B",
    cx: 1208.643,
    cy: 1413.796,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F9B9F3",
    cx: 1203.616,
    cy: 1422,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#032701",
    cx: 1198.844,
    cy: 1429.788,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F119BD",
    cx: 1194.284,
    cy: 1437.228,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9DA9AB",
    cx: 1189.949,
    cy: 1444.302,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9FCBE3",
    cx: 1185.837,
    cy: 1451.013,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9DD315",
    cx: 1181.859,
    cy: 1457.504,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F90F7D",
    cx: 1177.905,
    cy: 1463.957,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D38F33",
    cx: 1173.951,
    cy: 1470.408,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D256B",
    cx: 1170.002,
    cy: 1476.853,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F9E1DB",
    cx: 1166.047,
    cy: 1483.307,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BF81C9",
    cx: 1162.096,
    cy: 1489.755,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1F7DED",
    cx: 1158.141,
    cy: 1496.208,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1F3549",
    cx: 1154.19,
    cy: 1502.656,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6DD343",
    cx: 1150.234,
    cy: 1509.111,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1F93A5",
    cx: 1146.284,
    cy: 1515.557,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B91FD1",
    cx: 1142.331,
    cy: 1522.008,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6927E5",
    cx: 1138.375,
    cy: 1528.462,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A5B51F",
    cx: 1134.419,
    cy: 1534.918,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F129ED",
    cx: 1130.464,
    cy: 1541.374,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8B3B21",
    cx: 1126.511,
    cy: 1547.824,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5FCBDB",
    cx: 1122.556,
    cy: 1554.278,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#952775",
    cx: 1118.606,
    cy: 1560.723,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#352B43",
    cx: 1114.65,
    cy: 1567.178,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3935E5",
    cx: 1110.693,
    cy: 1573.636,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1967C1",
    cx: 1107.069,
    cy: 1579.55,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9FB595",
    cx: 2215.736,
    cy: 52.46,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5BD369",
    cx: 2166.891,
    cy: 119.689,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FDD91B",
    cx: 2119.209,
    cy: 185.318,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D5163",
    cx: 2073.805,
    cy: 247.811,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#81BBAD",
    cx: 2030.606,
    cy: 307.27,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B33169",
    cx: 1989.492,
    cy: 363.857,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#69B5BF",
    cx: 1950.371,
    cy: 417.704,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#09D58D",
    cx: 1913.135,
    cy: 468.955,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7FABED",
    cx: 1877.696,
    cy: 517.732,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D969A7",
    cx: 1843.976,
    cy: 564.144,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#531503",
    cx: 1811.91,
    cy: 608.279,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#81E1CB",
    cx: 1781.393,
    cy: 650.282,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E51339",
    cx: 1752.343,
    cy: 690.265,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#73EF45",
    cx: 1724.693,
    cy: 728.322,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#53895D",
    cx: 1698.38,
    cy: 764.539,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#472F4D",
    cx: 1673.34,
    cy: 799.004,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B9E501",
    cx: 1649.511,
    cy: 831.802,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A391C7",
    cx: 1626.838,
    cy: 863.008,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EBF141",
    cx: 1605.259,
    cy: 892.71,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#33F5F3",
    cx: 1584.713,
    cy: 920.989,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#87EBE3",
    cx: 1565.174,
    cy: 947.882,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6F7D69",
    cx: 1546.583,
    cy: 973.471,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7F579D",
    cx: 1528.887,
    cy: 997.826,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F503A9",
    cx: 1512.052,
    cy: 1020.998,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E5B395",
    cx: 1496.029,
    cy: 1043.051,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1DD7EB",
    cx: 1480.779,
    cy: 1064.041,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3545C5",
    cx: 1466.277,
    cy: 1084.001,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A73F81",
    cx: 1452.471,
    cy: 1103.005,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3FB977",
    cx: 1439.327,
    cy: 1121.095,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D2F35",
    cx: 1426.82,
    cy: 1138.31,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#77EF63",
    cx: 1414.922,
    cy: 1154.686,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C5AF0D",
    cx: 1403.605,
    cy: 1170.262,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7F099B",
    cx: 1392.842,
    cy: 1185.076,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#837DC5",
    cx: 1382.604,
    cy: 1199.168,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6F1DDF",
    cx: 1372.861,
    cy: 1212.578,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#83CBFF",
    cx: 1363.59,
    cy: 1225.339,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ED259F",
    cx: 1354.763,
    cy: 1237.487,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B59573",
    cx: 1346.358,
    cy: 1249.056,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#15DD65",
    cx: 1338.354,
    cy: 1260.072,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B79F69",
    cx: 1330.734,
    cy: 1270.561,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#29D16D",
    cx: 1323.481,
    cy: 1280.543,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#474D69",
    cx: 1316.586,
    cy: 1290.033,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4DD5AB",
    cx: 1310.042,
    cy: 1299.041,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#47C1C7",
    cx: 1303.797,
    cy: 1307.636,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#73338B",
    cx: 1297.847,
    cy: 1315.826,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7FA507",
    cx: 1292.191,
    cy: 1323.61,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DF1D8D",
    cx: 1286.823,
    cy: 1331,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#57150F",
    cx: 1281.694,
    cy: 1338.059,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1D95EF",
    cx: 1276.817,
    cy: 1344.771,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8BBD57",
    cx: 1272.191,
    cy: 1351.139,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#573357",
    cx: 1267.716,
    cy: 1357.297,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#69F78D",
    cx: 1263.268,
    cy: 1363.42,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E123E5",
    cx: 1258.82,
    cy: 1369.542,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D57B9F",
    cx: 1254.377,
    cy: 1375.657,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B175B1",
    cx: 1249.928,
    cy: 1381.78,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1F6547",
    cx: 1245.483,
    cy: 1387.899,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#61AD61",
    cx: 1241.034,
    cy: 1394.022,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BB5D43",
    cx: 1236.589,
    cy: 1400.14,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D12975",
    cx: 1232.139,
    cy: 1406.265,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#572B91",
    cx: 1227.695,
    cy: 1412.381,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B99771",
    cx: 1223.249,
    cy: 1418.501,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#13E181",
    cx: 1218.799,
    cy: 1424.626,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#653181",
    cx: 1214.349,
    cy: 1430.751,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#077169",
    cx: 1209.898,
    cy: 1436.876,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BD417F",
    cx: 1205.452,
    cy: 1442.996,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FB238F",
    cx: 1201.003,
    cy: 1449.12,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E72F01",
    cx: 1196.56,
    cy: 1455.236,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D52DFD",
    cx: 1192.109,
    cy: 1461.361,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D5793",
    cx: 1187.658,
    cy: 1467.488,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F1BFFF",
    cx: 1183.581,
    cy: 1473.1,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E3AFA1",
    cx: 2408.644,
    cy: 37.702,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6D5F37",
    cx: 2354.676,
    cy: 100.891,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F492B",
    cx: 2301.991,
    cy: 162.576,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EB73E1",
    cx: 2251.824,
    cy: 221.315,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F76141",
    cx: 2204.093,
    cy: 277.201,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2B19C1",
    cx: 2158.666,
    cy: 330.388,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AFC74B",
    cx: 2115.44,
    cy: 380.999,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AD5707",
    cx: 2074.298,
    cy: 429.171,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D94F59",
    cx: 2035.141,
    cy: 475.017,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#55B3EB",
    cx: 1997.884,
    cy: 518.64,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#897535",
    cx: 1962.454,
    cy: 560.124,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E37BB1",
    cx: 1928.736,
    cy: 599.602,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#03093D",
    cx: 1896.639,
    cy: 637.183,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6557A1",
    cx: 1866.088,
    cy: 672.954,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#797347",
    cx: 1837.014,
    cy: 706.994,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EB0D25",
    cx: 1809.347,
    cy: 739.389,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#33CD51",
    cx: 1783.018,
    cy: 770.216,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BD6127",
    cx: 1757.967,
    cy: 799.547,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#839FE9",
    cx: 1734.124,
    cy: 827.464,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F1435B",
    cx: 1711.422,
    cy: 854.043,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F3EDA7",
    cx: 1689.834,
    cy: 879.32,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#29E709",
    cx: 1669.292,
    cy: 903.372,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A32B7B",
    cx: 1649.74,
    cy: 926.264,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CD893F",
    cx: 1631.139,
    cy: 948.043,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D5955B",
    cx: 1613.435,
    cy: 968.772,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#577D17",
    cx: 1596.585,
    cy: 988.5,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#511155",
    cx: 1580.562,
    cy: 1007.261,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CD9700",
    cx: 1565.307,
    cy: 1025.123,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AD6765",
    cx: 1550.784,
    cy: 1042.126,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9315C5",
    cx: 1536.965,
    cy: 1058.307,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#69BF71",
    cx: 1523.819,
    cy: 1073.699,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6BA5A1",
    cx: 1511.315,
    cy: 1088.339,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D159DF",
    cx: 1499.423,
    cy: 1102.263,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#43B36F",
    cx: 1488.11,
    cy: 1115.508,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#734D61",
    cx: 1477.346,
    cy: 1128.112,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E7E19F",
    cx: 1467.102,
    cy: 1140.106,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#057755",
    cx: 1457.349,
    cy: 1151.525,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FD3999",
    cx: 1448.063,
    cy: 1162.398,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#57D3F1",
    cx: 1439.219,
    cy: 1172.752,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ED512B",
    cx: 1430.799,
    cy: 1182.611,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#832903",
    cx: 1422.786,
    cy: 1191.994,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#99B1D5",
    cx: 1415.167,
    cy: 1200.914,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AB11A1",
    cx: 1407.936,
    cy: 1209.38,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8145ED",
    cx: 1401.037,
    cy: 1217.458,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#619BD9",
    cx: 1394.462,
    cy: 1225.156,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9D634B",
    cx: 1388.213,
    cy: 1232.473,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E52D51",
    cx: 1382.281,
    cy: 1239.418,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8965B3",
    cx: 1376.614,
    cy: 1246.053,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A17967",
    cx: 1371.226,
    cy: 1252.362,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#552FAF",
    cx: 1366.114,
    cy: 1258.347,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DD7FEF",
    cx: 1361.17,
    cy: 1264.136,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C1AF9B",
    cx: 1356.255,
    cy: 1269.891,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4361E7",
    cx: 1351.341,
    cy: 1275.645,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D73BB",
    cx: 1346.432,
    cy: 1281.392,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7FFDAD",
    cx: 1341.516,
    cy: 1287.148,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878D8B",
    cx: 1336.605,
    cy: 1292.898,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2BD9FB",
    cx: 1331.69,
    cy: 1298.653,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B7F125",
    cx: 1326.778,
    cy: 1304.404,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#55F535",
    cx: 1321.861,
    cy: 1310.161,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AF530F",
    cx: 1316.951,
    cy: 1315.91,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8935F5",
    cx: 1312.038,
    cy: 1321.662,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6F81BD",
    cx: 1307.122,
    cy: 1327.419,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7FE323",
    cx: 1302.204,
    cy: 1333.176,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C1BD09",
    cx: 1297.287,
    cy: 1338.933,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B1E905",
    cx: 1292.374,
    cy: 1344.686,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F630B",
    cx: 1287.458,
    cy: 1350.442,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#69F9D7",
    cx: 1282.549,
    cy: 1356.189,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#292D3B",
    cx: 1277.632,
    cy: 1361.947,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#00BF7B",
    cx: 1272.713,
    cy: 1367.706,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9D25C3",
    cx: 1268.209,
    cy: 1372.98,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#311761",
    cx: 2602.115,
    cy: 38.124,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1731CB",
    cx: 2543.355,
    cy: 96.884,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3FAFBF",
    cx: 2485.993,
    cy: 154.246,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B16DB7",
    cx: 2431.372,
    cy: 208.867,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#27436F",
    cx: 2379.403,
    cy: 260.836,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E18FF3",
    cx: 2329.943,
    cy: 310.296,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#237FE7",
    cx: 2282.88,
    cy: 357.359,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#49AD2B",
    cx: 2238.085,
    cy: 402.154,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CD37DD",
    cx: 2195.452,
    cy: 444.787,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79498D",
    cx: 2154.886,
    cy: 485.353,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#896927",
    cx: 2116.311,
    cy: 523.928,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#459F4B",
    cx: 2079.6,
    cy: 560.64,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C34557",
    cx: 2044.653,
    cy: 595.586,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8B016B",
    cx: 2011.39,
    cy: 628.85,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#65BF4F",
    cx: 1979.735,
    cy: 660.504,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E51315",
    cx: 1949.611,
    cy: 690.628,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D2DDF",
    cx: 1920.945,
    cy: 719.294,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E95F89",
    cx: 1893.67,
    cy: 746.57,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3BE767",
    cx: 1867.71,
    cy: 772.529,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0B63B5",
    cx: 1842.993,
    cy: 797.246,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0B7739",
    cx: 1819.488,
    cy: 820.752,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8135CD",
    cx: 1797.122,
    cy: 843.117,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#239D99",
    cx: 1775.834,
    cy: 864.405,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A35FB1",
    cx: 1755.582,
    cy: 884.657,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#678B73",
    cx: 1736.306,
    cy: 903.933,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A3736B",
    cx: 1717.96,
    cy: 922.279,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6523FB",
    cx: 1700.515,
    cy: 939.725,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EBC9BF",
    cx: 1683.905,
    cy: 956.334,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#993D97",
    cx: 1668.093,
    cy: 972.146,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2117E5",
    cx: 1653.047,
    cy: 987.192,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#558167",
    cx: 1638.734,
    cy: 1001.505,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79656B",
    cx: 1625.12,
    cy: 1015.119,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#790187",
    cx: 1612.172,
    cy: 1028.067,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#019555",
    cx: 1599.855,
    cy: 1040.384,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3BEFEF",
    cx: 1588.135,
    cy: 1052.104,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B76D23",
    cx: 1576.981,
    cy: 1063.258,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#93EBAF",
    cx: 1566.363,
    cy: 1073.876,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#672BA5",
    cx: 1556.252,
    cy: 1083.987,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C3AB23",
    cx: 1546.623,
    cy: 1093.616,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#87036F",
    cx: 1537.455,
    cy: 1102.784,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DD639F",
    cx: 1528.731,
    cy: 1111.508,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4517D3",
    cx: 1520.436,
    cy: 1119.803,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0DD171",
    cx: 1512.563,
    cy: 1127.676,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#37899F",
    cx: 1505.051,
    cy: 1135.188,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6D15F7",
    cx: 1497.892,
    cy: 1142.347,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#27C5CB",
    cx: 1491.089,
    cy: 1149.151,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F9DB0B",
    cx: 1484.63,
    cy: 1155.609,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C3CF03",
    cx: 1478.46,
    cy: 1161.779,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#53A715",
    cx: 1472.594,
    cy: 1167.646,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5139E1",
    cx: 1467.028,
    cy: 1173.211,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4BE7D3",
    cx: 1461.645,
    cy: 1178.594,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E34DCD",
    cx: 1456.294,
    cy: 1183.946,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#279B77",
    cx: 1450.943,
    cy: 1189.296,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1D85FB",
    cx: 1445.599,
    cy: 1194.641,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DB3739",
    cx: 1440.246,
    cy: 1199.993,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A307DD",
    cx: 1434.899,
    cy: 1205.34,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#392D99",
    cx: 1429.547,
    cy: 1210.692,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9D0711",
    cx: 1424.199,
    cy: 1216.04,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6B59AB",
    cx: 1418.846,
    cy: 1221.393,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0D4DC7",
    cx: 1413.5,
    cy: 1226.739,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#59B1C9",
    cx: 1408.151,
    cy: 1232.088,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D7A9A5",
    cx: 1402.798,
    cy: 1237.441,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#574515",
    cx: 1397.444,
    cy: 1242.795,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#957D05",
    cx: 1392.09,
    cy: 1248.149,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#00F1B7",
    cx: 1386.741,
    cy: 1253.498,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#85E127",
    cx: 1381.389,
    cy: 1258.85,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#631151",
    cx: 1376.044,
    cy: 1264.195,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9DC329",
    cx: 1370.69,
    cy: 1269.549,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#998F15",
    cx: 1365.335,
    cy: 1274.904,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C98BBB",
    cx: 1360.43,
    cy: 1279.809,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8F1511",
    cx: 2794.957,
    cy: 53.725,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FD27E7",
    cx: 2731.768,
    cy: 107.694,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4707B3",
    cx: 2670.082,
    cy: 160.378,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FF43EB",
    cx: 2611.344,
    cy: 210.546,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3F456F",
    cx: 2555.458,
    cy: 258.277,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ADC155",
    cx: 2502.27,
    cy: 303.703,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9D99ED",
    cx: 2451.66,
    cy: 346.929,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#911B5B",
    cx: 2403.488,
    cy: 388.071,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3785EF",
    cx: 2357.642,
    cy: 427.228,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ED9197",
    cx: 2314.018,
    cy: 464.486,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#638FDB",
    cx: 2272.535,
    cy: 499.916,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#13D319",
    cx: 2233.056,
    cy: 533.634,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1927DB",
    cx: 2195.475,
    cy: 565.731,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5D25CD",
    cx: 2159.705,
    cy: 596.282,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A793F5",
    cx: 2125.665,
    cy: 625.355,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A7291B",
    cx: 2093.27,
    cy: 653.023,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CBB1BB",
    cx: 2062.443,
    cy: 679.352,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6B1527",
    cx: 2033.112,
    cy: 704.403,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#473DD1",
    cx: 2005.195,
    cy: 728.246,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D9FB09",
    cx: 1978.615,
    cy: 750.947,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#179305",
    cx: 1953.338,
    cy: 772.536,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#116539",
    cx: 1929.287,
    cy: 793.078,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FB312D",
    cx: 1906.394,
    cy: 812.63,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#276145",
    cx: 1884.615,
    cy: 831.231,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9D7D59",
    cx: 1863.887,
    cy: 848.934,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F05F9",
    cx: 1844.158,
    cy: 865.784,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BDF18D",
    cx: 1825.397,
    cy: 881.808,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#851BBB",
    cx: 1807.536,
    cy: 897.063,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#75B313",
    cx: 1790.532,
    cy: 911.585,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#73A13B",
    cx: 1774.352,
    cy: 925.405,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDB727",
    cx: 1758.96,
    cy: 938.551,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#87D351",
    cx: 1744.32,
    cy: 951.054,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B479B",
    cx: 1730.396,
    cy: 962.947,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#435503",
    cx: 1717.15,
    cy: 974.259,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#09B9B9",
    cx: 1704.547,
    cy: 985.024,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D5B53F",
    cx: 1692.552,
    cy: 995.268,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#831999",
    cx: 1681.134,
    cy: 1005.02,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C17B69",
    cx: 1670.26,
    cy: 1014.307,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C1AF11",
    cx: 1659.906,
    cy: 1023.15,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3979B3",
    cx: 1650.047,
    cy: 1031.571,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#59235B",
    cx: 1640.665,
    cy: 1039.584,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F9AB85",
    cx: 1631.745,
    cy: 1047.202,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0527E5",
    cx: 1623.279,
    cy: 1054.433,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#331DFD",
    cx: 1615.2,
    cy: 1061.333,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7B4B45",
    cx: 1607.502,
    cy: 1067.908,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C39B4F",
    cx: 1600.186,
    cy: 1074.156,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F3F107",
    cx: 1593.24,
    cy: 1080.088,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0DA5EF",
    cx: 1586.605,
    cy: 1085.755,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#054DF5",
    cx: 1580.296,
    cy: 1091.143,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CF7BA3",
    cx: 1574.311,
    cy: 1096.255,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#91BDC9",
    cx: 1568.523,
    cy: 1101.199,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#15D90F",
    cx: 1562.768,
    cy: 1106.114,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7232D",
    cx: 1557.014,
    cy: 1111.029,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#492FD1",
    cx: 1551.267,
    cy: 1115.937,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0FDD31",
    cx: 1545.511,
    cy: 1120.853,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1D4F9F",
    cx: 1539.76,
    cy: 1125.765,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#33CD31",
    cx: 1534.005,
    cy: 1130.68,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D71D9",
    cx: 1528.254,
    cy: 1135.592,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F9073D",
    cx: 1522.498,
    cy: 1140.508,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B9A367",
    cx: 1516.749,
    cy: 1145.418,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5149CB",
    cx: 1510.996,
    cy: 1150.331,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AD9F49",
    cx: 1505.24,
    cy: 1155.248,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0B6715",
    cx: 1499.482,
    cy: 1160.165,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A72FCB",
    cx: 1493.725,
    cy: 1165.082,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#858B67",
    cx: 1487.973,
    cy: 1169.995,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#81EB17",
    cx: 1482.217,
    cy: 1174.911,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#77873F",
    cx: 1476.469,
    cy: 1179.82,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#175D37",
    cx: 1470.712,
    cy: 1184.737,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#19E7A5",
    cx: 1464.953,
    cy: 1189.656,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#534777",
    cx: 1459.678,
    cy: 1194.161,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CB410F",
    cx: 2985.98,
    cy: 84.408,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5D5791",
    cx: 2918.751,
    cy: 133.253,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F23B3",
    cx: 2853.123,
    cy: 180.935,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F933F",
    cx: 2790.629,
    cy: 226.339,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#35C3B7",
    cx: 2731.17,
    cy: 269.539,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#891F65",
    cx: 2674.583,
    cy: 310.652,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E593E3",
    cx: 2620.737,
    cy: 349.773,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#557D21",
    cx: 2569.486,
    cy: 387.01,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#53CD79",
    cx: 2520.708,
    cy: 422.448,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#137B79",
    cx: 2474.296,
    cy: 456.169,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E16B0D",
    cx: 2430.161,
    cy: 488.235,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AB4D59",
    cx: 2388.158,
    cy: 518.751,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B3A799",
    cx: 2348.175,
    cy: 547.801,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#57D1BF",
    cx: 2310.118,
    cy: 575.451,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#99C5E3",
    cx: 2273.901,
    cy: 601.764,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8D81C3",
    cx: 2239.436,
    cy: 626.805,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79B1D3",
    cx: 2206.638,
    cy: 650.634,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#19439F",
    cx: 2175.432,
    cy: 673.306,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#134BCD",
    cx: 2145.73,
    cy: 694.886,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7AB0B",
    cx: 2117.451,
    cy: 715.432,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CB3B43",
    cx: 2090.558,
    cy: 734.97,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B0145",
    cx: 2064.969,
    cy: 753.562,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4F4B2B",
    cx: 2040.614,
    cy: 771.257,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D939B3",
    cx: 2017.442,
    cy: 788.092,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C7C5DD",
    cx: 1995.389,
    cy: 804.115,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F90DAB",
    cx: 1974.399,
    cy: 819.365,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#797959",
    cx: 1954.439,
    cy: 833.867,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#29E961",
    cx: 1935.436,
    cy: 847.674,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#578B7B",
    cx: 1917.345,
    cy: 860.818,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#653D39",
    cx: 1900.13,
    cy: 873.325,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6DE3CD",
    cx: 1883.754,
    cy: 885.223,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C58193",
    cx: 1868.178,
    cy: 896.539,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A18DDF",
    cx: 1853.364,
    cy: 907.302,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4B2F27",
    cx: 1839.272,
    cy: 917.541,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D4DD9",
    cx: 1825.863,
    cy: 927.283,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2D3B7D",
    cx: 1813.101,
    cy: 936.555,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D3C363",
    cx: 1800.953,
    cy: 945.381,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EBB7E7",
    cx: 1789.384,
    cy: 953.786,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#973191",
    cx: 1778.368,
    cy: 961.79,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7F0B3F",
    cx: 1767.879,
    cy: 969.411,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CF355F",
    cx: 1757.897,
    cy: 976.663,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BF4DF1",
    cx: 1748.407,
    cy: 983.558,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4981A9",
    cx: 1739.399,
    cy: 990.103,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D545B5",
    cx: 1730.804,
    cy: 996.347,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DD19C1",
    cx: 1722.614,
    cy: 1002.298,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1785AF",
    cx: 1714.83,
    cy: 1007.953,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#474BBB",
    cx: 1707.441,
    cy: 1013.322,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#65FD05",
    cx: 1700.381,
    cy: 1018.451,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0F87F7",
    cx: 1693.669,
    cy: 1023.327,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#07FB53",
    cx: 1687.301,
    cy: 1027.954,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1F3995",
    cx: 1681.143,
    cy: 1032.428,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E7CDF7",
    cx: 1675.02,
    cy: 1036.877,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F6983",
    cx: 1668.898,
    cy: 1041.325,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#894743",
    cx: 1662.783,
    cy: 1045.767,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C70111",
    cx: 1656.66,
    cy: 1050.216,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1FE569",
    cx: 1650.542,
    cy: 1054.661,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#435D4F",
    cx: 1644.419,
    cy: 1059.11,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#85C31D",
    cx: 1638.3,
    cy: 1063.555,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B95FA5",
    cx: 1632.176,
    cy: 1068.005,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#755BF9",
    cx: 1626.059,
    cy: 1072.449,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4975FF",
    cx: 1619.939,
    cy: 1076.896,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#732551",
    cx: 1613.814,
    cy: 1081.345,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D14F29",
    cx: 1607.689,
    cy: 1085.796,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9153DD",
    cx: 1601.564,
    cy: 1090.246,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#13EDA1",
    cx: 1595.444,
    cy: 1094.692,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1775DF",
    cx: 1589.32,
    cy: 1099.142,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#97A921",
    cx: 1583.204,
    cy: 1103.585,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#334B33",
    cx: 1577.079,
    cy: 1108.035,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#87754D",
    cx: 1570.952,
    cy: 1112.487,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CB8BE3",
    cx: 1565.34,
    cy: 1116.564,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ED6D73",
    cx: 3174.007,
    cy: 129.984,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#973741",
    cx: 3103.153,
    cy: 173.404,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#41056F",
    cx: 3033.986,
    cy: 215.79,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9187EF",
    cx: 2968.123,
    cy: 256.151,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DBF935",
    cx: 2905.458,
    cy: 294.552,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#25BB09",
    cx: 2845.819,
    cy: 331.099,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B7F9F3",
    cx: 2789.069,
    cy: 365.875,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#83B379",
    cx: 2735.054,
    cy: 398.975,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#475561",
    cx: 2683.647,
    cy: 430.477,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0733F9",
    cx: 2634.732,
    cy: 460.452,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4BAB57",
    cx: 2588.217,
    cy: 488.957,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1F1751",
    cx: 2543.95,
    cy: 516.084,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B59B9F",
    cx: 2501.811,
    cy: 541.907,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D9507",
    cx: 2461.701,
    cy: 566.486,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F21E7",
    cx: 2423.532,
    cy: 589.876,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A1A735",
    cx: 2387.208,
    cy: 612.135,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#133305",
    cx: 2352.642,
    cy: 633.318,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C11DC9",
    cx: 2319.753,
    cy: 653.472,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6DD97F",
    cx: 2288.45,
    cy: 672.654,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2535F1",
    cx: 2258.646,
    cy: 690.918,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#972D55",
    cx: 2230.303,
    cy: 708.287,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#810B91",
    cx: 2203.334,
    cy: 724.813,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FDD19B",
    cx: 2177.666,
    cy: 740.543,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#39BF01",
    cx: 2153.244,
    cy: 755.509,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F652F",
    cx: 2130.002,
    cy: 769.752,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDBD67",
    cx: 2107.88,
    cy: 783.308,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7BBBE1",
    cx: 2086.844,
    cy: 796.199,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A35BFD",
    cx: 2066.816,
    cy: 808.472,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#453535",
    cx: 2047.75,
    cy: 820.156,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5D233B",
    cx: 2029.606,
    cy: 831.274,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0359E1",
    cx: 2012.347,
    cy: 841.85,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C52963",
    cx: 1995.932,
    cy: 851.91,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4389F5",
    cx: 1980.319,
    cy: 861.478,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8D3F41",
    cx: 1965.467,
    cy: 870.579,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7BA707",
    cx: 1951.335,
    cy: 879.239,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#754393",
    cx: 1937.885,
    cy: 887.481,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ABDD57",
    cx: 1925.082,
    cy: 895.327,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8D6515",
    cx: 1912.889,
    cy: 902.798,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B52915",
    cx: 1901.279,
    cy: 909.913,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AD27B3",
    cx: 1890.224,
    cy: 916.687,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9721A7",
    cx: 1879.704,
    cy: 923.134,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F9870D",
    cx: 1869.702,
    cy: 929.263,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E7DBF9",
    cx: 1860.209,
    cy: 935.081,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#07F7CB",
    cx: 1851.151,
    cy: 940.632,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0D3D05",
    cx: 1842.519,
    cy: 945.922,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DD055F",
    cx: 1834.315,
    cy: 950.949,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8D1FA5",
    cx: 1826.527,
    cy: 955.721,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8763E7",
    cx: 1819.087,
    cy: 960.28,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#89ABFD",
    cx: 1812.013,
    cy: 964.615,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#35A9B3",
    cx: 1805.302,
    cy: 968.728,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EFE979",
    cx: 1798.811,
    cy: 972.706,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#018DC1",
    cx: 1792.358,
    cy: 976.66,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#13EB2D",
    cx: 1785.906,
    cy: 980.614,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DB3DCF",
    cx: 1779.462,
    cy: 984.563,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#71AF3B",
    cx: 1773.008,
    cy: 988.518,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#217395",
    cx: 1766.56,
    cy: 992.469,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D12BDB",
    cx: 1760.107,
    cy: 996.424,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BDB561",
    cx: 1753.659,
    cy: 1000.375,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CDE33D",
    cx: 1747.204,
    cy: 1004.331,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A3330B",
    cx: 1740.757,
    cy: 1008.281,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#231F2F",
    cx: 1734.307,
    cy: 1012.234,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D74D03",
    cx: 1727.852,
    cy: 1016.189,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2777EF",
    cx: 1721.397,
    cy: 1020.145,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D593FF",
    cx: 1714.941,
    cy: 1024.101,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EF0D49",
    cx: 1708.491,
    cy: 1028.054,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#190951",
    cx: 1702.037,
    cy: 1032.009,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5B2583",
    cx: 1695.592,
    cy: 1035.958,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2D8D9D",
    cx: 1689.136,
    cy: 1039.914,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#83C7C9",
    cx: 1682.679,
    cy: 1043.872,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#69930B",
    cx: 1676.765,
    cy: 1047.496,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B7739",
    cx: 3357.879,
    cy: 190.172,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2D6B09",
    cx: 3283.837,
    cy: 227.899,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8723C1",
    cx: 3211.557,
    cy: 264.727,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#63855B",
    cx: 3142.73,
    cy: 299.796,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8905E1",
    cx: 3077.245,
    cy: 333.162,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6BA36B",
    cx: 3014.923,
    cy: 364.917,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D3325",
    cx: 2955.62,
    cy: 395.134,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CB092D",
    cx: 2899.175,
    cy: 423.894,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#41DF41",
    cx: 2845.454,
    cy: 451.266,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2F6335",
    cx: 2794.338,
    cy: 477.311,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#816D3F",
    cx: 2745.73,
    cy: 502.078,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F0941",
    cx: 2699.471,
    cy: 525.648,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D2581",
    cx: 2655.436,
    cy: 548.085,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#419969",
    cx: 2613.521,
    cy: 569.442,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F5D31",
    cx: 2573.635,
    cy: 589.765,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D4319",
    cx: 2535.677,
    cy: 609.106,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B7EF37",
    cx: 2499.554,
    cy: 627.511,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#737DD3",
    cx: 2465.186,
    cy: 645.022,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2BAB61",
    cx: 2432.474,
    cy: 661.69,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EB7B1B",
    cx: 2401.329,
    cy: 677.559,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#719319",
    cx: 2371.711,
    cy: 692.65,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1399E1",
    cx: 2343.529,
    cy: 707.01,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#47ABD5",
    cx: 2316.705,
    cy: 720.677,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#95B111",
    cx: 2291.185,
    cy: 733.68,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C3D925",
    cx: 2266.896,
    cy: 746.056,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#214523",
    cx: 2243.779,
    cy: 757.835,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B5E9B5",
    cx: 2221.796,
    cy: 769.036,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CF876F",
    cx: 2200.867,
    cy: 779.699,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B58705",
    cx: 2180.943,
    cy: 789.851,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6DCDC1",
    cx: 2161.984,
    cy: 799.512,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#59F1AD",
    cx: 2143.948,
    cy: 808.701,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#97B943",
    cx: 2126.794,
    cy: 817.442,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8DD381",
    cx: 2110.478,
    cy: 825.755,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EBE1DB",
    cx: 2094.958,
    cy: 833.663,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CB9BD5",
    cx: 2080.19,
    cy: 841.188,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EB812B",
    cx: 2066.135,
    cy: 848.349,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#27C7B7",
    cx: 2052.755,
    cy: 855.166,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A19B07",
    cx: 2040.015,
    cy: 861.658,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5BE5C3",
    cx: 2027.882,
    cy: 867.84,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A3D515",
    cx: 2016.33,
    cy: 873.726,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#73D901",
    cx: 2005.336,
    cy: 879.328,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7FDF49",
    cx: 1994.884,
    cy: 884.653,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5385C9",
    cx: 1984.964,
    cy: 889.708,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2D4F51",
    cx: 1975.498,
    cy: 894.531,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E14F7B",
    cx: 1966.477,
    cy: 899.127,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F38F27",
    cx: 1957.904,
    cy: 903.495,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#27A71D",
    cx: 1949.766,
    cy: 907.642,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C9F7D7",
    cx: 1941.991,
    cy: 911.603,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2D19D1",
    cx: 1934.599,
    cy: 915.37,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#956727",
    cx: 1927.586,
    cy: 918.943,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#15EB83",
    cx: 1920.803,
    cy: 922.399,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FDDD89",
    cx: 1914.06,
    cy: 925.835,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E95D03",
    cx: 1907.318,
    cy: 929.27,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E9AF17",
    cx: 1900.583,
    cy: 932.702,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2F7B39",
    cx: 1893.839,
    cy: 936.138,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#03516B",
    cx: 1887.101,
    cy: 939.571,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9B790B",
    cx: 1880.357,
    cy: 943.007,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2F49CD",
    cx: 1873.619,
    cy: 946.441,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#559BDB",
    cx: 1866.874,
    cy: 949.878,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FBB3ED",
    cx: 1860.137,
    cy: 953.31,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E52983",
    cx: 1853.396,
    cy: 956.745,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F1851D",
    cx: 1846.651,
    cy: 960.181,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D996F",
    cx: 1839.905,
    cy: 963.619,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3F09DD",
    cx: 1833.159,
    cy: 967.056,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#47E307",
    cx: 1826.419,
    cy: 970.49,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#994B07",
    cx: 1819.674,
    cy: 973.927,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#43E737",
    cx: 1812.939,
    cy: 977.359,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8DEB07",
    cx: 1806.193,
    cy: 980.796,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#81E115",
    cx: 1799.445,
    cy: 984.234,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FB51D9",
    cx: 1793.265,
    cy: 987.383,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#01D1BD",
    cx: 3536.461,
    cy: 264.601,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#591141",
    cx: 3459.688,
    cy: 296.402,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AFB905",
    cx: 3384.741,
    cy: 327.446,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#639D43",
    cx: 3313.375,
    cy: 357.007,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#59A545",
    cx: 3245.474,
    cy: 385.132,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FB3FD1",
    cx: 3180.852,
    cy: 411.899,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C77797",
    cx: 3119.361,
    cy: 437.37,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#899FF7",
    cx: 3060.834,
    cy: 461.613,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#13E705",
    cx: 3005.131,
    cy: 484.686,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1D7B8D",
    cx: 2952.129,
    cy: 506.639,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#39734F",
    cx: 2901.728,
    cy: 527.516,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5D470B",
    cx: 2853.762,
    cy: 547.384,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3509BD",
    cx: 2808.102,
    cy: 566.298,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A5F7B5",
    cx: 2764.641,
    cy: 584.3,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#993D7B",
    cx: 2723.283,
    cy: 601.431,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#29CF45",
    cx: 2683.924,
    cy: 617.734,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#659577",
    cx: 2646.47,
    cy: 633.248,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#490721",
    cx: 2610.833,
    cy: 648.009,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6583A9",
    cx: 2576.915,
    cy: 662.058,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#659F67",
    cx: 2544.621,
    cy: 675.435,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6969EF",
    cx: 2513.91,
    cy: 688.156,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A50771",
    cx: 2484.688,
    cy: 700.26,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#411939",
    cx: 2456.874,
    cy: 711.781,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#17F1D9",
    cx: 2430.413,
    cy: 722.742,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#99B3D9",
    cx: 2405.228,
    cy: 733.174,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#891DEB",
    cx: 2381.258,
    cy: 743.102,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#159F3F",
    cx: 2358.464,
    cy: 752.544,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8BA11B",
    cx: 2336.763,
    cy: 761.533,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F4583",
    cx: 2316.103,
    cy: 770.09,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D3AB5D",
    cx: 2296.444,
    cy: 778.233,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#23FDCD",
    cx: 2277.743,
    cy: 785.979,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#950179",
    cx: 2259.956,
    cy: 793.347,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3BEFFF",
    cx: 2243.039,
    cy: 800.354,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#87DF6B",
    cx: 2226.946,
    cy: 807.02,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#615B4B",
    cx: 2211.633,
    cy: 813.363,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#518DD9",
    cx: 2197.06,
    cy: 819.4,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E72D29",
    cx: 2183.186,
    cy: 825.146,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B54B53",
    cx: 2169.976,
    cy: 830.618,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D53715",
    cx: 2157.395,
    cy: 835.829,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E153D1",
    cx: 2145.417,
    cy: 840.791,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C7196B",
    cx: 2134.017,
    cy: 845.513,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A7CD53",
    cx: 2123.18,
    cy: 850.002,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BB25E7",
    cx: 2112.894,
    cy: 854.262,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#590959",
    cx: 2103.078,
    cy: 858.328,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#37D1C9",
    cx: 2093.725,
    cy: 862.202,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F9AFD5",
    cx: 2084.836,
    cy: 865.884,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#095FC9",
    cx: 2076.397,
    cy: 869.38,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D7101",
    cx: 2068.336,
    cy: 872.719,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4F01FB",
    cx: 2060.671,
    cy: 875.894,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8DB3AF",
    cx: 2053.399,
    cy: 878.906,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6F2119",
    cx: 2046.366,
    cy: 881.819,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0349B9",
    cx: 2039.374,
    cy: 884.715,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#21FD3B",
    cx: 2032.383,
    cy: 887.611,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AB07B9",
    cx: 2025.4,
    cy: 890.503,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1FA9CF",
    cx: 2018.407,
    cy: 893.4,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D30161",
    cx: 2011.42,
    cy: 896.294,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#533919",
    cx: 2004.428,
    cy: 899.19,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9BCD7D",
    cx: 1997.441,
    cy: 902.085,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3101ED",
    cx: 1990.447,
    cy: 904.982,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ED55C3",
    cx: 1983.461,
    cy: 907.875,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2FDF0F",
    cx: 1976.472,
    cy: 910.77,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#19BF9D",
    cx: 1969.478,
    cy: 913.667,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6D6185",
    cx: 1962.483,
    cy: 916.564,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D1CB3B",
    cx: 1955.488,
    cy: 919.462,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#01376F",
    cx: 1948.499,
    cy: 922.357,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D18505",
    cx: 1941.506,
    cy: 925.253,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1711F9",
    cx: 1934.522,
    cy: 928.146,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E195E1",
    cx: 1927.528,
    cy: 931.043,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#59E7D3",
    cx: 1920.53,
    cy: 933.942,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#29FDB9",
    cx: 1914.122,
    cy: 936.596,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4DF58D",
    cx: 3708.653,
    cy: 352.812,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3F1D1F",
    cx: 3629.621,
    cy: 378.491,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0FCD3B",
    cx: 3552.469,
    cy: 403.559,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#717521",
    cx: 3479.004,
    cy: 427.43,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#47C793",
    cx: 3409.106,
    cy: 450.141,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#47ADA1",
    cx: 3342.583,
    cy: 471.756,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4187D1",
    cx: 3279.283,
    cy: 492.323,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B571AF",
    cx: 3219.034,
    cy: 511.899,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5B011D",
    cx: 3161.693,
    cy: 530.53,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CF0519",
    cx: 3107.132,
    cy: 548.258,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A737DF",
    cx: 3055.249,
    cy: 565.116,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0567B7",
    cx: 3005.872,
    cy: 581.16,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#256553",
    cx: 2958.868,
    cy: 596.432,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D1C901",
    cx: 2914.129,
    cy: 610.969,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6137BB",
    cx: 2871.554,
    cy: 624.802,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2F01D9",
    cx: 2831.038,
    cy: 637.967,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#25697D",
    cx: 2792.481,
    cy: 650.495,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#59C71B",
    cx: 2755.796,
    cy: 662.414,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AB2331",
    cx: 2720.88,
    cy: 673.759,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5FAB39",
    cx: 2687.636,
    cy: 684.561,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0DF765",
    cx: 2656.022,
    cy: 694.833,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#55EF93",
    cx: 2625.94,
    cy: 704.607,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#599BF5",
    cx: 2597.308,
    cy: 713.91,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7DC951",
    cx: 2570.069,
    cy: 722.761,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F9C107",
    cx: 2544.143,
    cy: 731.185,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A38B77",
    cx: 2519.468,
    cy: 739.202,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F15F0D",
    cx: 2496.003,
    cy: 746.826,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9D97A1",
    cx: 2473.664,
    cy: 754.085,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#375F45",
    cx: 2452.397,
    cy: 760.995,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A5573D",
    cx: 2432.16,
    cy: 767.57,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F98323",
    cx: 2412.908,
    cy: 773.825,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C9DB07",
    cx: 2394.598,
    cy: 779.775,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#09BB95",
    cx: 2377.183,
    cy: 785.433,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C5817B",
    cx: 2360.616,
    cy: 790.816,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CDD359",
    cx: 2344.853,
    cy: 795.938,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#05037F",
    cx: 2329.852,
    cy: 800.812,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F4DC5",
    cx: 2315.57,
    cy: 805.453,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#179B51",
    cx: 2301.97,
    cy: 809.871,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#771D79",
    cx: 2289.02,
    cy: 814.079,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#99E18B",
    cx: 2276.689,
    cy: 818.086,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E3E7E9",
    cx: 2264.955,
    cy: 821.898,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#19AD8B",
    cx: 2253.798,
    cy: 825.523,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FBEFC5",
    cx: 2243.209,
    cy: 828.964,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#47650F",
    cx: 2233.105,
    cy: 832.247,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#333F1D",
    cx: 2223.477,
    cy: 835.375,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FB53D5",
    cx: 2214.326,
    cy: 838.349,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4DF1ED",
    cx: 2205.64,
    cy: 841.171,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F6757",
    cx: 2197.341,
    cy: 843.867,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C9E3B5",
    cx: 2189.45,
    cy: 846.431,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#392191",
    cx: 2181.965,
    cy: 848.864,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BD970D",
    cx: 2174.725,
    cy: 851.216,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C103A5",
    cx: 2167.527,
    cy: 853.555,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B57925",
    cx: 2160.33,
    cy: 855.893,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7B0783",
    cx: 2153.142,
    cy: 858.229,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#774D7B",
    cx: 2145.943,
    cy: 860.568,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7F3FF1",
    cx: 2138.751,
    cy: 862.904,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#93738D",
    cx: 2131.553,
    cy: 865.243,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D14735",
    cx: 2124.36,
    cy: 867.58,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BF2575",
    cx: 2117.16,
    cy: 869.92,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F10F23",
    cx: 2109.97,
    cy: 872.256,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CFBF21",
    cx: 2102.775,
    cy: 874.594,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BF3DE5",
    cx: 2095.575,
    cy: 876.933,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BB09AD",
    cx: 2088.375,
    cy: 879.273,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#537157",
    cx: 2081.174,
    cy: 881.612,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7F6F1F",
    cx: 2073.979,
    cy: 883.95,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A1AB61",
    cx: 2066.78,
    cy: 886.289,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#37FB51",
    cx: 2059.591,
    cy: 888.625,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E9179D",
    cx: 2052.391,
    cy: 890.965,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F6163",
    cx: 2045.188,
    cy: 893.305,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ED5F1D",
    cx: 2038.591,
    cy: 895.448,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#059BE9",
    cx: 3873.394,
    cy: 454.261,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1BD7EF",
    cx: 3792.59,
    cy: 473.66,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6B630B",
    cx: 3713.71,
    cy: 492.598,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F0387",
    cx: 3638.598,
    cy: 510.63,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5B83DD",
    cx: 3567.134,
    cy: 527.788,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EDD593",
    cx: 3499.12,
    cy: 544.116,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BD5B6F",
    cx: 3434.402,
    cy: 559.654,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A9779F",
    cx: 3372.802,
    cy: 574.442,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0B8F91",
    cx: 3314.176,
    cy: 588.517,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F33569",
    cx: 3258.392,
    cy: 601.91,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#45BB99",
    cx: 3205.346,
    cy: 614.645,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#65453B",
    cx: 3154.863,
    cy: 626.765,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#37FD95",
    cx: 3106.806,
    cy: 638.302,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDAF63",
    cx: 3061.064,
    cy: 649.284,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#336133",
    cx: 3017.535,
    cy: 659.734,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#514B5D",
    cx: 2976.111,
    cy: 669.68,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9DA597",
    cx: 2936.69,
    cy: 679.144,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4B976D",
    cx: 2899.183,
    cy: 688.148,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3FB9DB",
    cx: 2863.485,
    cy: 696.719,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#71C769",
    cx: 2829.495,
    cy: 704.879,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F3B9DB",
    cx: 2797.172,
    cy: 712.639,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AFFDB3",
    cx: 2766.417,
    cy: 720.023,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#83ABAF",
    cx: 2737.143,
    cy: 727.051,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BD314F",
    cx: 2709.293,
    cy: 733.737,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#933BA5",
    cx: 2682.786,
    cy: 740.101,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#13439F",
    cx: 2657.558,
    cy: 746.157,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4181C1",
    cx: 2633.568,
    cy: 751.917,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#09D7FF",
    cx: 2610.728,
    cy: 757.4,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A763DD",
    cx: 2588.984,
    cy: 762.62,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#07C3A1",
    cx: 2568.293,
    cy: 767.588,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A5FBD3",
    cx: 2548.611,
    cy: 772.313,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A5EB95",
    cx: 2529.89,
    cy: 776.808,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#15F371",
    cx: 2512.084,
    cy: 781.082,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F731E7",
    cx: 2495.147,
    cy: 785.149,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E577E1",
    cx: 2479.031,
    cy: 789.018,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D36B73",
    cx: 2463.693,
    cy: 792.7,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7774D",
    cx: 2449.091,
    cy: 796.206,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C1A137",
    cx: 2435.187,
    cy: 799.544,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0991C1",
    cx: 2421.946,
    cy: 802.723,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#01B3C7",
    cx: 2409.339,
    cy: 805.749,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4B39A5",
    cx: 2397.341,
    cy: 808.63,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A3ADFD",
    cx: 2385.935,
    cy: 811.368,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5DBF71",
    cx: 2375.109,
    cy: 813.967,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#03D383",
    cx: 2364.779,
    cy: 816.447,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8B17B1",
    cx: 2354.934,
    cy: 818.811,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#132BF9",
    cx: 2345.578,
    cy: 821.057,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#95C57D",
    cx: 2336.697,
    cy: 823.189,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#178F8B",
    cx: 2328.213,
    cy: 825.226,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6F8FA7",
    cx: 2320.145,
    cy: 827.163,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#05B107",
    cx: 2312.491,
    cy: 829,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CD611B",
    cx: 2305.089,
    cy: 830.778,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AF35CD",
    cx: 2297.73,
    cy: 832.544,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D5911",
    cx: 2290.372,
    cy: 834.311,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E3C989",
    cx: 2283.023,
    cy: 836.075,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3D970B",
    cx: 2275.663,
    cy: 837.842,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#079771",
    cx: 2268.309,
    cy: 839.608,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2949EF",
    cx: 2260.95,
    cy: 841.374,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BFD9B7",
    cx: 2253.596,
    cy: 843.14,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6B8B0D",
    cx: 2246.235,
    cy: 844.907,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F18143",
    cx: 2238.883,
    cy: 846.672,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#290561",
    cx: 2231.527,
    cy: 848.438,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#09E9F1",
    cx: 2224.166,
    cy: 850.205,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F91771",
    cx: 2216.804,
    cy: 851.973,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EBCD5B",
    cx: 2209.442,
    cy: 853.74,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4B75CD",
    cx: 2202.086,
    cy: 855.506,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#57A3D7",
    cx: 2194.726,
    cy: 857.273,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F9D17D",
    cx: 2187.376,
    cy: 859.038,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5B73E7",
    cx: 2180.014,
    cy: 860.806,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B1F901",
    cx: 2172.649,
    cy: 862.574,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F7975",
    cx: 2165.905,
    cy: 864.193,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F9F933",
    cx: 4029.667,
    cy: 568.323,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D517B3",
    cx: 3947.59,
    cy: 581.322,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1F4937",
    cx: 3867.467,
    cy: 594.013,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7B65FF",
    cx: 3791.172,
    cy: 606.096,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3D9F3D",
    cx: 3718.582,
    cy: 617.594,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E75BE9",
    cx: 3649.497,
    cy: 628.536,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C9EDB7",
    cx: 3583.759,
    cy: 638.948,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#491529",
    cx: 3521.189,
    cy: 648.858,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6351E9",
    cx: 3461.639,
    cy: 658.289,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#25F129",
    cx: 3404.977,
    cy: 667.264,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4547E1",
    cx: 3351.095,
    cy: 675.798,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2B258D",
    cx: 3299.816,
    cy: 683.92,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6DD7E7",
    cx: 3251.002,
    cy: 691.651,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#11755B",
    cx: 3204.54,
    cy: 699.01,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3707F9",
    cx: 3160.325,
    cy: 706.013,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D313D3",
    cx: 3118.248,
    cy: 712.677,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ADFB4B",
    cx: 3078.207,
    cy: 719.019,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E51B1B",
    cx: 3040.109,
    cy: 725.053,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DBE7B9",
    cx: 3003.848,
    cy: 730.796,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0BBFB7",
    cx: 2969.323,
    cy: 736.265,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CDBFA1",
    cx: 2936.491,
    cy: 741.465,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#49E901",
    cx: 2905.251,
    cy: 746.413,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#67D30B",
    cx: 2875.516,
    cy: 751.122,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0B990B",
    cx: 2847.227,
    cy: 755.603,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1957D9",
    cx: 2820.303,
    cy: 759.867,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#13CD31",
    cx: 2794.678,
    cy: 763.926,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#512149",
    cx: 2770.309,
    cy: 767.785,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F5BD5",
    cx: 2747.109,
    cy: 771.46,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AD8D27",
    cx: 2725.023,
    cy: 774.958,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F1897B",
    cx: 2704.006,
    cy: 778.287,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0007DB",
    cx: 2684.014,
    cy: 781.453,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EB0BE3",
    cx: 2664.998,
    cy: 784.465,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F3D9C7",
    cx: 2646.912,
    cy: 787.33,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D6133",
    cx: 2629.708,
    cy: 790.054,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D59531",
    cx: 2613.337,
    cy: 792.647,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#71E505",
    cx: 2597.758,
    cy: 795.115,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#93D5BF",
    cx: 2582.926,
    cy: 797.464,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EDA3E3",
    cx: 2568.803,
    cy: 799.701,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8F89BD",
    cx: 2555.354,
    cy: 801.831,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F979B",
    cx: 2542.548,
    cy: 803.859,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8FDB9F",
    cx: 2530.361,
    cy: 805.789,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DB5519",
    cx: 2518.775,
    cy: 807.624,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79874B",
    cx: 2507.778,
    cy: 809.366,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E14D47",
    cx: 2497.285,
    cy: 811.028,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#759F41",
    cx: 2487.286,
    cy: 812.612,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#75017F",
    cx: 2477.783,
    cy: 814.117,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#779381",
    cx: 2468.762,
    cy: 815.546,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#47F5CB",
    cx: 2460.143,
    cy: 816.911,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E32F79",
    cx: 2451.949,
    cy: 818.209,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#491B1B",
    cx: 2444.175,
    cy: 819.44,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D361C3",
    cx: 2436.656,
    cy: 820.631,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B179A7",
    cx: 2429.181,
    cy: 821.815,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B923E9",
    cx: 2421.707,
    cy: 822.998,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6F19CF",
    cx: 2414.242,
    cy: 824.181,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F90DB1",
    cx: 2406.766,
    cy: 825.365,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#913D17",
    cx: 2399.297,
    cy: 826.548,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C955D7",
    cx: 2391.821,
    cy: 827.732,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#877579",
    cx: 2384.352,
    cy: 828.915,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3153C9",
    cx: 2376.875,
    cy: 830.099,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C1AF45",
    cx: 2369.407,
    cy: 831.282,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#919F37",
    cx: 2361.935,
    cy: 832.465,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C1D539",
    cx: 2354.458,
    cy: 833.65,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#656D35",
    cx: 2346.98,
    cy: 834.834,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#71B9E5",
    cx: 2339.502,
    cy: 836.018,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8D2537",
    cx: 2332.03,
    cy: 837.202,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6DA183",
    cx: 2324.554,
    cy: 838.386,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E71587",
    cx: 2317.088,
    cy: 839.569,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#414F5B",
    cx: 2309.61,
    cy: 840.753,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8729D3",
    cx: 2302.129,
    cy: 841.938,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1347AD",
    cx: 2295.279,
    cy: 843.023,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DF0F77",
    cx: 4176.509,
    cy: 694.294,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#591B4D",
    cx: 4093.666,
    cy: 700.813,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#73D137",
    cx: 4012.794,
    cy: 707.178,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#19DB13",
    cx: 3935.786,
    cy: 713.239,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9FE1AB",
    cx: 3862.518,
    cy: 719.005,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#574F1F",
    cx: 3792.787,
    cy: 724.493,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#414D0D",
    cx: 3726.435,
    cy: 729.715,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EFAD9F",
    cx: 3663.28,
    cy: 734.686,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#67DF6F",
    cx: 3603.174,
    cy: 739.416,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6769FD",
    cx: 3545.982,
    cy: 743.917,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F3ED2B",
    cx: 3491.596,
    cy: 748.197,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4F8363",
    cx: 3439.839,
    cy: 752.271,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#17D77D",
    cx: 3390.569,
    cy: 756.148,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1F916F",
    cx: 3343.672,
    cy: 759.839,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#57BF7D",
    cx: 3299.044,
    cy: 763.352,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BDFDB7",
    cx: 3256.574,
    cy: 766.694,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4F6351",
    cx: 3216.158,
    cy: 769.875,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B92143",
    cx: 3177.704,
    cy: 772.901,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#491391",
    cx: 3141.105,
    cy: 775.782,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DFB31D",
    cx: 3106.258,
    cy: 778.524,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6DD731",
    cx: 3073.119,
    cy: 781.132,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E9C393",
    cx: 3041.586,
    cy: 783.614,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9995C3",
    cx: 3011.574,
    cy: 785.976,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AFC99D",
    cx: 2983.021,
    cy: 788.223,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#29AF4F",
    cx: 2955.845,
    cy: 790.362,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8B17B3",
    cx: 2929.98,
    cy: 792.398,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6FD5EB",
    cx: 2905.384,
    cy: 794.333,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DBADD7",
    cx: 2881.967,
    cy: 796.176,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6F3BF7",
    cx: 2859.675,
    cy: 797.931,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#331585",
    cx: 2838.462,
    cy: 799.6,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E56563",
    cx: 2818.282,
    cy: 801.188,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#43F535",
    cx: 2799.089,
    cy: 802.699,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D12BFD",
    cx: 2780.834,
    cy: 804.136,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5B837F",
    cx: 2763.469,
    cy: 805.502,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#992B09",
    cx: 2746.945,
    cy: 806.803,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E1E317",
    cx: 2731.22,
    cy: 808.04,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AB2DE5",
    cx: 2716.25,
    cy: 809.218,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A3D791",
    cx: 2701.995,
    cy: 810.34,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D90961",
    cx: 2688.42,
    cy: 811.409,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1DDF23",
    cx: 2675.494,
    cy: 812.426,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1197F5",
    cx: 2663.194,
    cy: 813.394,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#59D19B",
    cx: 2651.5,
    cy: 814.314,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#31B1AF",
    cx: 2640.4,
    cy: 815.188,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8B6733",
    cx: 2629.809,
    cy: 816.021,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FB4773",
    cx: 2619.716,
    cy: 816.816,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9B7139",
    cx: 2610.124,
    cy: 817.571,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A59B03",
    cx: 2601.019,
    cy: 818.287,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5B3B05",
    cx: 2592.32,
    cy: 818.972,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0DD305",
    cx: 2584.049,
    cy: 819.623,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BB63B1",
    cx: 2576.202,
    cy: 820.24,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F1D9D5",
    cx: 2568.613,
    cy: 820.838,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DBDB25",
    cx: 2561.068,
    cy: 821.432,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2F756F",
    cx: 2553.524,
    cy: 822.025,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#11BF7B",
    cx: 2545.99,
    cy: 822.618,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#73F519",
    cx: 2538.444,
    cy: 823.212,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#911F1B",
    cx: 2530.905,
    cy: 823.805,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#556787",
    cx: 2523.359,
    cy: 824.399,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#41ADB9",
    cx: 2515.82,
    cy: 824.993,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BFE345",
    cx: 2508.273,
    cy: 825.587,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D9E939",
    cx: 2500.736,
    cy: 826.18,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#39956B",
    cx: 2493.194,
    cy: 826.773,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#154DE3",
    cx: 2485.647,
    cy: 827.367,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#211D27",
    cx: 2478.099,
    cy: 827.961,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#339D49",
    cx: 2470.551,
    cy: 828.555,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#034397",
    cx: 2463.01,
    cy: 829.149,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8FFD71",
    cx: 2455.463,
    cy: 829.743,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C1DF0D",
    cx: 2447.928,
    cy: 830.336,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#57DFA5",
    cx: 2440.38,
    cy: 830.93,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AB5FB1",
    cx: 2432.83,
    cy: 831.524,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E74BC9",
    cx: 2425.915,
    cy: 832.068,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D67A9",
    cx: 4313.015,
    cy: 831.397,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E9DF73",
    cx: 4229.916,
    cy: 831.397,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#291125",
    cx: 4148.794,
    cy: 831.397,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B7B775",
    cx: 4071.548,
    cy: 831.397,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#29AB0F",
    cx: 3998.053,
    cy: 831.397,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#412F19",
    cx: 3928.106,
    cy: 831.397,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#25C5F7",
    cx: 3861.549,
    cy: 831.397,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#530765",
    cx: 3798.199,
    cy: 831.397,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5D419D",
    cx: 3737.907,
    cy: 831.397,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#234B67",
    cx: 3680.539,
    cy: 831.397,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3BABCB",
    cx: 3625.985,
    cy: 831.397,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7C9C9",
    cx: 3574.067,
    cy: 831.397,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3F07F1",
    cx: 3524.645,
    cy: 831.397,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#89A73D",
    cx: 3477.603,
    cy: 831.397,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#59353B",
    cx: 3432.837,
    cy: 831.397,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A9B563",
    cx: 3390.236,
    cy: 831.397,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#61B34B",
    cx: 3349.695,
    cy: 831.397,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5FE919",
    cx: 3311.122,
    cy: 831.397,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B3D0B",
    cx: 3274.409,
    cy: 831.397,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#65FB69",
    cx: 3239.454,
    cy: 831.397,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#59470F",
    cx: 3206.213,
    cy: 831.397,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B2117",
    cx: 3174.583,
    cy: 831.397,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BB7937",
    cx: 3144.478,
    cy: 831.397,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8B9D23",
    cx: 3115.836,
    cy: 831.397,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CDADE5",
    cx: 3088.577,
    cy: 831.397,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D3377B",
    cx: 3062.632,
    cy: 831.397,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7C1CF",
    cx: 3037.959,
    cy: 831.397,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1D27E9",
    cx: 3014.47,
    cy: 831.397,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#25E743",
    cx: 2992.109,
    cy: 831.397,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#919FBB",
    cx: 2970.83,
    cy: 831.397,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3F6D89",
    cx: 2950.588,
    cy: 831.397,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B19159",
    cx: 2931.336,
    cy: 831.397,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6359F9",
    cx: 2913.024,
    cy: 831.397,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D38BF7",
    cx: 2895.605,
    cy: 831.397,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5B21E7",
    cx: 2879.031,
    cy: 831.397,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5BA1EF",
    cx: 2863.257,
    cy: 831.397,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#39F72B",
    cx: 2848.24,
    cy: 831.397,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B95D1B",
    cx: 2833.941,
    cy: 831.397,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F3550B",
    cx: 2820.324,
    cy: 831.397,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1D592B",
    cx: 2807.359,
    cy: 831.397,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8B3181",
    cx: 2795.021,
    cy: 831.397,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0D599F",
    cx: 2783.29,
    cy: 831.397,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7F1BE5",
    cx: 2772.156,
    cy: 831.397,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DD8925",
    cx: 2761.532,
    cy: 831.397,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F99755",
    cx: 2751.408,
    cy: 831.397,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#013BF7",
    cx: 2741.787,
    cy: 831.397,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6DE3E3",
    cx: 2732.653,
    cy: 831.397,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0F91B7",
    cx: 2723.927,
    cy: 831.397,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#257549",
    cx: 2715.631,
    cy: 831.397,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8D5903",
    cx: 2707.76,
    cy: 831.397,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#21394D",
    cx: 2700.147,
    cy: 831.397,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2F5D4B",
    cx: 2692.579,
    cy: 831.397,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4DF903",
    cx: 2685.012,
    cy: 831.397,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DBAB2B",
    cx: 2677.454,
    cy: 831.397,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C17535",
    cx: 2669.885,
    cy: 831.397,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BF4F25",
    cx: 2662.322,
    cy: 831.397,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7CB11",
    cx: 2654.754,
    cy: 831.397,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7DB57B",
    cx: 2647.191,
    cy: 831.397,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1F274B",
    cx: 2639.621,
    cy: 831.397,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2D5FAD",
    cx: 2632.06,
    cy: 831.397,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#093BFB",
    cx: 2624.495,
    cy: 831.397,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#37D5C1",
    cx: 2616.925,
    cy: 831.397,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E97349",
    cx: 2609.353,
    cy: 831.397,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AD3389",
    cx: 2601.782,
    cy: 831.397,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1F457B",
    cx: 2594.217,
    cy: 831.397,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BD63E7",
    cx: 2586.648,
    cy: 831.397,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D25E5",
    cx: 2579.089,
    cy: 831.397,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B9E775",
    cx: 2571.518,
    cy: 831.397,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D7345",
    cx: 2563.944,
    cy: 831.397,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#897799",
    cx: 2557.008,
    cy: 831.397,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E70155",
    cx: 4438.343,
    cy: 978.789,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#23C97B",
    cx: 4355.5,
    cy: 972.269,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9305B5",
    cx: 4274.628,
    cy: 965.904,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C3C351",
    cx: 4197.62,
    cy: 959.843,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B1B09",
    cx: 4124.352,
    cy: 954.077,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#63E55D",
    cx: 4054.621,
    cy: 948.589,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#75E1E9",
    cx: 3988.269,
    cy: 943.367,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EDE1EF",
    cx: 3925.114,
    cy: 938.397,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C135E5",
    cx: 3865.008,
    cy: 933.666,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9D2F25",
    cx: 3807.816,
    cy: 929.165,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#797745",
    cx: 3753.43,
    cy: 924.885,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7A9CB",
    cx: 3701.672,
    cy: 920.811,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EB83D5",
    cx: 3652.403,
    cy: 916.934,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A3EDC3",
    cx: 3605.506,
    cy: 913.243,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#25EF95",
    cx: 3560.878,
    cy: 909.731,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#913723",
    cx: 3518.408,
    cy: 906.388,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1165CD",
    cx: 3477.992,
    cy: 903.207,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2741BB",
    cx: 3439.538,
    cy: 900.181,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B45A5",
    cx: 3402.939,
    cy: 897.301,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#019F35",
    cx: 3368.092,
    cy: 894.558,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B03F3",
    cx: 3334.953,
    cy: 891.95,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#19D915",
    cx: 3303.42,
    cy: 889.468,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A7D14B",
    cx: 3273.408,
    cy: 887.106,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8B07AD",
    cx: 3244.855,
    cy: 884.859,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7F07AB",
    cx: 3217.679,
    cy: 882.72,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#234943",
    cx: 3191.814,
    cy: 880.685,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9DABED",
    cx: 3167.218,
    cy: 878.749,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8BC93D",
    cx: 3143.801,
    cy: 876.906,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#57F3A3",
    cx: 3121.509,
    cy: 875.152,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#73A391",
    cx: 3100.296,
    cy: 873.482,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0D63D5",
    cx: 3080.116,
    cy: 871.894,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A9055F",
    cx: 3060.923,
    cy: 870.383,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#39C900",
    cx: 3042.668,
    cy: 868.947,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#17E5C1",
    cx: 3025.302,
    cy: 867.58,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#63D95D",
    cx: 3008.779,
    cy: 866.28,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#791B9F",
    cx: 2993.054,
    cy: 865.042,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#655FB1",
    cx: 2978.084,
    cy: 863.864,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1F0BF7",
    cx: 2963.829,
    cy: 862.742,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0DEB99",
    cx: 2950.254,
    cy: 861.673,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#61D7BB",
    cx: 2937.328,
    cy: 860.656,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5189E5",
    cx: 2925.028,
    cy: 859.688,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#791939",
    cx: 2913.333,
    cy: 858.768,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0BA521",
    cx: 2902.234,
    cy: 857.894,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8D51DD",
    cx: 2891.643,
    cy: 857.061,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#411377",
    cx: 2881.55,
    cy: 856.266,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1F25D5",
    cx: 2871.958,
    cy: 855.511,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F72341",
    cx: 2862.853,
    cy: 854.795,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C95393",
    cx: 2854.154,
    cy: 854.11,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#11AFA7",
    cx: 2845.883,
    cy: 853.459,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FD1781",
    cx: 2838.036,
    cy: 852.842,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BFDDBD",
    cx: 2830.447,
    cy: 852.244,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#750107",
    cx: 2822.902,
    cy: 851.651,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#45251F",
    cx: 2815.358,
    cy: 851.057,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#730D67",
    cx: 2807.823,
    cy: 850.464,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F1A32F",
    cx: 2800.278,
    cy: 849.87,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4581FD",
    cx: 2792.739,
    cy: 849.277,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D9A579",
    cx: 2785.193,
    cy: 848.683,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#49595F",
    cx: 2777.654,
    cy: 848.09,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D383A9",
    cx: 2770.107,
    cy: 847.496,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D38B31",
    cx: 2762.57,
    cy: 846.902,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#137D91",
    cx: 2755.028,
    cy: 846.309,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#053541",
    cx: 2747.481,
    cy: 845.715,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4F8D6B",
    cx: 2739.933,
    cy: 845.121,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B39161",
    cx: 2732.385,
    cy: 844.527,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#01EBDB",
    cx: 2724.844,
    cy: 843.933,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0F89EF",
    cx: 2717.297,
    cy: 843.339,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#75478B",
    cx: 2709.762,
    cy: 842.746,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C5234D",
    cx: 2702.214,
    cy: 842.152,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B35729",
    cx: 2694.664,
    cy: 841.558,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C39143",
    cx: 2687.749,
    cy: 841.014,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E9BF9B",
    cx: 4551.721,
    cy: 1135.559,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#85EFF5",
    cx: 4469.645,
    cy: 1122.559,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#75E309",
    cx: 4389.521,
    cy: 1109.869,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#794D39",
    cx: 4313.227,
    cy: 1097.785,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#13D76B",
    cx: 4240.636,
    cy: 1086.288,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2537CF",
    cx: 4171.551,
    cy: 1075.346,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AB1F51",
    cx: 4105.813,
    cy: 1064.934,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#378383",
    cx: 4043.243,
    cy: 1055.024,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4B8D65",
    cx: 3983.693,
    cy: 1045.592,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9FCF49",
    cx: 3927.031,
    cy: 1036.618,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#673DD9",
    cx: 3873.149,
    cy: 1028.084,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A7BD07",
    cx: 3821.87,
    cy: 1019.962,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EB9545",
    cx: 3773.056,
    cy: 1012.231,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F5AF39",
    cx: 3726.594,
    cy: 1004.872,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#09B72B",
    cx: 3682.379,
    cy: 997.869,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F73D43",
    cx: 3640.302,
    cy: 991.205,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9157C7",
    cx: 3600.261,
    cy: 984.863,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C5E56B",
    cx: 3562.163,
    cy: 978.828,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4F8F3F",
    cx: 3525.902,
    cy: 973.085,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EF8BD7",
    cx: 3491.377,
    cy: 967.617,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E3B7D9",
    cx: 3458.545,
    cy: 962.417,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#47A7CB",
    cx: 3427.305,
    cy: 957.469,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C7CB5B",
    cx: 3397.57,
    cy: 952.76,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D1E9A9",
    cx: 3369.281,
    cy: 948.279,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#21B111",
    cx: 3342.357,
    cy: 944.015,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8D5D41",
    cx: 3316.732,
    cy: 939.956,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1719D3",
    cx: 3292.363,
    cy: 936.096,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#950F33",
    cx: 3269.164,
    cy: 932.422,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B145A9",
    cx: 3247.077,
    cy: 928.924,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D3A9F5",
    cx: 3226.061,
    cy: 925.595,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A1D975",
    cx: 3206.068,
    cy: 922.429,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#356717",
    cx: 3187.052,
    cy: 919.417,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EB63DD",
    cx: 3168.966,
    cy: 916.552,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7DEF35",
    cx: 3151.762,
    cy: 913.827,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AFF9CB",
    cx: 3135.391,
    cy: 911.234,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8D7D43",
    cx: 3119.812,
    cy: 908.767,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#45192B",
    cx: 3104.98,
    cy: 906.418,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0377C5",
    cx: 3090.857,
    cy: 904.181,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0DE36B",
    cx: 3077.408,
    cy: 902.051,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CD6B63",
    cx: 3064.602,
    cy: 900.023,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D233D",
    cx: 3052.415,
    cy: 898.092,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A557AF",
    cx: 3040.829,
    cy: 896.257,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FD357D",
    cx: 3029.833,
    cy: 894.516,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0F3B17",
    cx: 3019.34,
    cy: 892.854,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#39D9DF",
    cx: 3009.34,
    cy: 891.27,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#19FB59",
    cx: 2999.837,
    cy: 889.765,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CD61E9",
    cx: 2990.816,
    cy: 888.336,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F817F",
    cx: 2982.198,
    cy: 886.971,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8D2731",
    cx: 2974.003,
    cy: 885.673,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BD5F25",
    cx: 2966.229,
    cy: 884.442,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C5A945",
    cx: 2958.71,
    cy: 883.251,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C3E973",
    cx: 2951.235,
    cy: 882.067,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E1FB73",
    cx: 2943.761,
    cy: 880.883,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F3552B",
    cx: 2936.296,
    cy: 879.701,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BD3781",
    cx: 2928.82,
    cy: 878.517,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4BF1E7",
    cx: 2921.351,
    cy: 877.334,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BF1D5F",
    cx: 2913.875,
    cy: 876.15,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B7BFAB",
    cx: 2906.406,
    cy: 874.967,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#214731",
    cx: 2898.928,
    cy: 873.782,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D5339D",
    cx: 2891.461,
    cy: 872.6,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#81CDDB",
    cx: 2883.989,
    cy: 871.416,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7B2B31",
    cx: 2876.512,
    cy: 870.232,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BFE915",
    cx: 2869.034,
    cy: 869.048,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A3EF55",
    cx: 2861.556,
    cy: 867.863,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E11FB9",
    cx: 2854.084,
    cy: 866.68,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#815DEF",
    cx: 2846.608,
    cy: 865.496,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#89D749",
    cx: 2839.142,
    cy: 864.313,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2313BF",
    cx: 2831.664,
    cy: 863.129,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B76101",
    cx: 2824.184,
    cy: 861.944,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3909B3",
    cx: 2817.333,
    cy: 860.859,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3715BD",
    cx: 4652.449,
    cy: 1300.741,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4F6B67",
    cx: 4571.646,
    cy: 1281.342,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#37DD41",
    cx: 4492.765,
    cy: 1262.404,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDB1E5",
    cx: 4417.653,
    cy: 1244.372,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9941AB",
    cx: 4346.189,
    cy: 1227.215,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4B29C1",
    cx: 4278.175,
    cy: 1210.886,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A35FC9",
    cx: 4213.457,
    cy: 1195.349,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CD673B",
    cx: 4151.857,
    cy: 1180.56,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4F63CB",
    cx: 4093.231,
    cy: 1166.485,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#91D5B5",
    cx: 4037.448,
    cy: 1153.092,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#57D37F",
    cx: 3984.401,
    cy: 1140.357,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#35D9C7",
    cx: 3933.918,
    cy: 1128.237,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0F0F07",
    cx: 3885.861,
    cy: 1116.7,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#57B3E7",
    cx: 3840.119,
    cy: 1105.718,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CD4575",
    cx: 3796.59,
    cy: 1095.268,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B709E5",
    cx: 3755.166,
    cy: 1085.323,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4993FB",
    cx: 3715.746,
    cy: 1075.859,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D3B15",
    cx: 3678.238,
    cy: 1066.854,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7B579B",
    cx: 3642.54,
    cy: 1058.283,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#618DF7",
    cx: 3608.551,
    cy: 1050.123,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#37BFB1",
    cx: 3576.228,
    cy: 1042.363,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D78337",
    cx: 3545.472,
    cy: 1034.979,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F2BD1",
    cx: 3516.198,
    cy: 1027.952,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B1E559",
    cx: 3488.348,
    cy: 1021.265,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D16B65",
    cx: 3461.842,
    cy: 1014.902,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9D5F13",
    cx: 3436.614,
    cy: 1008.845,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#55C143",
    cx: 3412.623,
    cy: 1003.085,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A3C31F",
    cx: 3389.783,
    cy: 997.602,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#35AF93",
    cx: 3368.04,
    cy: 992.382,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#711715",
    cx: 3347.349,
    cy: 987.414,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3959D3",
    cx: 3327.666,
    cy: 982.689,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FD3D2B",
    cx: 3308.946,
    cy: 978.195,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#796D31",
    cx: 3291.14,
    cy: 973.92,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#85F123",
    cx: 3274.202,
    cy: 969.853,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#21B739",
    cx: 3258.086,
    cy: 965.984,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#13613F",
    cx: 3242.748,
    cy: 962.302,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C3977B",
    cx: 3228.146,
    cy: 958.796,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CBF725",
    cx: 3214.242,
    cy: 955.458,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDE573",
    cx: 3201.001,
    cy: 952.279,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EB7F1F",
    cx: 3188.394,
    cy: 949.253,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5B4B23",
    cx: 3176.397,
    cy: 946.372,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0BBDB5",
    cx: 3164.99,
    cy: 943.634,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B76335",
    cx: 3154.164,
    cy: 941.035,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#130DE9",
    cx: 3143.834,
    cy: 938.555,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CBA53B",
    cx: 3133.99,
    cy: 936.191,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#973BAD",
    cx: 3124.634,
    cy: 933.945,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7787E7",
    cx: 3115.753,
    cy: 931.813,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D7B76D",
    cx: 3107.268,
    cy: 929.776,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#77B3DF",
    cx: 3099.2,
    cy: 927.839,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EBDB39",
    cx: 3091.547,
    cy: 926.002,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3BB3DB",
    cx: 3084.145,
    cy: 924.225,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#43BDBD",
    cx: 3076.786,
    cy: 922.458,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B72969",
    cx: 3069.428,
    cy: 920.691,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C571B3",
    cx: 3062.078,
    cy: 918.927,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B7AD67",
    cx: 3054.718,
    cy: 917.16,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#359B1D",
    cx: 3047.365,
    cy: 915.394,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FD210F",
    cx: 3040.005,
    cy: 913.628,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#930DE5",
    cx: 3032.652,
    cy: 911.862,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9B8527",
    cx: 3025.29,
    cy: 910.095,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E55905",
    cx: 3017.939,
    cy: 908.33,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BD97E1",
    cx: 3010.583,
    cy: 906.564,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CB6FAB",
    cx: 3003.222,
    cy: 904.797,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#671D3D",
    cx: 2995.859,
    cy: 903.029,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7FD5C9",
    cx: 2988.497,
    cy: 901.262,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#51E151",
    cx: 2981.142,
    cy: 899.496,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8989CF",
    cx: 2973.781,
    cy: 897.729,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DF593D",
    cx: 2966.431,
    cy: 895.964,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDCFA9",
    cx: 2959.069,
    cy: 894.197,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2DB1FB",
    cx: 2951.705,
    cy: 892.429,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0FB751",
    cx: 2944.96,
    cy: 890.809,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#359DBD",
    cx: 4739.906,
    cy: 1473.317,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#49C719",
    cx: 4660.874,
    cy: 1447.638,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#73F1CD",
    cx: 4583.722,
    cy: 1422.57,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0F51A9",
    cx: 4510.257,
    cy: 1398.7,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B7E12D",
    cx: 4440.359,
    cy: 1375.989,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#417DD9",
    cx: 4373.836,
    cy: 1354.374,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#232391",
    cx: 4310.536,
    cy: 1333.807,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#653BCF",
    cx: 4250.287,
    cy: 1314.23,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#474541",
    cx: 4192.946,
    cy: 1295.599,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CF65CD",
    cx: 4138.385,
    cy: 1277.871,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1F93B9",
    cx: 4086.501,
    cy: 1261.013,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BD516B",
    cx: 4037.124,
    cy: 1244.97,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D9FBC9",
    cx: 3990.121,
    cy: 1229.697,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3749CD",
    cx: 3945.382,
    cy: 1215.161,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#91E925",
    cx: 3902.807,
    cy: 1201.327,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1D63BF",
    cx: 3862.29,
    cy: 1188.163,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6FBD9F",
    cx: 3823.734,
    cy: 1175.635,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1DD911",
    cx: 3787.049,
    cy: 1163.715,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#91CF03",
    cx: 3752.133,
    cy: 1152.37,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A59F45",
    cx: 3718.889,
    cy: 1141.569,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F54571",
    cx: 3687.274,
    cy: 1131.297,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F791C1",
    cx: 3657.193,
    cy: 1121.522,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F91741",
    cx: 3628.561,
    cy: 1112.219,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BB71EB",
    cx: 3601.321,
    cy: 1103.369,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2FF121",
    cx: 3575.396,
    cy: 1094.945,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DBBB91",
    cx: 3550.72,
    cy: 1086.927,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EF6B1F",
    cx: 3527.256,
    cy: 1079.303,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#978BD7",
    cx: 3504.917,
    cy: 1072.045,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DF5D75",
    cx: 3483.649,
    cy: 1065.135,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3569F9",
    cx: 3463.412,
    cy: 1058.559,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#23D9A1",
    cx: 3444.161,
    cy: 1052.304,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#550FF1",
    cx: 3425.851,
    cy: 1046.355,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C3C103",
    cx: 3408.435,
    cy: 1040.696,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BFC92D",
    cx: 3391.869,
    cy: 1035.313,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5D5B4F",
    cx: 3376.106,
    cy: 1030.192,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4F8BC7",
    cx: 3361.104,
    cy: 1025.317,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#015341",
    cx: 3346.822,
    cy: 1020.677,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F9C313",
    cx: 3333.223,
    cy: 1016.258,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4F73B7",
    cx: 3320.272,
    cy: 1012.05,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1327ED",
    cx: 3307.942,
    cy: 1008.044,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#072727",
    cx: 3296.207,
    cy: 1004.231,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6987D5",
    cx: 3285.051,
    cy: 1000.606,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4907B9",
    cx: 3274.462,
    cy: 997.166,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E349E5",
    cx: 3264.358,
    cy: 993.883,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1DC139",
    cx: 3254.729,
    cy: 990.754,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#13592D",
    cx: 3245.579,
    cy: 987.781,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FB0511",
    cx: 3236.892,
    cy: 984.958,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#057945",
    cx: 3228.594,
    cy: 982.262,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8F6511",
    cx: 3220.703,
    cy: 979.698,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#69CBCF",
    cx: 3213.217,
    cy: 977.266,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#398DA9",
    cx: 3205.977,
    cy: 974.914,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#35A12D",
    cx: 3198.78,
    cy: 972.575,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FDEB81",
    cx: 3191.583,
    cy: 970.237,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#97F37B",
    cx: 3184.395,
    cy: 967.901,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4F533D",
    cx: 3177.196,
    cy: 965.562,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#856BC1",
    cx: 3170.003,
    cy: 963.225,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ADE167",
    cx: 3162.805,
    cy: 960.886,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3DEBE9",
    cx: 3155.613,
    cy: 958.549,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#450567",
    cx: 3148.413,
    cy: 956.21,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7B6161",
    cx: 3141.222,
    cy: 953.873,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79A369",
    cx: 3134.028,
    cy: 951.536,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8D0B41",
    cx: 3126.828,
    cy: 949.196,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0731A1",
    cx: 3119.627,
    cy: 946.857,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#75D375",
    cx: 3112.427,
    cy: 944.517,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DFB319",
    cx: 3105.232,
    cy: 942.179,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#270F75",
    cx: 3098.033,
    cy: 939.84,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6FF745",
    cx: 3090.844,
    cy: 937.505,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#59779F",
    cx: 3083.643,
    cy: 935.165,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#73C193",
    cx: 3076.44,
    cy: 932.824,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#19A749",
    cx: 3069.843,
    cy: 930.681,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5715CD",
    cx: 4813.555,
    cy: 1652.223,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0767EF",
    cx: 4736.781,
    cy: 1620.422,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E5D937",
    cx: 4661.834,
    cy: 1589.379,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1D65BB",
    cx: 4590.468,
    cy: 1559.818,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0B0305",
    cx: 4522.567,
    cy: 1531.692,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D36715",
    cx: 4457.945,
    cy: 1504.925,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E383A1",
    cx: 4396.455,
    cy: 1479.455,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4DAF03",
    cx: 4337.927,
    cy: 1455.212,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D5773",
    cx: 4282.224,
    cy: 1432.139,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5BB329",
    cx: 4229.223,
    cy: 1410.185,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F536D",
    cx: 4178.821,
    cy: 1389.308,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D7C3EF",
    cx: 4130.855,
    cy: 1369.44,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4DCDDD",
    cx: 4085.195,
    cy: 1350.527,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BD9B2F",
    cx: 4041.735,
    cy: 1332.525,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#331B3F",
    cx: 4000.376,
    cy: 1315.394,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#139D4F",
    cx: 3961.018,
    cy: 1299.091,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3FE787",
    cx: 3923.563,
    cy: 1283.577,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ADAF0B",
    cx: 3887.926,
    cy: 1268.815,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5D0DF9",
    cx: 3854.008,
    cy: 1254.766,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CB35C5",
    cx: 3821.714,
    cy: 1241.389,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F9A38F",
    cx: 3791.003,
    cy: 1228.668,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2B4931",
    cx: 3761.781,
    cy: 1216.564,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BBA14D",
    cx: 3733.967,
    cy: 1205.043,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FDF73D",
    cx: 3707.506,
    cy: 1194.083,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#254D19",
    cx: 3682.321,
    cy: 1183.651,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B7EFEF",
    cx: 3658.351,
    cy: 1173.722,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3931F9",
    cx: 3635.557,
    cy: 1164.281,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#571D93",
    cx: 3613.856,
    cy: 1155.292,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B2F2D",
    cx: 3593.197,
    cy: 1146.734,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EB9D77",
    cx: 3573.538,
    cy: 1138.591,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8F37C7",
    cx: 3554.836,
    cy: 1130.845,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AFC75F",
    cx: 3537.049,
    cy: 1123.478,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#85450D",
    cx: 3520.132,
    cy: 1116.47,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#77035F",
    cx: 3504.039,
    cy: 1109.804,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#63B509",
    cx: 3488.726,
    cy: 1103.461,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#11594F",
    cx: 3474.153,
    cy: 1097.425,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#857D79",
    cx: 3460.279,
    cy: 1091.678,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#19C35D",
    cx: 3447.069,
    cy: 1086.206,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#873D1F",
    cx: 3434.488,
    cy: 1080.995,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EB43D3",
    cx: 3422.51,
    cy: 1076.034,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#47F161",
    cx: 3411.111,
    cy: 1071.312,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2751AB",
    cx: 3400.273,
    cy: 1066.823,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#179B33",
    cx: 3389.987,
    cy: 1062.562,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6D4BF5",
    cx: 3380.171,
    cy: 1058.497,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D9197F",
    cx: 3370.818,
    cy: 1054.622,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F3ED41",
    cx: 3361.929,
    cy: 1050.94,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CDAB6D",
    cx: 3353.491,
    cy: 1047.445,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CBCBB1",
    cx: 3345.429,
    cy: 1044.106,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7FA587",
    cx: 3337.764,
    cy: 1040.931,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4BE347",
    cx: 3330.492,
    cy: 1037.919,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A32D41",
    cx: 3323.459,
    cy: 1035.005,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AFF3E9",
    cx: 3316.467,
    cy: 1032.109,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CFC125",
    cx: 3309.476,
    cy: 1029.214,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9FE973",
    cx: 3302.493,
    cy: 1026.321,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#976B6D",
    cx: 3295.5,
    cy: 1023.424,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F5FDEF",
    cx: 3288.513,
    cy: 1020.53,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0B2745",
    cx: 3281.521,
    cy: 1017.634,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#573BE5",
    cx: 3274.534,
    cy: 1014.74,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#999587",
    cx: 3267.54,
    cy: 1011.843,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D97D1D",
    cx: 3260.554,
    cy: 1008.95,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4711B9",
    cx: 3253.565,
    cy: 1006.055,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7791B",
    cx: 3246.571,
    cy: 1003.158,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4DB573",
    cx: 3239.576,
    cy: 1000.26,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#819BED",
    cx: 3232.582,
    cy: 997.363,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C15915",
    cx: 3225.593,
    cy: 994.468,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B35D99",
    cx: 3218.599,
    cy: 991.571,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#359B4D",
    cx: 3211.616,
    cy: 988.678,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6F4BF5",
    cx: 3204.621,
    cy: 985.781,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F18527",
    cx: 3197.624,
    cy: 982.883,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F55129",
    cx: 3191.215,
    cy: 980.228,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F1763",
    cx: 4872.938,
    cy: 1836.356,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#699BB7",
    cx: 4798.896,
    cy: 1798.629,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#67C7F5",
    cx: 4726.616,
    cy: 1761.801,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B1FF31",
    cx: 4657.789,
    cy: 1726.732,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B1C5A7",
    cx: 4592.304,
    cy: 1693.366,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C1E74B",
    cx: 4529.981,
    cy: 1661.611,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E33583",
    cx: 4470.679,
    cy: 1631.395,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#758FEB",
    cx: 4414.233,
    cy: 1602.634,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A79D65",
    cx: 4360.513,
    cy: 1575.262,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#93DB13",
    cx: 4309.397,
    cy: 1549.218,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B5157F",
    cx: 4260.789,
    cy: 1524.45,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#956FB1",
    cx: 4214.53,
    cy: 1500.88,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7F679D",
    cx: 4170.495,
    cy: 1478.443,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#11139D",
    cx: 4128.58,
    cy: 1457.087,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8BD195",
    cx: 4088.693,
    cy: 1436.763,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#018901",
    cx: 4050.735,
    cy: 1417.423,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3389AF",
    cx: 4014.613,
    cy: 1399.018,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4975CD",
    cx: 3980.244,
    cy: 1381.506,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ADB3D5",
    cx: 3947.533,
    cy: 1364.839,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6933C1",
    cx: 3916.388,
    cy: 1348.969,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#01F1A9",
    cx: 3886.77,
    cy: 1333.878,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6FB711",
    cx: 3858.587,
    cy: 1319.519,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#61597D",
    cx: 3831.763,
    cy: 1305.851,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A14583",
    cx: 3806.244,
    cy: 1292.848,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F4B55",
    cx: 3781.955,
    cy: 1280.472,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79578D",
    cx: 3758.838,
    cy: 1268.694,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2DEBAD",
    cx: 3736.855,
    cy: 1257.493,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#29FDA9",
    cx: 3715.926,
    cy: 1246.829,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#73DBB1",
    cx: 3696.002,
    cy: 1236.677,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A1F919",
    cx: 3677.042,
    cy: 1227.017,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C7E3CB",
    cx: 3659.007,
    cy: 1217.827,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D7CD1F",
    cx: 3641.853,
    cy: 1209.087,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#398313",
    cx: 3625.537,
    cy: 1200.773,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#75BF0B",
    cx: 3610.016,
    cy: 1192.865,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#41CDB7",
    cx: 3595.248,
    cy: 1185.341,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6BD1DB",
    cx: 3581.194,
    cy: 1178.179,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F6D0B",
    cx: 3567.814,
    cy: 1171.362,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8B2175",
    cx: 3555.073,
    cy: 1164.87,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878349",
    cx: 3542.94,
    cy: 1158.688,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E9651D",
    cx: 3531.388,
    cy: 1152.802,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C7019B",
    cx: 3520.395,
    cy: 1147.201,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#35D7CB",
    cx: 3509.943,
    cy: 1141.875,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8D3D7D",
    cx: 3500.022,
    cy: 1136.821,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A5C3A5",
    cx: 3490.557,
    cy: 1131.997,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D3F7F",
    cx: 3481.536,
    cy: 1127.401,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E7B10B",
    cx: 3472.963,
    cy: 1123.033,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8D5129",
    cx: 3464.825,
    cy: 1118.886,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DBD16B",
    cx: 3457.05,
    cy: 1114.925,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#393D93",
    cx: 3449.658,
    cy: 1111.158,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D3290F",
    cx: 3442.645,
    cy: 1107.585,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5BEFAF",
    cx: 3435.862,
    cy: 1104.129,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#67C3E7",
    cx: 3429.119,
    cy: 1100.693,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A5BBB5",
    cx: 3422.376,
    cy: 1097.258,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#09554B",
    cx: 3415.642,
    cy: 1093.827,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#25178B",
    cx: 3408.898,
    cy: 1090.39,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C13F17",
    cx: 3402.159,
    cy: 1086.957,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFB89",
    cx: 3395.416,
    cy: 1083.521,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#377729",
    cx: 3388.677,
    cy: 1080.087,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5967D5",
    cx: 3381.932,
    cy: 1076.651,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F79B2D",
    cx: 3375.196,
    cy: 1073.218,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#49E9F3",
    cx: 3368.455,
    cy: 1069.784,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F915DF",
    cx: 3361.71,
    cy: 1066.347,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ABB75D",
    cx: 3354.964,
    cy: 1062.91,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#67BD17",
    cx: 3348.218,
    cy: 1059.472,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#11F3E7",
    cx: 3341.478,
    cy: 1056.038,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F4591",
    cx: 3334.733,
    cy: 1052.601,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0B056F",
    cx: 3327.998,
    cy: 1049.17,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7FC397",
    cx: 3321.252,
    cy: 1045.732,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A1571F",
    cx: 3314.504,
    cy: 1042.294,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E77DDD",
    cx: 3308.323,
    cy: 1039.145,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3F09E7",
    cx: 4917.693,
    cy: 2024.58,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#81BD45",
    cx: 4846.839,
    cy: 1981.161,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#717D21",
    cx: 4777.671,
    cy: 1938.775,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3D65B5",
    cx: 4711.808,
    cy: 1898.414,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#53CB69",
    cx: 4649.143,
    cy: 1860.013,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B6D1D",
    cx: 4589.504,
    cy: 1823.466,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5D274F",
    cx: 4532.754,
    cy: 1788.69,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#13574B",
    cx: 4478.74,
    cy: 1755.59,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3DB5B7",
    cx: 4427.333,
    cy: 1724.087,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D175AD",
    cx: 4378.418,
    cy: 1694.112,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C71F2D",
    cx: 4331.903,
    cy: 1665.608,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#696197",
    cx: 4287.636,
    cy: 1638.481,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A731EB",
    cx: 4245.496,
    cy: 1612.658,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#77033F",
    cx: 4205.387,
    cy: 1588.079,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D3C14D",
    cx: 4167.218,
    cy: 1564.689,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#35DB9B",
    cx: 4130.894,
    cy: 1542.429,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#593101",
    cx: 4096.327,
    cy: 1521.247,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2F2153",
    cx: 4063.438,
    cy: 1501.093,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#77D3D9",
    cx: 4032.136,
    cy: 1481.91,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6B4D9F",
    cx: 4002.332,
    cy: 1463.646,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#05375B",
    cx: 3973.989,
    cy: 1446.278,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8DFBB5",
    cx: 3947.02,
    cy: 1429.751,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EB0BB9",
    cx: 3921.351,
    cy: 1414.021,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6FA98B",
    cx: 3896.93,
    cy: 1399.056,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F11339",
    cx: 3873.687,
    cy: 1384.813,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79A9AD",
    cx: 3851.566,
    cy: 1371.257,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9743A7",
    cx: 3830.529,
    cy: 1358.366,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AF6F4F",
    cx: 3810.501,
    cy: 1346.093,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AFB57B",
    cx: 3791.435,
    cy: 1334.409,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1545F1",
    cx: 3773.292,
    cy: 1323.291,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E5790F",
    cx: 3756.033,
    cy: 1312.714,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8F8FED",
    cx: 3739.617,
    cy: 1302.655,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DF7389",
    cx: 3724.004,
    cy: 1293.087,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A77D2D",
    cx: 3709.152,
    cy: 1283.986,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#51D1DD",
    cx: 3695.02,
    cy: 1275.326,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D561EB",
    cx: 3681.571,
    cy: 1267.084,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#45B9E1",
    cx: 3668.767,
    cy: 1259.238,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F74F9D",
    cx: 3656.575,
    cy: 1251.766,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F3A7EF",
    cx: 3644.965,
    cy: 1244.652,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B58F73",
    cx: 3633.91,
    cy: 1237.877,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BDF94D",
    cx: 3623.39,
    cy: 1231.431,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B92949",
    cx: 3613.388,
    cy: 1225.301,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1F5967",
    cx: 3603.895,
    cy: 1219.484,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E74589",
    cx: 3594.836,
    cy: 1213.933,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#034B9F",
    cx: 3586.204,
    cy: 1208.643,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8D6949",
    cx: 3578,
    cy: 1203.616,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3FFD5F",
    cx: 3570.213,
    cy: 1198.844,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#712D45",
    cx: 3562.773,
    cy: 1194.284,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#794F11",
    cx: 3555.698,
    cy: 1189.949,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3D9B97",
    cx: 3548.987,
    cy: 1185.837,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B12967",
    cx: 3542.497,
    cy: 1181.859,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#05613D",
    cx: 3536.044,
    cy: 1177.905,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F0333",
    cx: 3529.592,
    cy: 1173.951,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#39C189",
    cx: 3523.147,
    cy: 1170.002,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#954FB7",
    cx: 3516.694,
    cy: 1166.047,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DBBB7D",
    cx: 3510.246,
    cy: 1162.096,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#098315",
    cx: 3503.792,
    cy: 1158.141,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#17E593",
    cx: 3497.344,
    cy: 1154.19,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B59BBD",
    cx: 3490.889,
    cy: 1150.234,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#714DCF",
    cx: 3484.443,
    cy: 1146.284,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#674D5F",
    cx: 3477.993,
    cy: 1142.331,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#533B9B",
    cx: 3471.538,
    cy: 1138.376,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8DCB7D",
    cx: 3465.082,
    cy: 1134.42,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E3D30B",
    cx: 3458.627,
    cy: 1130.464,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FB39F3",
    cx: 3452.177,
    cy: 1126.511,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F9B23",
    cx: 3445.723,
    cy: 1122.556,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2BF5B7",
    cx: 3439.278,
    cy: 1118.606,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#27A3B3",
    cx: 3432.822,
    cy: 1114.651,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#61FF85",
    cx: 3426.364,
    cy: 1110.693,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1D776F",
    cx: 3420.45,
    cy: 1107.069,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D25B3",
    cx: 4947.541,
    cy: 2215.736,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#63DDCB",
    cx: 4880.312,
    cy: 2166.892,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DB134D",
    cx: 4814.683,
    cy: 2119.209,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9771E9",
    cx: 4752.189,
    cy: 2073.805,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#475FE9",
    cx: 4692.73,
    cy: 2030.606,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2145CF",
    cx: 4636.143,
    cy: 1989.493,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9DA1E7",
    cx: 4582.297,
    cy: 1950.371,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#318DCF",
    cx: 4531.045,
    cy: 1913.135,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#879BD9",
    cx: 4482.268,
    cy: 1877.696,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D5C5AF",
    cx: 4435.856,
    cy: 1843.976,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F5658D",
    cx: 4391.721,
    cy: 1811.91,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5511B3",
    cx: 4349.719,
    cy: 1781.393,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#530D07",
    cx: 4309.735,
    cy: 1752.344,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BFE56B",
    cx: 4271.678,
    cy: 1724.693,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CF1165",
    cx: 4235.461,
    cy: 1698.381,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8759C1",
    cx: 4200.996,
    cy: 1673.34,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8B03F7",
    cx: 4168.198,
    cy: 1649.511,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#19575F",
    cx: 4136.992,
    cy: 1626.838,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BB5D49",
    cx: 4107.291,
    cy: 1605.259,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#739707",
    cx: 4079.011,
    cy: 1584.713,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#414DD1",
    cx: 4052.118,
    cy: 1565.174,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E589A7",
    cx: 4026.53,
    cy: 1546.583,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#552B27",
    cx: 4002.174,
    cy: 1528.887,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#61CF01",
    cx: 3979.002,
    cy: 1512.052,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#53B9E9",
    cx: 3956.949,
    cy: 1496.029,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E32961",
    cx: 3935.959,
    cy: 1480.779,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#51F5C3",
    cx: 3915.999,
    cy: 1466.277,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8105CD",
    cx: 3896.996,
    cy: 1452.471,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3FDF69",
    cx: 3878.905,
    cy: 1439.327,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#57B5C7",
    cx: 3861.69,
    cy: 1426.82,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B99375",
    cx: 3845.314,
    cy: 1414.922,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F81ED",
    cx: 3829.738,
    cy: 1403.605,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5B49B5",
    cx: 3814.924,
    cy: 1392.842,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C9CDAD",
    cx: 3800.832,
    cy: 1382.604,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9FF903",
    cx: 3787.423,
    cy: 1372.861,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4945CB",
    cx: 3774.662,
    cy: 1363.59,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7553D",
    cx: 3762.513,
    cy: 1354.763,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0D130B",
    cx: 3750.945,
    cy: 1346.358,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6905D7",
    cx: 3739.928,
    cy: 1338.355,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#73F395",
    cx: 3729.439,
    cy: 1330.734,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AB0FC9",
    cx: 3719.457,
    cy: 1323.481,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#75C5B9",
    cx: 3709.967,
    cy: 1316.586,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8DF75D",
    cx: 3700.959,
    cy: 1310.042,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BDB1DB",
    cx: 3692.365,
    cy: 1303.797,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#077D5F",
    cx: 3684.174,
    cy: 1297.847,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8F998F",
    cx: 3676.39,
    cy: 1292.191,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#15E7EF",
    cx: 3669.001,
    cy: 1286.823,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79556F",
    cx: 3661.941,
    cy: 1281.694,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#59F53F",
    cx: 3655.229,
    cy: 1276.817,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#05F949",
    cx: 3648.861,
    cy: 1272.191,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#69770F",
    cx: 3642.703,
    cy: 1267.716,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3D5795",
    cx: 3636.58,
    cy: 1263.268,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F3F791",
    cx: 3630.458,
    cy: 1258.82,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D993B3",
    cx: 3624.344,
    cy: 1254.377,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9153B9",
    cx: 3618.22,
    cy: 1249.928,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#95577F",
    cx: 3612.102,
    cy: 1245.483,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#651F41",
    cx: 3605.979,
    cy: 1241.035,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0DE1EF",
    cx: 3599.86,
    cy: 1236.589,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#73B94B",
    cx: 3593.736,
    cy: 1232.14,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#19C593",
    cx: 3587.619,
    cy: 1227.696,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#458B9B",
    cx: 3581.499,
    cy: 1223.249,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6F1DED",
    cx: 3575.374,
    cy: 1218.799,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#136DEB",
    cx: 3569.249,
    cy: 1214.349,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E3DD4B",
    cx: 3563.124,
    cy: 1209.899,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3DF5D3",
    cx: 3557.004,
    cy: 1205.452,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#631D9F",
    cx: 3550.88,
    cy: 1201.003,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D7A747",
    cx: 3544.764,
    cy: 1196.56,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7DD377",
    cx: 3538.639,
    cy: 1192.11,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#477557",
    cx: 3532.512,
    cy: 1187.658,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#31273F",
    cx: 3526.9,
    cy: 1183.581,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C1E177",
    cx: 4962.298,
    cy: 2408.644,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#59234D",
    cx: 4899.108,
    cy: 2354.675,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AB9973",
    cx: 4837.423,
    cy: 2301.99,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B5B791",
    cx: 4778.685,
    cy: 2251.823,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#49D367",
    cx: 4722.798,
    cy: 2204.092,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2B3557",
    cx: 4669.611,
    cy: 2158.666,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#733BE3",
    cx: 4619,
    cy: 2115.44,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BDCB13",
    cx: 4570.829,
    cy: 2074.298,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B57DB1",
    cx: 4524.982,
    cy: 2035.141,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5BC34F",
    cx: 4481.359,
    cy: 1997.883,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1383F9",
    cx: 4439.875,
    cy: 1962.453,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5B3921",
    cx: 4400.397,
    cy: 1928.735,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E10B23",
    cx: 4362.816,
    cy: 1896.638,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D1D5D5",
    cx: 4327.045,
    cy: 1866.087,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#09A1D1",
    cx: 4293.005,
    cy: 1837.014,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#73D147",
    cx: 4260.611,
    cy: 1809.346,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0DCFFD",
    cx: 4229.783,
    cy: 1783.017,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#912F75",
    cx: 4200.452,
    cy: 1757.966,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D9561",
    cx: 4172.536,
    cy: 1734.123,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C33537",
    cx: 4145.956,
    cy: 1711.422,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F17DF3",
    cx: 4120.679,
    cy: 1689.833,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9B4F69",
    cx: 4096.627,
    cy: 1669.291,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C31307",
    cx: 4073.735,
    cy: 1649.74,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0565D7",
    cx: 4051.956,
    cy: 1631.138,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6F7909",
    cx: 4031.227,
    cy: 1613.435,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D10F57",
    cx: 4011.499,
    cy: 1596.585,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D3632F",
    cx: 3992.738,
    cy: 1580.561,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9155B1",
    cx: 3974.876,
    cy: 1565.307,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8B1157",
    cx: 3957.873,
    cy: 1550.784,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#933DB3",
    cx: 3941.692,
    cy: 1536.964,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D0DBD",
    cx: 3926.3,
    cy: 1523.818,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B3FB89",
    cx: 3911.661,
    cy: 1511.315,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#154113",
    cx: 3897.736,
    cy: 1499.422,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8FA3C1",
    cx: 3884.491,
    cy: 1488.11,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D7A909",
    cx: 3871.887,
    cy: 1477.345,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7FC78F",
    cx: 3859.893,
    cy: 1467.101,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2F336B",
    cx: 3848.474,
    cy: 1457.349,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#711921",
    cx: 3837.601,
    cy: 1448.062,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3F3F63",
    cx: 3827.247,
    cy: 1439.219,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B1D55D",
    cx: 3817.388,
    cy: 1430.798,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B9D935",
    cx: 3808.006,
    cy: 1422.785,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2D699D",
    cx: 3799.086,
    cy: 1415.167,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D5A5CD",
    cx: 3790.619,
    cy: 1407.936,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EDE937",
    cx: 3782.541,
    cy: 1401.036,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F39B07",
    cx: 3774.843,
    cy: 1394.461,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#21A955",
    cx: 3767.526,
    cy: 1388.213,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#298B29",
    cx: 3760.581,
    cy: 1382.281,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#23CD83",
    cx: 3753.946,
    cy: 1376.614,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#215521",
    cx: 3747.637,
    cy: 1371.226,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FBB383",
    cx: 3741.652,
    cy: 1366.114,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B7A7E3",
    cx: 3735.863,
    cy: 1361.17,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D39FCF",
    cx: 3730.108,
    cy: 1356.255,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#33C561",
    cx: 3724.354,
    cy: 1351.34,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2BDFE3",
    cx: 3718.607,
    cy: 1346.432,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7FFD95",
    cx: 3712.851,
    cy: 1341.516,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#41EDDD",
    cx: 3707.101,
    cy: 1336.604,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#05D7AB",
    cx: 3701.346,
    cy: 1331.689,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AB8773",
    cx: 3695.595,
    cy: 1326.777,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C14927",
    cx: 3689.838,
    cy: 1321.861,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#81570D",
    cx: 3684.089,
    cy: 1316.951,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1D33C7",
    cx: 3678.337,
    cy: 1312.038,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D36515",
    cx: 3672.58,
    cy: 1307.121,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4F1FD9",
    cx: 3666.823,
    cy: 1302.204,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ABF9FB",
    cx: 3661.066,
    cy: 1297.287,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0BD36F",
    cx: 3655.313,
    cy: 1292.374,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#53FD5B",
    cx: 3649.558,
    cy: 1287.458,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CF1F8D",
    cx: 3643.81,
    cy: 1282.549,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EDF115",
    cx: 3638.052,
    cy: 1277.632,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#631DCF",
    cx: 3632.293,
    cy: 1272.713,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9371A9",
    cx: 3627.019,
    cy: 1268.208,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1765A5",
    cx: 4961.875,
    cy: 2602.115,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B3F5D7",
    cx: 4903.115,
    cy: 2543.355,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#371D81",
    cx: 4845.753,
    cy: 2485.993,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2715CB",
    cx: 4791.132,
    cy: 2431.372,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#43AFAD",
    cx: 4739.163,
    cy: 2379.403,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#079793",
    cx: 4689.704,
    cy: 2329.944,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#257387",
    cx: 4642.641,
    cy: 2282.88,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FB59A7",
    cx: 4597.846,
    cy: 2238.085,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#05CD79",
    cx: 4555.212,
    cy: 2195.452,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C3F945",
    cx: 4514.647,
    cy: 2154.887,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C5173F",
    cx: 4476.071,
    cy: 2116.311,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B79D3",
    cx: 4439.36,
    cy: 2079.6,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4925CF",
    cx: 4404.413,
    cy: 2044.653,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8F15AB",
    cx: 4371.15,
    cy: 2011.39,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#551BC7",
    cx: 4339.496,
    cy: 1979.735,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#113FEB",
    cx: 4309.372,
    cy: 1949.611,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#99498F",
    cx: 4280.705,
    cy: 1920.945,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FF5189",
    cx: 4253.43,
    cy: 1893.67,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79A925",
    cx: 4227.47,
    cy: 1867.71,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6F3F65",
    cx: 4202.753,
    cy: 1842.993,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A5B53D",
    cx: 4179.248,
    cy: 1819.488,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AF99D5",
    cx: 4156.882,
    cy: 1797.122,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7B010D",
    cx: 4135.595,
    cy: 1775.835,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#13E1C1",
    cx: 4115.342,
    cy: 1755.582,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E3EF97",
    cx: 4096.066,
    cy: 1736.306,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#13BF4D",
    cx: 4077.721,
    cy: 1717.961,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#47ABE9",
    cx: 4060.275,
    cy: 1700.515,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1D4781",
    cx: 4043.666,
    cy: 1683.905,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F3EB9B",
    cx: 4027.854,
    cy: 1668.094,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#91BB9D",
    cx: 4012.807,
    cy: 1653.047,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5563FB",
    cx: 3998.494,
    cy: 1638.734,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#63B757",
    cx: 3984.881,
    cy: 1625.12,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9D5115",
    cx: 3971.932,
    cy: 1612.172,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDF1E9",
    cx: 3959.615,
    cy: 1599.855,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#756B7B",
    cx: 3947.895,
    cy: 1588.135,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8FC52B",
    cx: 3936.742,
    cy: 1576.981,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B57B9D",
    cx: 3926.123,
    cy: 1566.363,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E5C937",
    cx: 3916.012,
    cy: 1556.252,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CD77E9",
    cx: 3906.384,
    cy: 1546.623,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#555B97",
    cx: 3897.216,
    cy: 1537.456,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#299335",
    cx: 3888.491,
    cy: 1528.731,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B9C369",
    cx: 3880.196,
    cy: 1520.436,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7993F3",
    cx: 3872.323,
    cy: 1512.563,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6199E5",
    cx: 3864.811,
    cy: 1505.051,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#55F1D1",
    cx: 3857.653,
    cy: 1497.892,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#476559",
    cx: 3850.849,
    cy: 1491.089,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#518775",
    cx: 3844.391,
    cy: 1484.63,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EDB5B7",
    cx: 3838.221,
    cy: 1478.46,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B90D07",
    cx: 3832.354,
    cy: 1472.594,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#153D5B",
    cx: 3826.788,
    cy: 1467.028,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8B0385",
    cx: 3821.406,
    cy: 1461.645,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AFCD95",
    cx: 3816.054,
    cy: 1456.294,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#055F87",
    cx: 3810.703,
    cy: 1450.943,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2F6D79",
    cx: 3805.359,
    cy: 1445.599,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3575BF",
    cx: 3800.007,
    cy: 1440.246,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D523D1",
    cx: 3794.659,
    cy: 1434.899,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C75D23",
    cx: 3789.307,
    cy: 1429.547,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#51A1BB",
    cx: 3783.96,
    cy: 1424.2,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#773B43",
    cx: 3778.607,
    cy: 1418.847,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EBA195",
    cx: 3773.26,
    cy: 1413.5,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3D4B97",
    cx: 3767.911,
    cy: 1408.151,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D54D1B",
    cx: 3762.558,
    cy: 1402.798,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0147FB",
    cx: 3757.204,
    cy: 1397.444,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#236575",
    cx: 3751.851,
    cy: 1392.091,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7F6D01",
    cx: 3746.502,
    cy: 1386.742,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2D1507",
    cx: 3741.149,
    cy: 1381.389,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#57EBEF",
    cx: 3735.804,
    cy: 1376.044,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CFA9AF",
    cx: 3730.45,
    cy: 1370.69,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2723CB",
    cx: 3725.095,
    cy: 1365.335,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4FF973",
    cx: 3720.19,
    cy: 1360.43,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B96535",
    cx: 4946.274,
    cy: 2794.957,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E9B52F",
    cx: 4892.306,
    cy: 2731.768,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A5718B",
    cx: 4839.621,
    cy: 2670.083,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7DE5F1",
    cx: 4789.454,
    cy: 2611.344,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0FA1D5",
    cx: 4741.723,
    cy: 2555.458,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#638DE1",
    cx: 4696.296,
    cy: 2502.271,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D4BC3",
    cx: 4653.071,
    cy: 2451.66,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2DC777",
    cx: 4611.928,
    cy: 2403.488,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#99EBFB",
    cx: 4572.771,
    cy: 2357.642,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BB8971",
    cx: 4535.514,
    cy: 2314.018,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8503ED",
    cx: 4500.084,
    cy: 2272.535,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A7D5F1",
    cx: 4466.366,
    cy: 2233.056,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F3F3D",
    cx: 4434.269,
    cy: 2195.476,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#255589",
    cx: 4403.718,
    cy: 2159.705,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#07FD61",
    cx: 4374.645,
    cy: 2125.665,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#43435B",
    cx: 4346.977,
    cy: 2093.27,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F38715",
    cx: 4320.648,
    cy: 2062.443,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EF1D4D",
    cx: 4295.597,
    cy: 2033.112,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A96193",
    cx: 4271.754,
    cy: 2005.195,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5BDF47",
    cx: 4249.052,
    cy: 1978.615,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#417F9D",
    cx: 4227.464,
    cy: 1953.338,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F7309",
    cx: 4206.922,
    cy: 1929.287,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AD733F",
    cx: 4187.37,
    cy: 1906.395,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FBA500",
    cx: 4168.769,
    cy: 1884.615,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#41872F",
    cx: 4151.065,
    cy: 1863.887,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FDEDB5",
    cx: 4134.215,
    cy: 1844.158,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#610B83",
    cx: 4118.192,
    cy: 1825.397,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F058D",
    cx: 4102.937,
    cy: 1807.536,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#35DDD9",
    cx: 4088.415,
    cy: 1790.532,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8F21D5",
    cx: 4074.595,
    cy: 1774.352,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F73D0D",
    cx: 4061.449,
    cy: 1758.96,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#33D7D5",
    cx: 4048.946,
    cy: 1744.32,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1BD77B",
    cx: 4037.053,
    cy: 1730.396,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#65FD91",
    cx: 4025.74,
    cy: 1717.15,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#37194F",
    cx: 4014.976,
    cy: 1704.547,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AD1DBB",
    cx: 4004.732,
    cy: 1692.553,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#05AF7B",
    cx: 3994.979,
    cy: 1681.134,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C13519",
    cx: 3985.693,
    cy: 1670.261,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D6B25",
    cx: 3976.849,
    cy: 1659.906,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F34B49",
    cx: 3968.429,
    cy: 1650.047,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BFC737",
    cx: 3960.416,
    cy: 1640.665,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#113BA5",
    cx: 3952.797,
    cy: 1631.745,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A7837B",
    cx: 3945.567,
    cy: 1623.279,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A56FA3",
    cx: 3938.667,
    cy: 1615.201,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5D6317",
    cx: 3932.092,
    cy: 1607.502,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#37A1A5",
    cx: 3925.843,
    cy: 1600.186,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ADD1CB",
    cx: 3919.911,
    cy: 1593.241,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4B7119",
    cx: 3914.244,
    cy: 1586.605,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5FD1DB",
    cx: 3908.856,
    cy: 1580.297,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#41ABFD",
    cx: 3903.744,
    cy: 1574.311,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1BF19F",
    cx: 3898.801,
    cy: 1568.523,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1DB7A9",
    cx: 3893.885,
    cy: 1562.768,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B3E9CF",
    cx: 3888.971,
    cy: 1557.014,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D77B41",
    cx: 3884.062,
    cy: 1551.267,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D9E36F",
    cx: 3879.146,
    cy: 1545.511,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#43C31D",
    cx: 3874.235,
    cy: 1539.76,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#191B49",
    cx: 3869.32,
    cy: 1534.005,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B316F",
    cx: 3864.408,
    cy: 1528.255,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EBF14B",
    cx: 3859.491,
    cy: 1522.498,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F2BB7",
    cx: 3854.581,
    cy: 1516.749,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#67615D",
    cx: 3849.668,
    cy: 1510.996,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B54B03",
    cx: 3844.752,
    cy: 1505.24,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#67C12B",
    cx: 3839.834,
    cy: 1499.483,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#433B83",
    cx: 3834.917,
    cy: 1493.725,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FBD713",
    cx: 3830.004,
    cy: 1487.973,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C1012B",
    cx: 3825.088,
    cy: 1482.217,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#992DDF",
    cx: 3820.179,
    cy: 1476.469,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8931D1",
    cx: 3815.262,
    cy: 1470.712,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F18F00",
    cx: 3810.344,
    cy: 1464.953,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F53359",
    cx: 3805.839,
    cy: 1459.679,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C1F75B",
    cx: 4915.592,
    cy: 2985.98,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#355B63",
    cx: 4866.747,
    cy: 2918.751,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7DAD53",
    cx: 4819.065,
    cy: 2853.123,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3FEB3F",
    cx: 4773.661,
    cy: 2790.629,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B812B",
    cx: 4730.462,
    cy: 2731.17,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2F19D9",
    cx: 4689.348,
    cy: 2674.583,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#258771",
    cx: 4650.227,
    cy: 2620.737,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EF73AB",
    cx: 4612.991,
    cy: 2569.486,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8FF7E9",
    cx: 4577.552,
    cy: 2520.708,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AB7F83",
    cx: 4543.832,
    cy: 2474.296,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#219B03",
    cx: 4511.766,
    cy: 2430.161,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0FF94B",
    cx: 4481.249,
    cy: 2388.159,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#330913",
    cx: 4452.199,
    cy: 2348.175,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BF21F7",
    cx: 4424.549,
    cy: 2310.118,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BFFB93",
    cx: 4398.236,
    cy: 2273.901,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#93E95B",
    cx: 4373.196,
    cy: 2239.436,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8155BB",
    cx: 4349.367,
    cy: 2206.638,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EFDDA3",
    cx: 4326.694,
    cy: 2175.432,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CD05AB",
    cx: 4305.115,
    cy: 2145.731,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A17B83",
    cx: 4284.569,
    cy: 2117.451,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C79355",
    cx: 4265.03,
    cy: 2090.559,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#112DC9",
    cx: 4246.438,
    cy: 2064.97,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B96F8F",
    cx: 4228.743,
    cy: 2040.614,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C9155F",
    cx: 4211.908,
    cy: 2017.443,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E15973",
    cx: 4195.885,
    cy: 1995.389,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#45A9E7",
    cx: 4180.635,
    cy: 1974.399,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FB7D89",
    cx: 4166.133,
    cy: 1954.439,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AFD391",
    cx: 4152.327,
    cy: 1935.436,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6F3DC3",
    cx: 4139.183,
    cy: 1917.345,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FD4D4D",
    cx: 4126.675,
    cy: 1900.13,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D7C785",
    cx: 4114.778,
    cy: 1883.754,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9B07C5",
    cx: 4103.461,
    cy: 1868.178,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#717B2D",
    cx: 4092.698,
    cy: 1853.364,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1BF39F",
    cx: 4082.459,
    cy: 1839.272,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#273567",
    cx: 4072.717,
    cy: 1825.863,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#698B27",
    cx: 4063.446,
    cy: 1813.102,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#89F909",
    cx: 4054.619,
    cy: 1800.953,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B3A7FB",
    cx: 4046.214,
    cy: 1789.385,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3187BD",
    cx: 4038.21,
    cy: 1778.368,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D591FB",
    cx: 4030.59,
    cy: 1767.879,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#676393",
    cx: 4023.337,
    cy: 1757.897,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AF0969",
    cx: 4016.442,
    cy: 1748.407,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#23215D",
    cx: 4009.898,
    cy: 1739.399,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D787CF",
    cx: 4003.653,
    cy: 1730.805,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#676361",
    cx: 3997.703,
    cy: 1722.614,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CBF30D",
    cx: 3992.047,
    cy: 1714.83,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#39D975",
    cx: 3986.678,
    cy: 1707.441,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#314F99",
    cx: 3981.55,
    cy: 1700.381,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1715D3",
    cx: 3976.673,
    cy: 1693.669,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#693301",
    cx: 3972.046,
    cy: 1687.301,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CFE125",
    cx: 3967.572,
    cy: 1681.143,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#456D07",
    cx: 3963.124,
    cy: 1675.02,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9D957F",
    cx: 3958.676,
    cy: 1668.898,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1F7553",
    cx: 3954.233,
    cy: 1662.784,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D70189",
    cx: 3949.784,
    cy: 1656.66,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0BB16D",
    cx: 3945.339,
    cy: 1650.542,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3DE72F",
    cx: 3940.89,
    cy: 1644.419,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6FED7D",
    cx: 3936.445,
    cy: 1638.3,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#21DD6F",
    cx: 3931.995,
    cy: 1632.176,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C305A3",
    cx: 3927.551,
    cy: 1626.059,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A1D383",
    cx: 3923.105,
    cy: 1619.939,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#95AB4F",
    cx: 3918.655,
    cy: 1613.814,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F95FFD",
    cx: 3914.205,
    cy: 1607.689,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CB0B51",
    cx: 3909.754,
    cy: 1601.564,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B925C9",
    cx: 3905.308,
    cy: 1595.444,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CB672B",
    cx: 3900.859,
    cy: 1589.32,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#17D773",
    cx: 3896.416,
    cy: 1583.205,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#47D543",
    cx: 3891.965,
    cy: 1577.079,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#65FD03",
    cx: 3887.514,
    cy: 1570.952,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D7496F",
    cx: 3883.437,
    cy: 1565.34,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#499747",
    cx: 4870.016,
    cy: 3174.007,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#11D905",
    cx: 4826.597,
    cy: 3103.153,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D87A1",
    cx: 4784.21,
    cy: 3033.986,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#355B89",
    cx: 4743.85,
    cy: 2968.123,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C159E9",
    cx: 4705.449,
    cy: 2905.458,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2F8BB9",
    cx: 4668.902,
    cy: 2845.819,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F75B19",
    cx: 4634.125,
    cy: 2789.069,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#25B7B1",
    cx: 4601.025,
    cy: 2735.055,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878B41",
    cx: 4569.523,
    cy: 2683.647,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#032373",
    cx: 4539.548,
    cy: 2634.732,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BD55C9",
    cx: 4511.043,
    cy: 2588.218,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#03756D",
    cx: 4483.917,
    cy: 2543.95,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#437FC3",
    cx: 4458.093,
    cy: 2501.811,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8BE155",
    cx: 4433.514,
    cy: 2461.701,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EBF349",
    cx: 4410.124,
    cy: 2423.532,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#353387",
    cx: 4387.865,
    cy: 2387.208,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#670F9D",
    cx: 4366.683,
    cy: 2352.642,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F63CF",
    cx: 4346.528,
    cy: 2319.753,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FB7B29",
    cx: 4327.346,
    cy: 2288.45,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3D8357",
    cx: 4309.082,
    cy: 2258.646,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CD33B9",
    cx: 4291.713,
    cy: 2230.303,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#551B25",
    cx: 4275.187,
    cy: 2203.334,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#87AB49",
    cx: 4259.457,
    cy: 2177.666,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E53B8F",
    cx: 4244.492,
    cy: 2153.245,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BFC3AD",
    cx: 4230.249,
    cy: 2130.002,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#73F3C5",
    cx: 4216.692,
    cy: 2107.88,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C3019F",
    cx: 4203.801,
    cy: 2086.844,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6F2B5D",
    cx: 4191.528,
    cy: 2066.816,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A333D9",
    cx: 4179.844,
    cy: 2047.75,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A9B17B",
    cx: 4168.726,
    cy: 2029.607,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F6F13",
    cx: 4158.15,
    cy: 2012.348,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FDBB9D",
    cx: 4148.09,
    cy: 1995.932,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C5AF45",
    cx: 4138.522,
    cy: 1980.319,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C9C3D7",
    cx: 4129.421,
    cy: 1965.467,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#873F71",
    cx: 4120.761,
    cy: 1951.335,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#41C5C5",
    cx: 4112.52,
    cy: 1937.885,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#13F785",
    cx: 4104.673,
    cy: 1925.082,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4FC527",
    cx: 4097.202,
    cy: 1912.89,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F51B65",
    cx: 4090.087,
    cy: 1901.279,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#35A323",
    cx: 4083.313,
    cy: 1890.225,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D727A9",
    cx: 4076.866,
    cy: 1879.704,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4921E3",
    cx: 4070.737,
    cy: 1869.702,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A55F83",
    cx: 4064.919,
    cy: 1860.209,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#695BC7",
    cx: 4059.368,
    cy: 1851.151,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7FEDF9",
    cx: 4054.079,
    cy: 1842.519,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3F0303",
    cx: 4049.051,
    cy: 1834.315,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D315DD",
    cx: 4044.279,
    cy: 1826.527,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C9790D",
    cx: 4039.72,
    cy: 1819.087,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A37333",
    cx: 4035.385,
    cy: 1812.013,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#314BD1",
    cx: 4031.272,
    cy: 1805.302,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8B576B",
    cx: 4027.295,
    cy: 1798.811,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7CF31",
    cx: 4023.34,
    cy: 1792.359,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A5797B",
    cx: 4019.387,
    cy: 1785.906,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B6381",
    cx: 4015.438,
    cy: 1779.462,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#83C107",
    cx: 4011.483,
    cy: 1773.008,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#670F49",
    cx: 4007.531,
    cy: 1766.56,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CD6967",
    cx: 4003.577,
    cy: 1760.107,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#69C773",
    cx: 3999.625,
    cy: 1753.659,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C90F95",
    cx: 3995.67,
    cy: 1747.204,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D1D171",
    cx: 3991.719,
    cy: 1740.757,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#25C399",
    cx: 3987.767,
    cy: 1734.307,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6B7FC5",
    cx: 3983.811,
    cy: 1727.853,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BDBD3B",
    cx: 3979.855,
    cy: 1721.397,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1D0FF1",
    cx: 3975.899,
    cy: 1714.941,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4B25AF",
    cx: 3971.947,
    cy: 1708.491,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7BE123",
    cx: 3967.991,
    cy: 1702.037,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1DBFC3",
    cx: 3964.042,
    cy: 1695.592,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DD174D",
    cx: 3960.086,
    cy: 1689.137,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#71D91D",
    cx: 3956.129,
    cy: 1682.679,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AFB197",
    cx: 3952.504,
    cy: 1676.765,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#39F73D",
    cx: 4809.828,
    cy: 3357.878,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6D9109",
    cx: 4772.101,
    cy: 3283.836,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ABEF23",
    cx: 4735.272,
    cy: 3211.556,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#27F7FB",
    cx: 4700.204,
    cy: 3142.73,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4B2FD3",
    cx: 4666.837,
    cy: 3077.245,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F961F5",
    cx: 4635.083,
    cy: 3014.922,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DD2F9D",
    cx: 4604.866,
    cy: 2955.619,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#039795",
    cx: 4576.106,
    cy: 2899.174,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#83CFDF",
    cx: 4548.734,
    cy: 2845.453,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F3E787",
    cx: 4522.689,
    cy: 2794.338,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5D8713",
    cx: 4497.922,
    cy: 2745.73,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6F370D",
    cx: 4474.352,
    cy: 2699.471,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2D7789",
    cx: 4451.915,
    cy: 2655.435,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79A15B",
    cx: 4430.558,
    cy: 2613.521,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1FABD1",
    cx: 4410.235,
    cy: 2573.634,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B3EB0D",
    cx: 4390.895,
    cy: 2535.676,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D58983",
    cx: 4372.489,
    cy: 2499.554,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#57078F",
    cx: 4354.978,
    cy: 2465.185,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#81EDD7",
    cx: 4338.311,
    cy: 2432.474,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#779DDD",
    cx: 4322.441,
    cy: 2401.329,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B961B9",
    cx: 4307.35,
    cy: 2371.71,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CDD303",
    cx: 4292.99,
    cy: 2343.528,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F5ED4D",
    cx: 4279.323,
    cy: 2316.704,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1D49E3",
    cx: 4266.32,
    cy: 2291.184,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D58B95",
    cx: 4253.944,
    cy: 2266.896,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4DDBCD",
    cx: 4242.165,
    cy: 2243.779,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DBE141",
    cx: 4230.964,
    cy: 2221.796,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#53F783",
    cx: 4220.3,
    cy: 2200.867,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EDFD7F",
    cx: 4210.148,
    cy: 2180.942,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#397DB7",
    cx: 4200.488,
    cy: 2161.983,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#315795",
    cx: 4191.299,
    cy: 2143.948,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#77D3A3",
    cx: 4182.558,
    cy: 2126.793,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#933119",
    cx: 4174.245,
    cy: 2110.478,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F972F",
    cx: 4166.337,
    cy: 2094.957,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AF23EF",
    cx: 4158.812,
    cy: 2080.189,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#29E55B",
    cx: 4151.651,
    cy: 2066.135,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#554341",
    cx: 4144.833,
    cy: 2052.755,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#07FB43",
    cx: 4138.342,
    cy: 2040.014,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B54BE7",
    cx: 4132.16,
    cy: 2027.881,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ED4FF1",
    cx: 4126.274,
    cy: 2016.329,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CDCD5D",
    cx: 4120.672,
    cy: 2005.335,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#23CFDD",
    cx: 4115.347,
    cy: 1994.884,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3FC31B",
    cx: 4110.292,
    cy: 1984.963,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A7D579",
    cx: 4105.469,
    cy: 1975.497,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#BFD1DF",
    cx: 4100.873,
    cy: 1966.477,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#995DB1",
    cx: 4096.505,
    cy: 1957.904,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8D41D1",
    cx: 4092.358,
    cy: 1949.766,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#61F95D",
    cx: 4088.397,
    cy: 1941.991,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#15D1BD",
    cx: 4084.63,
    cy: 1934.599,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C12183",
    cx: 4081.057,
    cy: 1927.585,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D52F79",
    cx: 4077.601,
    cy: 1920.803,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A505C5",
    cx: 4074.165,
    cy: 1914.059,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0DF947",
    cx: 4070.729,
    cy: 1907.317,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9FA74F",
    cx: 4067.298,
    cy: 1900.583,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9541A3",
    cx: 4063.862,
    cy: 1893.838,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6B311D",
    cx: 4060.428,
    cy: 1887.1,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#01FDC5",
    cx: 4056.992,
    cy: 1880.357,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8FF95F",
    cx: 4053.559,
    cy: 1873.618,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#957D7B",
    cx: 4050.122,
    cy: 1866.873,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8B7F1D",
    cx: 4046.69,
    cy: 1860.136,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5FF191",
    cx: 4043.255,
    cy: 1853.396,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D90DC3",
    cx: 4039.819,
    cy: 1846.651,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5377D5",
    cx: 4036.381,
    cy: 1839.905,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CD4791",
    cx: 4032.944,
    cy: 1833.159,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C741BB",
    cx: 4029.51,
    cy: 1826.418,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C93F37",
    cx: 4026.073,
    cy: 1819.674,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E519FD",
    cx: 4022.641,
    cy: 1812.939,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#97DBB3",
    cx: 4019.204,
    cy: 1806.193,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#95FBDD",
    cx: 4015.766,
    cy: 1799.445,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#93A349",
    cx: 4012.617,
    cy: 1793.264,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A14D6F",
    cx: 4735.398,
    cy: 3536.462,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#37A5FD",
    cx: 4703.597,
    cy: 3459.688,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#57BFEF",
    cx: 4672.553,
    cy: 3384.741,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2D4D73",
    cx: 4642.993,
    cy: 3313.375,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1D6B9D",
    cx: 4614.867,
    cy: 3245.474,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9D5D4F",
    cx: 4588.1,
    cy: 3180.853,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E3A191",
    cx: 4562.629,
    cy: 3119.361,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CF113F",
    cx: 4538.387,
    cy: 3060.834,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#53A96B",
    cx: 4515.314,
    cy: 3005.131,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5303F5",
    cx: 4493.36,
    cy: 2952.129,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#15DB5F",
    cx: 4472.483,
    cy: 2901.728,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#83D5F5",
    cx: 4452.615,
    cy: 2853.762,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#291DB7",
    cx: 4433.702,
    cy: 2808.102,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9977DF",
    cx: 4415.7,
    cy: 2764.642,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#711D89",
    cx: 4398.568,
    cy: 2723.283,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5FC3F1",
    cx: 4382.266,
    cy: 2683.925,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#232B7D",
    cx: 4366.751,
    cy: 2646.47,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#05419D",
    cx: 4351.99,
    cy: 2610.833,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#692941",
    cx: 4337.941,
    cy: 2576.915,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A709CB",
    cx: 4324.564,
    cy: 2544.621,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CB116B",
    cx: 4311.843,
    cy: 2513.91,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7EF27",
    cx: 4299.739,
    cy: 2484.688,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDEB23",
    cx: 4288.218,
    cy: 2456.874,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DB01A7",
    cx: 4277.258,
    cy: 2430.413,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C33F37",
    cx: 4266.826,
    cy: 2405.228,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DD1B9B",
    cx: 4256.897,
    cy: 2381.258,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#416529",
    cx: 4247.456,
    cy: 2358.464,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F3EF8D",
    cx: 4238.467,
    cy: 2336.763,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6105E3",
    cx: 4229.909,
    cy: 2316.104,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#47D541",
    cx: 4221.766,
    cy: 2296.445,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3317C7",
    cx: 4214.02,
    cy: 2277.743,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#792D19",
    cx: 4206.652,
    cy: 2259.957,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CFC5E1",
    cx: 4199.645,
    cy: 2243.039,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FDED03",
    cx: 4192.979,
    cy: 2226.946,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#33FDEF",
    cx: 4186.636,
    cy: 2211.633,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EB0BD5",
    cx: 4180.6,
    cy: 2197.06,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E79900",
    cx: 4174.853,
    cy: 2183.186,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9915B5",
    cx: 4169.381,
    cy: 2169.976,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E31571",
    cx: 4164.17,
    cy: 2157.395,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#17DB67",
    cx: 4159.208,
    cy: 2145.417,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D76933",
    cx: 4154.487,
    cy: 2134.018,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#078153",
    cx: 4149.998,
    cy: 2123.18,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AD6311",
    cx: 4145.737,
    cy: 2112.894,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#619FAB",
    cx: 4141.671,
    cy: 2103.079,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CFD577",
    cx: 4137.797,
    cy: 2093.725,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3D93C1",
    cx: 4134.115,
    cy: 2084.836,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#31DD21",
    cx: 4130.62,
    cy: 2076.398,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5D5DD5",
    cx: 4127.281,
    cy: 2068.336,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A35B03",
    cx: 4124.105,
    cy: 2060.671,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#758581",
    cx: 4121.093,
    cy: 2053.399,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ED093F",
    cx: 4118.18,
    cy: 2046.366,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1DC745",
    cx: 4115.284,
    cy: 2039.374,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E93177",
    cx: 4112.388,
    cy: 2032.383,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#373F03",
    cx: 4109.496,
    cy: 2025.4,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B3A3B5",
    cx: 4106.599,
    cy: 2018.407,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B2F65",
    cx: 4103.705,
    cy: 2011.42,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C7BB55",
    cx: 4100.809,
    cy: 2004.428,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#331D19",
    cx: 4097.915,
    cy: 1997.441,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CD4517",
    cx: 4095.018,
    cy: 1990.447,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F58FB5",
    cx: 4092.125,
    cy: 1983.462,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7FCF63",
    cx: 4089.229,
    cy: 1976.472,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#156D5D",
    cx: 4086.332,
    cy: 1969.478,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A77915",
    cx: 4083.435,
    cy: 1962.483,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6FFD91",
    cx: 4080.538,
    cy: 1955.489,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#831BD5",
    cx: 4077.643,
    cy: 1948.5,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#77F35D",
    cx: 4074.746,
    cy: 1941.506,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2F8177",
    cx: 4071.853,
    cy: 1934.523,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#354F53",
    cx: 4068.956,
    cy: 1927.528,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#47AB0F",
    cx: 4066.058,
    cy: 1920.531,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B5DDF",
    cx: 4063.403,
    cy: 1914.122,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#95ED67",
    cx: 4647.187,
    cy: 3708.653,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DBAB93",
    cx: 4621.508,
    cy: 3629.621,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#390F3D",
    cx: 4596.44,
    cy: 3552.47,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2BE523",
    cx: 4572.57,
    cy: 3479.004,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F5E30B",
    cx: 4549.858,
    cy: 3409.106,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B70DFD",
    cx: 4528.244,
    cy: 3342.583,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#85F7F1",
    cx: 4507.677,
    cy: 3279.284,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#675B05",
    cx: 4488.101,
    cy: 3219.034,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#83C1D7",
    cx: 4469.469,
    cy: 3161.693,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FD4341",
    cx: 4451.741,
    cy: 3107.133,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1959C3",
    cx: 4434.883,
    cy: 3055.249,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2F13EB",
    cx: 4418.84,
    cy: 3005.872,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9DA92B",
    cx: 4403.567,
    cy: 2958.868,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E14F29",
    cx: 4389.031,
    cy: 2914.129,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8F3977",
    cx: 4375.197,
    cy: 2871.554,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#296919",
    cx: 4362.033,
    cy: 2831.038,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6B3BC3",
    cx: 4349.505,
    cy: 2792.482,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6B0525",
    cx: 4337.585,
    cy: 2755.796,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#09F19D",
    cx: 4326.24,
    cy: 2720.881,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C337D5",
    cx: 4315.438,
    cy: 2687.636,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B3196B",
    cx: 4305.167,
    cy: 2656.022,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CD49D7",
    cx: 4295.393,
    cy: 2625.94,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CD6113",
    cx: 4286.089,
    cy: 2597.308,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D36729",
    cx: 4277.239,
    cy: 2570.069,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7DA7DB",
    cx: 4268.815,
    cy: 2544.143,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4FA3E1",
    cx: 4260.797,
    cy: 2519.468,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4F072B",
    cx: 4253.173,
    cy: 2496.003,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#410B77",
    cx: 4245.915,
    cy: 2473.664,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F13B63",
    cx: 4239.005,
    cy: 2452.397,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1DF963",
    cx: 4232.429,
    cy: 2432.16,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1FCB5B",
    cx: 4226.174,
    cy: 2412.909,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B73B05",
    cx: 4220.225,
    cy: 2394.598,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DF1F5D",
    cx: 4214.566,
    cy: 2377.183,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2FE72B",
    cx: 4209.184,
    cy: 2360.617,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C53BA3",
    cx: 4204.062,
    cy: 2344.853,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3F4FCD",
    cx: 4199.188,
    cy: 2329.852,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#839DC9",
    cx: 4194.547,
    cy: 2315.57,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#07B797",
    cx: 4190.128,
    cy: 2301.971,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#814963",
    cx: 4185.92,
    cy: 2289.02,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0FBD3F",
    cx: 4181.914,
    cy: 2276.689,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D1C949",
    cx: 4178.101,
    cy: 2264.955,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#55771B",
    cx: 4174.476,
    cy: 2253.798,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#93D943",
    cx: 4171.036,
    cy: 2243.209,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D61B3",
    cx: 4167.752,
    cy: 2233.106,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#471391",
    cx: 4164.624,
    cy: 2223.477,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#33C583",
    cx: 4161.651,
    cy: 2214.326,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#07FF85",
    cx: 4158.829,
    cy: 2205.64,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0563D1",
    cx: 4156.132,
    cy: 2197.341,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5F4131",
    cx: 4153.568,
    cy: 2189.45,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#59F571",
    cx: 4151.136,
    cy: 2181.965,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2F1725",
    cx: 4148.784,
    cy: 2174.725,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E9912B",
    cx: 4146.445,
    cy: 2167.527,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#95ADEF",
    cx: 4144.106,
    cy: 2160.33,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6D3B73",
    cx: 4141.771,
    cy: 2153.142,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F8DCF",
    cx: 4139.432,
    cy: 2145.943,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A18FB9",
    cx: 4137.095,
    cy: 2138.751,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A769C9",
    cx: 4134.756,
    cy: 2131.553,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AFC9DB",
    cx: 4132.419,
    cy: 2124.36,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EF25D1",
    cx: 4130.08,
    cy: 2117.161,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0177B9",
    cx: 4127.744,
    cy: 2109.97,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2FD375",
    cx: 4125.406,
    cy: 2102.775,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#338163",
    cx: 4123.066,
    cy: 2095.575,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A309D9",
    cx: 4120.727,
    cy: 2088.375,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#490D55",
    cx: 4118.387,
    cy: 2081.174,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ABE53B",
    cx: 4116.049,
    cy: 2073.979,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EFE797",
    cx: 4113.71,
    cy: 2066.781,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#833F19",
    cx: 4111.375,
    cy: 2059.592,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6BA7BB",
    cx: 4109.035,
    cy: 2052.391,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#717747",
    cx: 4106.694,
    cy: 2045.188,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79E50F",
    cx: 4104.551,
    cy: 2038.591,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#37119B",
    cx: 4545.739,
    cy: 3873.394,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D0BF5",
    cx: 4526.34,
    cy: 3792.591,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D7BF1D",
    cx: 4507.402,
    cy: 3713.711,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#89835B",
    cx: 4489.37,
    cy: 3638.599,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6BDF35",
    cx: 4472.212,
    cy: 3567.135,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#05E9F3",
    cx: 4455.884,
    cy: 3499.121,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F94B0F",
    cx: 4440.346,
    cy: 3434.402,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5521D1",
    cx: 4425.558,
    cy: 3372.803,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#558357",
    cx: 4411.483,
    cy: 3314.177,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F5DB93",
    cx: 4398.09,
    cy: 3258.393,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#55CD87",
    cx: 4385.355,
    cy: 3205.347,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5BC571",
    cx: 4373.235,
    cy: 3154.863,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E1ABA3",
    cx: 4361.698,
    cy: 3106.807,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#970DB3",
    cx: 4350.716,
    cy: 3061.065,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#019113",
    cx: 4340.266,
    cy: 3017.536,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#578993",
    cx: 4330.32,
    cy: 2976.111,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ADAF25",
    cx: 4320.856,
    cy: 2936.691,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8B5F5B",
    cx: 4311.852,
    cy: 2899.184,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7D49C3",
    cx: 4303.281,
    cy: 2863.485,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#67D10B",
    cx: 4295.121,
    cy: 2829.496,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F5C903",
    cx: 4287.361,
    cy: 2797.173,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#63F971",
    cx: 4279.978,
    cy: 2766.417,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2947E1",
    cx: 4272.949,
    cy: 2737.144,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#37A1EF",
    cx: 4266.263,
    cy: 2709.294,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6513C7",
    cx: 4259.899,
    cy: 2682.787,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0F5997",
    cx: 4253.843,
    cy: 2657.559,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B30B19",
    cx: 4248.083,
    cy: 2633.569,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5FC5BD",
    cx: 4242.6,
    cy: 2610.729,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6BF3ED",
    cx: 4237.379,
    cy: 2588.985,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#79AD53",
    cx: 4232.412,
    cy: 2568.294,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2D6395",
    cx: 4227.687,
    cy: 2548.612,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#732103",
    cx: 4223.192,
    cy: 2529.891,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F9B5D1",
    cx: 4218.917,
    cy: 2512.085,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#834503",
    cx: 4214.851,
    cy: 2495.148,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2B2F39",
    cx: 4210.982,
    cy: 2479.031,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3D153B",
    cx: 4207.3,
    cy: 2463.693,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#078927",
    cx: 4203.794,
    cy: 2449.092,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5DDB8D",
    cx: 4200.456,
    cy: 2435.188,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CDA167",
    cx: 4197.277,
    cy: 2421.947,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DD13C5",
    cx: 4194.25,
    cy: 2409.34,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#03A919",
    cx: 4191.37,
    cy: 2397.342,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1F2739",
    cx: 4188.632,
    cy: 2385.936,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1DA181",
    cx: 4186.033,
    cy: 2375.11,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3DC39D",
    cx: 4183.553,
    cy: 2364.779,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#353FA5",
    cx: 4181.189,
    cy: 2354.935,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#979B5F",
    cx: 4178.943,
    cy: 2345.579,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E155E9",
    cx: 4176.811,
    cy: 2336.698,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#591DEF",
    cx: 4174.774,
    cy: 2328.213,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C541FB",
    cx: 4172.837,
    cy: 2320.146,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CBB385",
    cx: 4171,
    cy: 2312.492,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A989F9",
    cx: 4169.223,
    cy: 2305.09,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B1FDC1",
    cx: 4167.456,
    cy: 2297.731,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3F35A7",
    cx: 4165.689,
    cy: 2290.373,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0F27A5",
    cx: 4163.925,
    cy: 2283.024,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AF7B51",
    cx: 4162.158,
    cy: 2275.664,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4F092B",
    cx: 4160.393,
    cy: 2268.31,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A30F83",
    cx: 4158.625,
    cy: 2260.951,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9957D5",
    cx: 4156.86,
    cy: 2253.597,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1DF7B7",
    cx: 4155.093,
    cy: 2246.236,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#498B71",
    cx: 4153.328,
    cy: 2238.884,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B5ABA3",
    cx: 4151.562,
    cy: 2231.528,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B3E701",
    cx: 4149.794,
    cy: 2224.167,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F3D32D",
    cx: 4148.027,
    cy: 2216.805,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2F0FF9",
    cx: 4146.26,
    cy: 2209.443,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E1EB1D",
    cx: 4144.494,
    cy: 2202.087,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C5BBAF",
    cx: 4142.727,
    cy: 2194.727,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#316185",
    cx: 4140.962,
    cy: 2187.377,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7F391D",
    cx: 4139.194,
    cy: 2180.015,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6B59CD",
    cx: 4137.426,
    cy: 2172.65,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F873D",
    cx: 4135.807,
    cy: 2165.906,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E3AF4D",
    cx: 4431.678,
    cy: 4029.667,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#714F11",
    cx: 4418.678,
    cy: 3947.591,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B98319",
    cx: 4405.988,
    cy: 3867.468,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ABE1D1",
    cx: 4393.904,
    cy: 3791.173,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5D11C7",
    cx: 4382.407,
    cy: 3718.583,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B789FB",
    cx: 4371.465,
    cy: 3649.498,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8D51C9",
    cx: 4361.053,
    cy: 3583.76,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0F5DC3",
    cx: 4351.143,
    cy: 3521.19,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#95A711",
    cx: 4341.711,
    cy: 3461.64,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#570BF3",
    cx: 4332.736,
    cy: 3404.978,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B1B183",
    cx: 4324.203,
    cy: 3351.096,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2FCFF1",
    cx: 4316.081,
    cy: 3299.817,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8DD7A9",
    cx: 4308.349,
    cy: 3251.003,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9DD123",
    cx: 4300.99,
    cy: 3204.541,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3D1757",
    cx: 4293.987,
    cy: 3160.326,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2F6187",
    cx: 4287.323,
    cy: 3118.249,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9DDD3B",
    cx: 4280.981,
    cy: 3078.208,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A3F719",
    cx: 4274.947,
    cy: 3040.11,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#45ADD7",
    cx: 4269.204,
    cy: 3003.849,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2B8535",
    cx: 4263.736,
    cy: 2969.324,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E1154B",
    cx: 4258.536,
    cy: 2936.492,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D3B1E7",
    cx: 4253.588,
    cy: 2905.252,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#87550F",
    cx: 4248.878,
    cy: 2875.517,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E32323",
    cx: 4244.397,
    cy: 2847.228,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#69DD13",
    cx: 4240.133,
    cy: 2820.304,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#672163",
    cx: 4236.075,
    cy: 2794.678,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FB1169",
    cx: 4232.215,
    cy: 2770.31,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AF21BB",
    cx: 4228.541,
    cy: 2747.11,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#696BEB",
    cx: 4225.042,
    cy: 2725.024,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#15F597",
    cx: 4221.714,
    cy: 2704.007,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6B756D",
    cx: 4218.547,
    cy: 2684.015,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B8D83",
    cx: 4215.535,
    cy: 2664.999,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C12D07",
    cx: 4212.671,
    cy: 2646.913,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8FF1E3",
    cx: 4209.946,
    cy: 2629.708,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1DED27",
    cx: 4207.353,
    cy: 2613.338,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3BCD21",
    cx: 4204.886,
    cy: 2597.759,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3F757F",
    cx: 4202.537,
    cy: 2582.927,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9D6129",
    cx: 4200.299,
    cy: 2568.804,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D70109",
    cx: 4198.169,
    cy: 2555.354,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#835585",
    cx: 4196.141,
    cy: 2542.549,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7171E3",
    cx: 4194.211,
    cy: 2530.362,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#832503",
    cx: 4192.376,
    cy: 2518.776,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0D8343",
    cx: 4190.634,
    cy: 2507.779,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#576383",
    cx: 4188.972,
    cy: 2497.286,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#899B3F",
    cx: 4187.389,
    cy: 2487.287,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#552721",
    cx: 4185.883,
    cy: 2477.784,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A92B13",
    cx: 4184.455,
    cy: 2468.762,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#193D83",
    cx: 4183.089,
    cy: 2460.144,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#954BDD",
    cx: 4181.792,
    cy: 2451.95,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A3A3B9",
    cx: 4180.561,
    cy: 2444.176,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A9AF35",
    cx: 4179.37,
    cy: 2436.657,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#618BE1",
    cx: 4178.186,
    cy: 2429.182,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#55EBD3",
    cx: 4177.002,
    cy: 2421.708,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2701B5",
    cx: 4175.819,
    cy: 2414.243,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B1F147",
    cx: 4174.635,
    cy: 2406.767,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1519D3",
    cx: 4173.452,
    cy: 2399.297,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#658391",
    cx: 4172.269,
    cy: 2391.822,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0F8F7F",
    cx: 4171.085,
    cy: 2384.352,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EDB357",
    cx: 4169.901,
    cy: 2376.875,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#413947",
    cx: 4168.718,
    cy: 2369.408,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A519AD",
    cx: 4167.535,
    cy: 2361.936,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D95745",
    cx: 4166.351,
    cy: 2354.459,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#51EDEF",
    cx: 4165.166,
    cy: 2346.98,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A5AB3B",
    cx: 4163.982,
    cy: 2339.503,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8B0781",
    cx: 4162.798,
    cy: 2332.031,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#09C53D",
    cx: 4161.614,
    cy: 2324.555,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#25090D",
    cx: 4160.432,
    cy: 2317.089,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8F9D19",
    cx: 4159.248,
    cy: 2309.611,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EFEBBB",
    cx: 4158.063,
    cy: 2302.13,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#177587",
    cx: 4156.978,
    cy: 2295.279,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D39EB",
    cx: 4305.706,
    cy: 4176.51,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0DC519",
    cx: 4299.186,
    cy: 4093.667,
    r: 37.701
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#31694D",
    cx: 4292.821,
    cy: 4012.795,
    r: 35.92
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#61ED77",
    cx: 4286.761,
    cy: 3935.787,
    r: 34.182
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#572939",
    cx: 4280.994,
    cy: 3862.518,
    r: 32.527
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8183CF",
    cx: 4275.506,
    cy: 3792.788,
    r: 30.953
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#93351F",
    cx: 4270.284,
    cy: 3726.436,
    r: 29.454
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F67A3",
    cx: 4265.314,
    cy: 3663.281,
    r: 28.028
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D3655B",
    cx: 4260.583,
    cy: 3603.175,
    r: 26.671
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6145A3",
    cx: 4256.083,
    cy: 3545.983,
    r: 25.379
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F13B51",
    cx: 4251.802,
    cy: 3491.597,
    r: 24.15
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9F7BBF",
    cx: 4247.729,
    cy: 3439.839,
    r: 22.981
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E1DD79",
    cx: 4243.851,
    cy: 3390.57,
    r: 21.869
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#35FDD5",
    cx: 4240.16,
    cy: 3343.673,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E503CB",
    cx: 4236.648,
    cy: 3299.045,
    r: 19.802
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6BED5F",
    cx: 4233.306,
    cy: 3256.575,
    r: 18.843
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DB1FE7",
    cx: 4230.125,
    cy: 3216.159,
    r: 17.93
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#431F7F",
    cx: 4227.098,
    cy: 3177.705,
    r: 17.062
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#07EB01",
    cx: 4224.218,
    cy: 3141.106,
    r: 16.235
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A12F39",
    cx: 4221.476,
    cy: 3106.259,
    r: 15.449
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B5078D",
    cx: 4218.867,
    cy: 3073.119,
    r: 14.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C54FC3",
    cx: 4216.386,
    cy: 3041.587,
    r: 13.987
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D7C75D",
    cx: 4214.023,
    cy: 3011.575,
    r: 13.31
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A12745",
    cx: 4211.776,
    cy: 2983.021,
    r: 12.665
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#25152B",
    cx: 4209.638,
    cy: 2955.846,
    r: 12.051
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#235D69",
    cx: 4207.602,
    cy: 2929.981,
    r: 11.467
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5BBD2F",
    cx: 4205.667,
    cy: 2905.385,
    r: 10.911
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#231193",
    cx: 4203.823,
    cy: 2881.968,
    r: 10.382
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#697163",
    cx: 4202.069,
    cy: 2859.676,
    r: 9.879
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3519DB",
    cx: 4200.399,
    cy: 2838.462,
    r: 9.4
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8FB969",
    cx: 4198.811,
    cy: 2818.283,
    r: 8.944
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#752757",
    cx: 4197.301,
    cy: 2799.09,
    r: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9599F1",
    cx: 4195.864,
    cy: 2780.835,
    r: 8.098
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#7FD93B",
    cx: 4194.498,
    cy: 2763.469,
    r: 7.705
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#05C13F",
    cx: 4193.197,
    cy: 2746.946,
    r: 7.331
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#95C5E9",
    cx: 4191.959,
    cy: 2731.221,
    r: 6.976
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#259943",
    cx: 4190.781,
    cy: 2716.251,
    r: 6.637
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#796B8F",
    cx: 4189.659,
    cy: 2701.996,
    r: 6.315
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B5F59",
    cx: 4188.591,
    cy: 2688.421,
    r: 6.009
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#5B65F1",
    cx: 4187.574,
    cy: 2675.495,
    r: 5.717
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#91C321",
    cx: 4186.605,
    cy: 2663.195,
    r: 5.439
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C5FD63",
    cx: 4185.685,
    cy: 2651.5,
    r: 5.175
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DFBFC3",
    cx: 4184.812,
    cy: 2640.401,
    r: 4.924
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#99130D",
    cx: 4183.978,
    cy: 2629.81,
    r: 4.685
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B9618F",
    cx: 4183.184,
    cy: 2619.717,
    r: 4.457
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#77550F",
    cx: 4182.429,
    cy: 2610.125,
    r: 4.24
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C1C71B",
    cx: 4181.712,
    cy: 2601.02,
    r: 4.035
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#35FBB1",
    cx: 4181.028,
    cy: 2592.321,
    r: 3.839
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AFD563",
    cx: 4180.376,
    cy: 2584.05,
    r: 3.652
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#AF7B79",
    cx: 4179.759,
    cy: 2576.203,
    r: 3.475
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DD5725",
    cx: 4179.162,
    cy: 2568.614,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0B5D9F",
    cx: 4178.568,
    cy: 2561.069,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#67ED05",
    cx: 4177.974,
    cy: 2553.525,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#01A9DF",
    cx: 4177.381,
    cy: 2545.99,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#9DF33D",
    cx: 4176.788,
    cy: 2538.445,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B9F16B",
    cx: 4176.194,
    cy: 2530.905,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#99F331",
    cx: 4175.6,
    cy: 2523.36,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#93E9DD",
    cx: 4175.007,
    cy: 2515.821,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#058331",
    cx: 4174.413,
    cy: 2508.274,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F9FF7F",
    cx: 4173.82,
    cy: 2500.737,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F9AD8F",
    cx: 4173.226,
    cy: 2493.195,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#216559",
    cx: 4172.632,
    cy: 2485.648,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#B77FDB",
    cx: 4172.038,
    cy: 2478.1,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#CF0D2F",
    cx: 4171.444,
    cy: 2470.552,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#A38DC7",
    cx: 4170.851,
    cy: 2463.01,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#57ED8B",
    cx: 4170.257,
    cy: 2455.464,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#6D1573",
    cx: 4169.664,
    cy: 2447.929,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3B256D",
    cx: 4169.07,
    cy: 2440.381,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F9D1B1",
    cx: 4168.476,
    cy: 2432.83,
    r: 3.427
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3F2301",
    cx: 4167.931,
    cy: 2425.916,
    r: 3.427
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirection);
export default __webpack_public_path__ + "static/media/direction.a5d454eaa8c27b481e0bf158553b1039.svg";
export { ForwardRef as ReactComponent };